// // // // // // import {
// // // // // //   collection,
// // // // // //   addDoc,
// // // // // //   getDocs,
// // // // // //   doc,
// // // // // //   setDoc,
// // // // // //   getDoc,
// // // // // //   serverTimestamp,
// // // // // //   query,
// // // // // //   where,
// // // // // //   orderBy,
// // // // // //   limit,
// // // // // //   increment,
// // // // // // } from "firebase/firestore";
// // // // // // import { db } from "./firebase";
// // // // // // import servicesConfig from "./servicesConfig";

// // // // // // // ─────────────────────────────────────────────
// // // // // // // TRACKING HELPERS
// // // // // // // ─────────────────────────────────────────────

// // // // // // /**
// // // // // //  * Write a tracking event to users/{uid}/events subcollection.
// // // // // //  * Never throws — tracking must never break the main flow.
// // // // // //  */
// // // // // // async function trackEvent(userId, eventName, data = {}) {
// // // // // //   if (!userId) return;
// // // // // //   try {
// // // // // //     await addDoc(collection(db, "users", userId, "events"), {
// // // // // //       event:     eventName,
// // // // // //       ...data,
// // // // // //       timestamp: serverTimestamp(),
// // // // // //     });
// // // // // //   } catch (err) {
// // // // // //     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Increment a counter on the user's top-level document.
// // // // // //  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
// // // // // //  */
// // // // // // async function incrementUserStat(userId, field, by = 1) {
// // // // // //   if (!userId) return;
// // // // // //   try {
// // // // // //     await setDoc(
// // // // // //       doc(db, "users", userId),
// // // // // //       { [field]: increment(by) },
// // // // // //       { merge: true }
// // // // // //     );
// // // // // //   } catch (err) {
// // // // // //     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
// // // // // //   }
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // TRANSACTIONS
// // // // // // // ─────────────────────────────────────────────

// // // // // // /**
// // // // // //  * Save a new verified transaction after Stripe payment succeeds.
// // // // // //  * Deduplicates by paymentIntentId — safe to call multiple times.
// // // // // //  */
// // // // // // export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null) {
// // // // // //   try {
// // // // // //     // ── Deduplicate: don't create a second record for the same payment ──
// // // // // //     const existing = await getDocs(
// // // // // //       query(
// // // // // //         collection(db, "users", userId, "transactions"),
// // // // // //         where("paymentIntentId", "==", paymentIntentId)
// // // // // //       )
// // // // // //     );
// // // // // //     if (!existing.empty) {
// // // // // //       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
// // // // // //       return existing.docs[0].id;
// // // // // //     }

// // // // // //     // ── Default includes to planId if not provided ──
// // // // // //     const serviceIncludes = includes || [planId];

// // // // // //     // Get plan limits from config
// // // // // //     const limits = getPlanLimits(planId);

// // // // // //     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
// // // // // //       paymentIntentId,
// // // // // //       planId,
// // // // // //       includes:          serviceIncludes,
// // // // // //       status:            "paid",
// // // // // //       analysed:          false,
// // // // // //       analysisUsedCount: 0,
// // // // // //       analysisCount:     limits.analysisCount,
// // // // // //       resumeGenerated:   false,
// // // // // //       resumeGenCount:    limits.resumeGenCount,
// // // // // //       createdAt:         serverTimestamp(),
// // // // // //     });

// // // // // //     // ── Track payment event ──
// // // // // //     await trackEvent(userId, "payment_completed", {
// // // // // //       paymentIntentId,
// // // // // //       planId,
// // // // // //       includes:      serviceIncludes,
// // // // // //       transactionId: ref.id,
// // // // // //     });

// // // // // //     // ── Increment user payment counter ──
// // // // // //     await incrementUserStat(userId, "totalPayments");

// // // // // //     // ── Update user last paid timestamp ──
// // // // // //     await setDoc(
// // // // // //       doc(db, "users", userId),
// // // // // //       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
// // // // // //       { merge: true }
// // // // // //     );

// // // // // //     console.log("✅ Transaction saved:", ref.id);
// // // // // //     return ref.id;

// // // // // //   } catch (err) {
// // // // // //     console.error("❌ saveTransaction error:", err);
// // // // // //     throw err;
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Mark a transaction as analysed (analysis complete).
// // // // // //  */
// // // // // // export async function markTransactionComplete(userId, transactionId) {
// // // // // //   if (!userId || !transactionId) {
// // // // // //     console.error("❌ markTransactionComplete: missing params");
// // // // // //     return;
// // // // // //   }
// // // // // //   try {
// // // // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // // // //     const snap = await getDoc(ref);
// // // // // //     if (!snap.exists()) {
// // // // // //       console.error("❌ Transaction not found:", transactionId);
// // // // // //       return;
// // // // // //     }

// // // // // //     const data        = snap.data();
// // // // // //     const newCount    = (data.analysisUsedCount || 0) + 1;
// // // // // //     // Always read limit from config — don't trust stale Firebase value
// // // // // //     const planLimits  = getPlanLimits(data.planId);
// // // // // //     const maxCount    = planLimits.analysisCount;
// // // // // //     const analysedAll = newCount >= maxCount;

// // // // // //     await setDoc(ref, {
// // // // // //       status:            "paid",
// // // // // //       analysed:          true,
// // // // // //       completedAt:       serverTimestamp(),
// // // // // //       analysisUsedCount: newCount,
// // // // // //       analysisCount:     maxCount,      // patch it in case it was missing
// // // // // //       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
// // // // // //       analysedAll,
// // // // // //     }, { merge: true });

// // // // // //     // ── Track analysis completion event ──
// // // // // //     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

// // // // // //     // ── Increment user analysis counter ──
// // // // // //     await incrementUserStat(userId, "totalAnalyses");

// // // // // //     // ── Update user last analysed timestamp ──
// // // // // //     await setDoc(
// // // // // //       doc(db, "users", userId),
// // // // // //       { lastAnalysisAt: serverTimestamp() },
// // // // // //       { merge: true }
// // // // // //     );

// // // // // //     console.log("✅ Transaction marked complete:", transactionId);

// // // // // //   } catch (err) {
// // // // // //     console.error("❌ markTransactionComplete error:", err.message);
// // // // // //     throw err;
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Mark resume as generated for a transaction.
// // // // // //  */
// // // // // // export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
// // // // // //   if (!userId || !transactionId) {
// // // // // //     console.error("❌ markResumeGenerated: missing params");
// // // // // //     return;
// // // // // //   }
// // // // // //   try {
// // // // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // // // //     await setDoc(ref, {
// // // // // //       resumeGenerated:    true,
// // // // // //       resumeGeneratedAt:  serverTimestamp(),
// // // // // //       resumeTemplateId:   templateId,   // ← track which template was used
// // // // // //     }, { merge: true });

// // // // // //     // ── Track resume generation event with template ──
// // // // // //     await trackEvent(userId, "resume_generated", {
// // // // // //       transactionId,
// // // // // //       templateId,
// // // // // //     });

// // // // // //     // ── Increment user resume counter ──
// // // // // //     await incrementUserStat(userId, "totalResumesGenerated");

// // // // // //     // ── Update user last resume timestamp + template ──
// // // // // //     await setDoc(
// // // // // //       doc(db, "users", userId),
// // // // // //       {
// // // // // //         lastResumeGeneratedAt: serverTimestamp(),
// // // // // //         lastResumeTemplateId:  templateId,
// // // // // //       },
// // // // // //       { merge: true }
// // // // // //     );

// // // // // //     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

// // // // // //   } catch (err) {
// // // // // //     console.error("❌ markResumeGenerated error:", err);
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Get pending transaction — paid but NOT yet analysed.
// // // // // //  */
// // // // // // export async function getPendingTransaction(userId) {
// // // // // //   try {
// // // // // //     const snapshot = await getDocs(
// // // // // //       collection(db, "users", userId, "transactions")
// // // // // //     );
// // // // // //     if (snapshot.empty) return null;

// // // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // // //     const pending = all
// // // // // //       .filter(t => t.status === "paid" && t.analysed === false)
// // // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // // //     if (pending.length === 0) return null;

// // // // // //     console.log("✅ Pending transaction found:", pending[0].id);
// // // // // //     return pending[0];

// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getPendingTransaction error:", err);
// // // // // //     return null;
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Get most recent completed transaction — paid AND analysed.
// // // // // //  */
// // // // // // export async function getCompletedTransaction(userId) {
// // // // // //   try {
// // // // // //     const snapshot = await getDocs(
// // // // // //       collection(db, "users", userId, "transactions")
// // // // // //     );
// // // // // //     if (snapshot.empty) return null;

// // // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // // //     const completed = all
// // // // // //       .filter(t => t.status === "paid" && t.analysed === true)
// // // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // // //     if (completed.length === 0) return null;

// // // // // //     console.log("✅ Completed transaction found:", completed[0].id);
// // // // // //     return completed[0];

// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getCompletedTransaction error:", err);
// // // // // //     return null;
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Get all transactions for a user (most recent first, max 50).
// // // // // //  */
// // // // // // export async function getAllTransactions(userId) {
// // // // // //   try {
// // // // // //     const snapshot = await getDocs(
// // // // // //       collection(db, "users", userId, "transactions")
// // // // // //     );
// // // // // //     if (snapshot.empty) return [];
// // // // // //     return snapshot.docs
// // // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // // // //       .slice(0, 50);
// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getAllTransactions error:", err);
// // // // // //     return [];
// // // // // //   }
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // ANALYSES
// // // // // // // ─────────────────────────────────────────────

// // // // // // /**
// // // // // //  * Get most recent analysis for a user.
// // // // // //  */
// // // // // // export async function getLastAnalysis(userId) {
// // // // // //   try {
// // // // // //     const snapshot = await getDocs(
// // // // // //       collection(db, "users", userId, "analyses")
// // // // // //     );
// // // // // //     if (snapshot.empty) return null;

// // // // // //     const sorted = snapshot.docs
// // // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // // //     console.log("✅ Last analysis found");
// // // // // //     return sorted[0];

// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getLastAnalysis error:", err);
// // // // // //     return null;
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Get all analyses for a user (most recent first, max 20).
// // // // // //  */
// // // // // // export async function getAllAnalyses(userId) {
// // // // // //   try {
// // // // // //     const snapshot = await getDocs(
// // // // // //       collection(db, "users", userId, "analyses")
// // // // // //     );
// // // // // //     if (snapshot.empty) return [];

// // // // // //     return snapshot.docs
// // // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // // // //       .slice(0, 20);

// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getAllAnalyses error:", err);
// // // // // //     return [];
// // // // // //   }
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // GENERATED RESUMES
// // // // // // // ─────────────────────────────────────────────

// // // // // // /**
// // // // // //  * Check if user is eligible for free resume generation.
// // // // // //  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
// // // // // //  */
// // // // // // export async function getFreeResumeEligibility(userId) {
// // // // // //   try {
// // // // // //     const snapshot = await getDocs(
// // // // // //       collection(db, "users", userId, "transactions")
// // // // // //     );
// // // // // //     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

// // // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

// // // // // //     // All paid transactions sorted newest first
// // // // // //     const paidTransactions = all
// // // // // //       .filter(t => t.status === "paid")
// // // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // // //     if (paidTransactions.length === 0) {
// // // // // //       return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // // // //     }

// // // // // //     // Always use the most recent paid plan for template access
// // // // // //     const mostRecentPlan = paidTransactions[0].planId || "ats_basic";
// // // // // //     const mostRecentIncludes = paidTransactions[0].includes || [];

// // // // // //     // Find any analysed transaction where resume has NOT been generated yet
// // // // // //     // Resume unlock: user must have done at least 1 analysis
// // // // // //     const unusedAnalysis = all
// // // // // //       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
// // // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // // //     if (unusedAnalysis.length === 0) {
// // // // // //       // No eligible transaction — but still return planId so templates show correctly
// // // // // //       console.log("No unused analysis found");
// // // // // //       return {
// // // // // //         eligible:      false,
// // // // // //         transactionId: null,
// // // // // //         planId:        mostRecentPlan,
// // // // // //         includes:      mostRecentIncludes,
// // // // // //       };
// // // // // //     }

// // // // // //     // Use the most recent unused analysis transaction
// // // // // //     const eligible = unusedAnalysis[0];
// // // // // //     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
// // // // // //     return {
// // // // // //       eligible:      true,
// // // // // //       transactionId: eligible.id,
// // // // // //       planId:        eligible.planId || mostRecentPlan,
// // // // // //       includes:      eligible.includes || mostRecentIncludes,
// // // // // //     };

// // // // // //   } catch (err) {
// // // // // //     console.error("getFreeResumeEligibility error:", err);
// // // // // //     return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // // // //   }
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // PLAN LIMITS — reads from servicesConfig
// // // // // // // ─────────────────────────────────────────────

// // // // // // export function getPlanLimits(planId) {
// // // // // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // // // // //   const limits = {
// // // // // //     analysisCount:  plan?.analysisCount  ?? 2,  // default 2 if not found
// // // // // //     resumeGenCount: plan?.resumeGenCount ?? 1,
// // // // // //   };
// // // // // //   console.log(`📊 getPlanLimits(${planId}):`, limits);
// // // // // //   return limits;
// // // // // // }

// // // // // // /**
// // // // // //  * Get full usage status for a transaction.
// // // // // //  * Used by dashboard to show analysis counter + generate button state.
// // // // // //  */
// // // // // // export async function getTransactionUsage(userId, transactionId) {
// // // // // //   if (!userId || !transactionId) return null;
// // // // // //   try {
// // // // // //     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
// // // // // //     if (!snap.exists()) return null;
// // // // // //     const data    = snap.data();
// // // // // //     const used   = data.analysisUsedCount || 0;
// // // // // //     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
// // // // // //     const limits = getPlanLimits(data.planId);
// // // // // //     const max    = limits.analysisCount;  // authoritative from config
// // // // // //     const resumeGenerated = data.resumeGenerated || false;
// // // // // //     // Once resume is generated — NO more analyses allowed for this transaction
// // // // // //     // User must pay again for new analyses
// // // // // //     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
// // // // // //     const canAnalyzeAgain   = !resumeGenerated && used < max;
// // // // // //     // canGenerateResume: true after at least 1 analysis, even if more analyses remain
// // // // // //     // User can choose to generate anytime after first analysis
// // // // // //     const canGenerateResume = used > 0 && !resumeGenerated;
// // // // // //     return {
// // // // // //       transactionId,
// // // // // //       planId:            data.planId,
// // // // // //       analysisUsedCount: used,
// // // // // //       analysisCount:     max,
// // // // // //       analysisRemaining: resumeGenerated ? 0 : Math.max(0, max - used),
// // // // // //       canAnalyzeAgain,
// // // // // //       resumeGenerated,
// // // // // //       resumeGenCount:    limits.resumeGenCount,
// // // // // //       canGenerateResume,
// // // // // //       resumeTemplateId:  data.resumeTemplateId || null,
// // // // // //       // Analyses list for selection modal
// // // // // //       analyses:          [],  // populated separately
// // // // // //     };
// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getTransactionUsage error:", err);
// // // // // //     return null;
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Get all paid transaction usages for a user.
// // // // // //  */
// // // // // // export async function getAllTransactionUsages(userId) {
// // // // // //   if (!userId) return [];
// // // // // //   try {
// // // // // //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// // // // // //     return snap.docs
// // // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // // //       .filter(t => t.status === "paid" || t.status === "completed")
// // // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getAllTransactionUsages error:", err);
// // // // // //     return [];
// // // // // //   }
// // // // // // }

// // // // // // export async function saveGeneratedResume(userId, transactionId, resumeData) {
// // // // // //   try {
// // // // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // // // //     await setDoc(ref, {
// // // // // //       resumeData,
// // // // // //       transactionId,
// // // // // //       createdAt: serverTimestamp(),
// // // // // //     });
// // // // // //     console.log("✅ Generated resume saved:", transactionId);
// // // // // //   } catch (err) {
// // // // // //     console.error("❌ saveGeneratedResume error:", err);
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Get a saved generated resume by transactionId.
// // // // // //  */
// // // // // // export async function getGeneratedResume(userId, transactionId) {
// // // // // //   try {
// // // // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // // // //     const snap = await getDoc(ref);
// // // // // //     if (snap.exists()) {
// // // // // //       console.log("✅ Generated resume found");
// // // // // //       return snap.data().resumeData;
// // // // // //     }
// // // // // //     return null;
// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getGeneratedResume error:", err);
// // // // // //     return null;
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Get the latest generated resume for a user.
// // // // // //  */
// // // // // // export async function getLatestGeneratedResume(userId) {
// // // // // //   try {
// // // // // //     const snapshot = await getDocs(
// // // // // //       collection(db, "users", userId, "generatedResumes")
// // // // // //     );
// // // // // //     if (snapshot.empty) return null;

// // // // // //     const sorted = snapshot.docs
// // // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // // //     console.log("✅ Latest generated resume found");
// // // // // //     return sorted[0]?.resumeData || null;

// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getLatestGeneratedResume error:", err);
// // // // // //     return null;
// // // // // //   }
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // SERVICE ACCESS
// // // // // // // ─────────────────────────────────────────────

// // // // // // /**
// // // // // //  * Check if user has access to a specific service from any of their transactions.
// // // // // //  * Works for single services AND bundles.
// // // // // //  */
// // // // // // export async function hasServiceAccess(userId, serviceCode) {
// // // // // //   try {
// // // // // //     const snapshot = await getDocs(
// // // // // //       collection(db, "users", userId, "transactions")
// // // // // //     );
// // // // // //     if (snapshot.empty) return false;

// // // // // //     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // // //     return transactions.some(t => {
// // // // // //       if (t.status !== "paid") return false;
// // // // // //       // Direct service match
// // // // // //       if (t.serviceCode === serviceCode) return true;
// // // // // //       // Bundle match — check includes array
// // // // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // // // //       return false;
// // // // // //     });
// // // // // //   } catch (err) {
// // // // // //     console.error("❌ hasServiceAccess error:", err);
// // // // // //     return false;
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Get pending transaction for a specific service.
// // // // // //  * Works for both direct service and bundle.
// // // // // //  */
// // // // // // export async function getPendingTransactionForService(userId, serviceCode) {
// // // // // //   try {
// // // // // //     const snapshot = await getDocs(
// // // // // //       collection(db, "users", userId, "transactions")
// // // // // //     );
// // // // // //     if (snapshot.empty) return null;

// // // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // // //     const pending = all.filter(t => {
// // // // // //       if (t.status !== "paid" || t.analysed !== false) return false;
// // // // // //       if (t.serviceCode === serviceCode) return true;
// // // // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // // // //       return false;
// // // // // //     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // // //     return pending[0] || null;
// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getPendingTransactionForService error:", err);
// // // // // //     return null;
// // // // // //   }
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // SUPPORT TICKETS
// // // // // // // ─────────────────────────────────────────────

// // // // // // /**
// // // // // //  * Save a support ticket.
// // // // // //  */
// // // // // // export async function saveSupportTicket(userId, ticketData) {
// // // // // //   try {
// // // // // //     const ref = await addDoc(collection(db, "supportTickets"), {
// // // // // //       userId:    userId || null,
// // // // // //       firstName: ticketData.firstName,
// // // // // //       lastName:  ticketData.lastName,
// // // // // //       email:     ticketData.email,
// // // // // //       topic:     ticketData.topic,
// // // // // //       message:   ticketData.message,
// // // // // //       status:    "open",
// // // // // //       createdAt: serverTimestamp(),
// // // // // //       updatedAt: serverTimestamp(),
// // // // // //       date:      new Date().toISOString().split("T")[0],
// // // // // //     });

// // // // // //     // ── Track support ticket event ──
// // // // // //     if (userId) {
// // // // // //       await trackEvent(userId, "support_ticket_created", {
// // // // // //         ticketId: ref.id,
// // // // // //         topic:    ticketData.topic,
// // // // // //       });
// // // // // //     }

// // // // // //     console.log("✅ Support ticket saved:", ref.id);
// // // // // //     return ref.id;

// // // // // //   } catch (err) {
// // // // // //     console.error("❌ saveSupportTicket error:", err);
// // // // // //     return null;
// // // // // //   }
// // // // // // }

// // // // // // /**
// // // // // //  * Get all support tickets for a user.
// // // // // //  * Uses a proper Firestore query instead of fetching all and filtering client-side.
// // // // // //  */
// // // // // // export async function getUserSupportTickets(userId) {
// // // // // //   try {
// // // // // //     const q = query(
// // // // // //       collection(db, "supportTickets"),
// // // // // //       where("userId", "==", userId),
// // // // // //       orderBy("createdAt", "desc"),
// // // // // //       limit(50)
// // // // // //     );
// // // // // //     const snapshot = await getDocs(q);
// // // // // //     if (snapshot.empty) return [];
// // // // // //     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // // //   } catch (err) {
// // // // // //     console.error("❌ getUserSupportTickets error:", err);
// // // // // //     return [];
// // // // // //   }
// // // // // // }

// // // // // // // ─────────────────────────────────────────────
// // // // // // // SESSION / PAGE TRACKING
// // // // // // // ─────────────────────────────────────────────

// // // // // // /**
// // // // // //  * Track a page view or dashboard step visit.
// // // // // //  * Call this from key screens: dashboard intro, upload, results, etc.
// // // // // //  */
// // // // // // export async function trackPageView(userId, page, extra = {}) {
// // // // // //   await trackEvent(userId, "page_view", { page, ...extra });
// // // // // // }

// // // // // // /**
// // // // // //  * Track a user action (button clicks, downloads, etc.)
// // // // // //  */
// // // // // // export async function trackUserAction(userId, action, extra = {}) {
// // // // // //   await trackEvent(userId, action, extra);
// // // // // // }

// // // // // // /**
// // // // // //  * Track analysis start — called when user clicks "Analyze My Resume".
// // // // // //  */
// // // // // // export async function trackAnalysisStart(userId, transactionId) {
// // // // // //   await trackEvent(userId, "analysis_started", { transactionId });
// // // // // //   await setDoc(
// // // // // //     doc(db, "users", userId),
// // // // // //     { lastActivityAt: serverTimestamp() },
// // // // // //     { merge: true }
// // // // // //   );
// // // // // // }

// // // // // // /**
// // // // // //  * Track analysis failure so you can investigate in Firebase console.
// // // // // //  */
// // // // // // export async function trackAnalysisError(userId, transactionId, errorMessage) {
// // // // // //   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// // // // // // }

// // // // // // /**
// // // // // //  * Track report download.
// // // // // //  */
// // // // // // export async function trackReportDownload(userId, analysisId) {
// // // // // //   await trackEvent(userId, "report_downloaded", { analysisId });
// // // // // //   await incrementUserStat(userId, "totalDownloads");
// // // // // // }

// // // // // // /**
// // // // // //  * Track service card click on dashboard intro.
// // // // // //  */
// // // // // // export async function trackServiceClick(userId, serviceCode) {
// // // // // //   await trackEvent(userId, "service_selected", { serviceCode });
// // // // // // }

// // // // // // /**
// // // // // //  * Track payment modal opened.
// // // // // //  */
// // // // // // export async function trackPaymentModalOpened(userId, serviceCode) {
// // // // // //   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// // // // // // }

// // // // // // /**
// // // // // //  * Track payment failure.
// // // // // //  */
// // // // // // export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
// // // // // //   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// // // // // // }

// // // // // import {
// // // // //   collection,
// // // // //   addDoc,
// // // // //   getDocs,
// // // // //   doc,
// // // // //   setDoc,
// // // // //   getDoc,
// // // // //   serverTimestamp,
// // // // //   query,
// // // // //   where,
// // // // //   orderBy,
// // // // //   limit,
// // // // //   increment,
// // // // // } from "firebase/firestore";
// // // // // import { db } from "./firebase";
// // // // // import servicesConfig from "./servicesConfig";

// // // // // // ─────────────────────────────────────────────
// // // // // // TRACKING HELPERS
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Write a tracking event to users/{uid}/events subcollection.
// // // // //  * Never throws — tracking must never break the main flow.
// // // // //  */
// // // // // async function trackEvent(userId, eventName, data = {}) {
// // // // //   if (!userId) return;
// // // // //   try {
// // // // //     await addDoc(collection(db, "users", userId, "events"), {
// // // // //       event:     eventName,
// // // // //       ...data,
// // // // //       timestamp: serverTimestamp(),
// // // // //     });
// // // // //   } catch (err) {
// // // // //     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Increment a counter on the user's top-level document.
// // // // //  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
// // // // //  */
// // // // // async function incrementUserStat(userId, field, by = 1) {
// // // // //   if (!userId) return;
// // // // //   try {
// // // // //     await setDoc(
// // // // //       doc(db, "users", userId),
// // // // //       { [field]: increment(by) },
// // // // //       { merge: true }
// // // // //     );
// // // // //   } catch (err) {
// // // // //     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // TRANSACTIONS
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Save a new verified transaction after Stripe payment succeeds.
// // // // //  * Deduplicates by paymentIntentId — safe to call multiple times.
// // // // //  */
// // // // // export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
// // // // //   try {
// // // // //     // ── Deduplicate: don't create a second record for the same payment ──
// // // // //     const existing = await getDocs(
// // // // //       query(
// // // // //         collection(db, "users", userId, "transactions"),
// // // // //         where("paymentIntentId", "==", paymentIntentId)
// // // // //       )
// // // // //     );
// // // // //     if (!existing.empty) {
// // // // //       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
// // // // //       return existing.docs[0].id;
// // // // //     }

// // // // //     // ── Default includes to planId if not provided ──
// // // // //     const serviceIncludes = includes || [planId];

// // // // //     // Get plan limits from config
// // // // //     const limits = getPlanLimits(planId);

// // // // //     // ── Snapshot plan name from config at time of purchase ──
// // // // //     const planConfig = servicesConfig.plans.find(p => p.id === planId);

// // // // //     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
// // // // //       paymentIntentId,
// // // // //       planId,
// // // // //       planName:          paymentMeta.planName  || planConfig?.name  || planId,
// // // // //       // Price frozen at payment time — never re-read from config
// // // // //       amountPaid:        paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,  // cents
// // // // //       amountDisplay:     paymentMeta.amountDisplay ?? planConfig?.price         ?? "",  // "$1.99"
// // // // //       currency:          paymentMeta.currency  || "usd",
// // // // //       includes:          serviceIncludes,
// // // // //       status:            "paid",
// // // // //       analysed:          false,
// // // // //       analysisUsedCount: 0,
// // // // //       analysisCount:     limits.analysisCount,
// // // // //       resumeGenerated:   false,
// // // // //       resumeGenCount:    limits.resumeGenCount,
// // // // //       createdAt:         serverTimestamp(),
// // // // //     });

// // // // //     // ── Track payment event ──
// // // // //     await trackEvent(userId, "payment_completed", {
// // // // //       paymentIntentId,
// // // // //       planId,
// // // // //       includes:      serviceIncludes,
// // // // //       transactionId: ref.id,
// // // // //     });

// // // // //     // ── Increment user payment counter ──
// // // // //     await incrementUserStat(userId, "totalPayments");

// // // // //     // ── Update user last paid timestamp ──
// // // // //     await setDoc(
// // // // //       doc(db, "users", userId),
// // // // //       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
// // // // //       { merge: true }
// // // // //     );

// // // // //     console.log("✅ Transaction saved:", ref.id);
// // // // //     return ref.id;

// // // // //   } catch (err) {
// // // // //     console.error("❌ saveTransaction error:", err);
// // // // //     throw err;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Mark a transaction as analysed (analysis complete).
// // // // //  */
// // // // // export async function markTransactionComplete(userId, transactionId) {
// // // // //   if (!userId || !transactionId) {
// // // // //     console.error("❌ markTransactionComplete: missing params");
// // // // //     return;
// // // // //   }
// // // // //   try {
// // // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // // //     const snap = await getDoc(ref);
// // // // //     if (!snap.exists()) {
// // // // //       console.error("❌ Transaction not found:", transactionId);
// // // // //       return;
// // // // //     }

// // // // //     const data        = snap.data();
// // // // //     const newCount    = (data.analysisUsedCount || 0) + 1;
// // // // //     // Always read limit from config — don't trust stale Firebase value
// // // // //     const planLimits  = getPlanLimits(data.planId);
// // // // //     const maxCount    = planLimits.analysisCount;
// // // // //     const analysedAll = newCount >= maxCount;

// // // // //     await setDoc(ref, {
// // // // //       status:            "paid",
// // // // //       analysed:          true,
// // // // //       completedAt:       serverTimestamp(),
// // // // //       analysisUsedCount: newCount,
// // // // //       analysisCount:     maxCount,      // patch it in case it was missing
// // // // //       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
// // // // //       analysedAll,
// // // // //     }, { merge: true });

// // // // //     // ── Track analysis completion event ──
// // // // //     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

// // // // //     // ── Increment user analysis counter ──
// // // // //     await incrementUserStat(userId, "totalAnalyses");

// // // // //     // ── Update user last analysed timestamp ──
// // // // //     await setDoc(
// // // // //       doc(db, "users", userId),
// // // // //       { lastAnalysisAt: serverTimestamp() },
// // // // //       { merge: true }
// // // // //     );

// // // // //     console.log("✅ Transaction marked complete:", transactionId);

// // // // //   } catch (err) {
// // // // //     console.error("❌ markTransactionComplete error:", err.message);
// // // // //     throw err;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Mark resume as generated for a transaction.
// // // // //  */
// // // // // export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
// // // // //   if (!userId || !transactionId) {
// // // // //     console.error("❌ markResumeGenerated: missing params");
// // // // //     return;
// // // // //   }
// // // // //   try {
// // // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // // //     await setDoc(ref, {
// // // // //       resumeGenerated:    true,
// // // // //       resumeGeneratedAt:  serverTimestamp(),
// // // // //       resumeTemplateId:   templateId,   // ← track which template was used
// // // // //     }, { merge: true });

// // // // //     // ── Track resume generation event with template ──
// // // // //     await trackEvent(userId, "resume_generated", {
// // // // //       transactionId,
// // // // //       templateId,
// // // // //     });

// // // // //     // ── Increment user resume counter ──
// // // // //     await incrementUserStat(userId, "totalResumesGenerated");

// // // // //     // ── Update user last resume timestamp + template ──
// // // // //     await setDoc(
// // // // //       doc(db, "users", userId),
// // // // //       {
// // // // //         lastResumeGeneratedAt: serverTimestamp(),
// // // // //         lastResumeTemplateId:  templateId,
// // // // //       },
// // // // //       { merge: true }
// // // // //     );

// // // // //     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

// // // // //   } catch (err) {
// // // // //     console.error("❌ markResumeGenerated error:", err);
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get pending transaction — paid but NOT yet analysed.
// // // // //  */
// // // // // export async function getPendingTransaction(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //     const pending = all
// // // // //       .filter(t => t.status === "paid" && t.analysed === false)
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     if (pending.length === 0) return null;

// // // // //     console.log("✅ Pending transaction found:", pending[0].id);
// // // // //     return pending[0];

// // // // //   } catch (err) {
// // // // //     console.error("❌ getPendingTransaction error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get most recent completed transaction — paid AND analysed.
// // // // //  */
// // // // // export async function getCompletedTransaction(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //     const completed = all
// // // // //       .filter(t => t.status === "paid" && t.analysed === true)
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     if (completed.length === 0) return null;

// // // // //     console.log("✅ Completed transaction found:", completed[0].id);
// // // // //     return completed[0];

// // // // //   } catch (err) {
// // // // //     console.error("❌ getCompletedTransaction error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get all transactions for a user (most recent first, max 50).
// // // // //  */
// // // // // export async function getAllTransactions(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return [];
// // // // //     return snapshot.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // // //       .slice(0, 50);
// // // // //   } catch (err) {
// // // // //     console.error("❌ getAllTransactions error:", err);
// // // // //     return [];
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // ANALYSES
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Get most recent analysis for a user.
// // // // //  */
// // // // // export async function getLastAnalysis(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "analyses")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const sorted = snapshot.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     console.log("✅ Last analysis found");
// // // // //     return sorted[0];

// // // // //   } catch (err) {
// // // // //     console.error("❌ getLastAnalysis error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get all analyses for a user (most recent first, max 20).
// // // // //  */
// // // // // export async function getAllAnalyses(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "analyses")
// // // // //     );
// // // // //     if (snapshot.empty) return [];

// // // // //     return snapshot.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // // //       .slice(0, 20);

// // // // //   } catch (err) {
// // // // //     console.error("❌ getAllAnalyses error:", err);
// // // // //     return [];
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // GENERATED RESUMES
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Check if user is eligible for free resume generation.
// // // // //  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
// // // // //  */
// // // // // export async function getFreeResumeEligibility(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

// // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

// // // // //     // All paid transactions sorted newest first
// // // // //     const paidTransactions = all
// // // // //       .filter(t => t.status === "paid")
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     if (paidTransactions.length === 0) {
// // // // //       return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // // //     }

// // // // //     // Always use the most recent paid plan for template access
// // // // //     const mostRecentPlan = paidTransactions[0].planId || "ats_basic";
// // // // //     const mostRecentIncludes = paidTransactions[0].includes || [];

// // // // //     // Find any analysed transaction where resume has NOT been generated yet
// // // // //     // Resume unlock: user must have done at least 1 analysis
// // // // //     const unusedAnalysis = all
// // // // //       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     if (unusedAnalysis.length === 0) {
// // // // //       // No eligible transaction — but still return planId so templates show correctly
// // // // //       console.log("No unused analysis found");
// // // // //       return {
// // // // //         eligible:      false,
// // // // //         transactionId: null,
// // // // //         planId:        mostRecentPlan,
// // // // //         includes:      mostRecentIncludes,
// // // // //       };
// // // // //     }

// // // // //     // Use the most recent unused analysis transaction
// // // // //     const eligible = unusedAnalysis[0];
// // // // //     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
// // // // //     return {
// // // // //       eligible:      true,
// // // // //       transactionId: eligible.id,
// // // // //       planId:        eligible.planId || mostRecentPlan,
// // // // //       includes:      eligible.includes || mostRecentIncludes,
// // // // //     };

// // // // //   } catch (err) {
// // // // //     console.error("getFreeResumeEligibility error:", err);
// // // // //     return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // PLAN LIMITS — reads from servicesConfig
// // // // // // ─────────────────────────────────────────────

// // // // // export function getPlanLimits(planId) {
// // // // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // // // //   const limits = {
// // // // //     analysisCount:  plan?.analysisCount  ?? 2,  // default 2 if not found
// // // // //     resumeGenCount: plan?.resumeGenCount ?? 1,
// // // // //   };
// // // // //   console.log(`📊 getPlanLimits(${planId}):`, limits);
// // // // //   return limits;
// // // // // }

// // // // // /**
// // // // //  * Get full usage status for a transaction.
// // // // //  * Used by dashboard to show analysis counter + generate button state.
// // // // //  */
// // // // // export async function getTransactionUsage(userId, transactionId) {
// // // // //   if (!userId || !transactionId) return null;
// // // // //   try {
// // // // //     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
// // // // //     if (!snap.exists()) return null;
// // // // //     const data    = snap.data();
// // // // //     const used   = data.analysisUsedCount || 0;
// // // // //     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
// // // // //     const limits = getPlanLimits(data.planId);
// // // // //     const max    = limits.analysisCount;  // authoritative from config
// // // // //     const resumeGenerated = data.resumeGenerated || false;
// // // // //     // Once resume is generated — NO more analyses allowed for this transaction
// // // // //     // User must pay again for new analyses
// // // // //     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
// // // // //     const canAnalyzeAgain   = !resumeGenerated && used < max;
// // // // //     // canGenerateResume: true after at least 1 analysis, even if more analyses remain
// // // // //     // User can choose to generate anytime after first analysis
// // // // //     const canGenerateResume = used > 0 && !resumeGenerated;
// // // // //     return {
// // // // //       transactionId,
// // // // //       planId:            data.planId,
// // // // //       analysisUsedCount: used,
// // // // //       analysisCount:     max,
// // // // //       analysisRemaining: resumeGenerated ? 0 : Math.max(0, max - used),
// // // // //       canAnalyzeAgain,
// // // // //       resumeGenerated,
// // // // //       resumeGenCount:    limits.resumeGenCount,
// // // // //       canGenerateResume,
// // // // //       resumeTemplateId:  data.resumeTemplateId || null,
// // // // //       // Analyses list for selection modal
// // // // //       analyses:          [],  // populated separately
// // // // //     };
// // // // //   } catch (err) {
// // // // //     console.error("❌ getTransactionUsage error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get all paid transaction usages for a user.
// // // // //  */
// // // // // export async function getAllTransactionUsages(userId) {
// // // // //   if (!userId) return [];
// // // // //   try {
// // // // //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// // // // //     return snap.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .filter(t => t.status === "paid" || t.status === "completed")
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// // // // //   } catch (err) {
// // // // //     console.error("❌ getAllTransactionUsages error:", err);
// // // // //     return [];
// // // // //   }
// // // // // }

// // // // // export async function saveGeneratedResume(userId, transactionId, resumeData) {
// // // // //   try {
// // // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // // //     await setDoc(ref, {
// // // // //       resumeData,
// // // // //       transactionId,
// // // // //       createdAt: serverTimestamp(),
// // // // //     });
// // // // //     console.log("✅ Generated resume saved:", transactionId);
// // // // //   } catch (err) {
// // // // //     console.error("❌ saveGeneratedResume error:", err);
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get a saved generated resume by transactionId.
// // // // //  */
// // // // // export async function getGeneratedResume(userId, transactionId) {
// // // // //   try {
// // // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // // //     const snap = await getDoc(ref);
// // // // //     if (snap.exists()) {
// // // // //       console.log("✅ Generated resume found");
// // // // //       return snap.data().resumeData;
// // // // //     }
// // // // //     return null;
// // // // //   } catch (err) {
// // // // //     console.error("❌ getGeneratedResume error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get the latest generated resume for a user.
// // // // //  */
// // // // // export async function getLatestGeneratedResume(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "generatedResumes")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const sorted = snapshot.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     console.log("✅ Latest generated resume found");
// // // // //     return sorted[0]?.resumeData || null;

// // // // //   } catch (err) {
// // // // //     console.error("❌ getLatestGeneratedResume error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // SERVICE ACCESS
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Check if user has access to a specific service from any of their transactions.
// // // // //  * Works for single services AND bundles.
// // // // //  */
// // // // // export async function hasServiceAccess(userId, serviceCode) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return false;

// // // // //     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //     return transactions.some(t => {
// // // // //       if (t.status !== "paid") return false;
// // // // //       // Direct service match
// // // // //       if (t.serviceCode === serviceCode) return true;
// // // // //       // Bundle match — check includes array
// // // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // // //       return false;
// // // // //     });
// // // // //   } catch (err) {
// // // // //     console.error("❌ hasServiceAccess error:", err);
// // // // //     return false;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get pending transaction for a specific service.
// // // // //  * Works for both direct service and bundle.
// // // // //  */
// // // // // export async function getPendingTransactionForService(userId, serviceCode) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //     const pending = all.filter(t => {
// // // // //       if (t.status !== "paid" || t.analysed !== false) return false;
// // // // //       if (t.serviceCode === serviceCode) return true;
// // // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // // //       return false;
// // // // //     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     return pending[0] || null;
// // // // //   } catch (err) {
// // // // //     console.error("❌ getPendingTransactionForService error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // SUPPORT TICKETS
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Save a support ticket.
// // // // //  */
// // // // // export async function saveSupportTicket(userId, ticketData) {
// // // // //   try {
// // // // //     const ref = await addDoc(collection(db, "supportTickets"), {
// // // // //       userId:    userId || null,
// // // // //       firstName: ticketData.firstName,
// // // // //       lastName:  ticketData.lastName,
// // // // //       email:     ticketData.email,
// // // // //       topic:     ticketData.topic,
// // // // //       message:   ticketData.message,
// // // // //       status:    "open",
// // // // //       createdAt: serverTimestamp(),
// // // // //       updatedAt: serverTimestamp(),
// // // // //       date:      new Date().toISOString().split("T")[0],
// // // // //     });

// // // // //     // ── Track support ticket event ──
// // // // //     if (userId) {
// // // // //       await trackEvent(userId, "support_ticket_created", {
// // // // //         ticketId: ref.id,
// // // // //         topic:    ticketData.topic,
// // // // //       });
// // // // //     }

// // // // //     console.log("✅ Support ticket saved:", ref.id);
// // // // //     return ref.id;

// // // // //   } catch (err) {
// // // // //     console.error("❌ saveSupportTicket error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get all support tickets for a user.
// // // // //  * Uses a proper Firestore query instead of fetching all and filtering client-side.
// // // // //  */
// // // // // export async function getUserSupportTickets(userId) {
// // // // //   try {
// // // // //     const q = query(
// // // // //       collection(db, "supportTickets"),
// // // // //       where("userId", "==", userId),
// // // // //       orderBy("createdAt", "desc"),
// // // // //       limit(50)
// // // // //     );
// // // // //     const snapshot = await getDocs(q);
// // // // //     if (snapshot.empty) return [];
// // // // //     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //   } catch (err) {
// // // // //     console.error("❌ getUserSupportTickets error:", err);
// // // // //     return [];
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // SESSION / PAGE TRACKING
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Track a page view or dashboard step visit.
// // // // //  * Call this from key screens: dashboard intro, upload, results, etc.
// // // // //  */
// // // // // export async function trackPageView(userId, page, extra = {}) {
// // // // //   await trackEvent(userId, "page_view", { page, ...extra });
// // // // // }

// // // // // /**
// // // // //  * Track a user action (button clicks, downloads, etc.)
// // // // //  */
// // // // // export async function trackUserAction(userId, action, extra = {}) {
// // // // //   await trackEvent(userId, action, extra);
// // // // // }

// // // // // /**
// // // // //  * Track analysis start — called when user clicks "Analyze My Resume".
// // // // //  */
// // // // // export async function trackAnalysisStart(userId, transactionId) {
// // // // //   await trackEvent(userId, "analysis_started", { transactionId });
// // // // //   await setDoc(
// // // // //     doc(db, "users", userId),
// // // // //     { lastActivityAt: serverTimestamp() },
// // // // //     { merge: true }
// // // // //   );
// // // // // }

// // // // // /**
// // // // //  * Track analysis failure so you can investigate in Firebase console.
// // // // //  */
// // // // // export async function trackAnalysisError(userId, transactionId, errorMessage) {
// // // // //   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// // // // // }

// // // // // /**
// // // // //  * Track report download.
// // // // //  */
// // // // // export async function trackReportDownload(userId, analysisId) {
// // // // //   await trackEvent(userId, "report_downloaded", { analysisId });
// // // // //   await incrementUserStat(userId, "totalDownloads");
// // // // // }

// // // // // /**
// // // // //  * Track service card click on dashboard intro.
// // // // //  */
// // // // // export async function trackServiceClick(userId, serviceCode) {
// // // // //   await trackEvent(userId, "service_selected", { serviceCode });
// // // // // }

// // // // // /**
// // // // //  * Track payment modal opened.
// // // // //  */
// // // // // export async function trackPaymentModalOpened(userId, serviceCode) {
// // // // //   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// // // // // }

// // // // // /**
// // // // //  * Track payment failure.
// // // // //  */
// // // // // export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
// // // // //   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// // // // // }

// // // // import {
// // // //   collection,
// // // //   addDoc,
// // // //   getDocs,
// // // //   doc,
// // // //   setDoc,
// // // //   getDoc,
// // // //   serverTimestamp,
// // // //   query,
// // // //   where,
// // // //   orderBy,
// // // //   limit,
// // // //   increment,
// // // // } from "firebase/firestore";
// // // // import { db } from "./firebase";
// // // // import servicesConfig from "./servicesConfig";

// // // // // ── Normalize legacy planIds saved as service codes ──
// // // // const LEGACY_PLAN_MAP = {
// // // //   "ATS_ANALYSIS":        "ats_basic",
// // // //   "ATS_RESUME_SAMPLE":   "ats_basic",
// // // //   "ATS_RESUME_IMPROVED": "ats_basic",
// // // //   "DOCUMENT_SUMMARY":    "doc_pro",
// // // //   "DOCUMENT_CHAT":       "doc_pro",
// // // // };
// // // // function normalizePlanId(planId) {
// // // //   if (!planId) return "ats_basic";
// // // //   return LEGACY_PLAN_MAP[planId] || planId;
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // TRACKING HELPERS
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Write a tracking event to users/{uid}/events subcollection.
// // // //  * Never throws — tracking must never break the main flow.
// // // //  */
// // // // async function trackEvent(userId, eventName, data = {}) {
// // // //   if (!userId) return;
// // // //   try {
// // // //     await addDoc(collection(db, "users", userId, "events"), {
// // // //       event:     eventName,
// // // //       ...data,
// // // //       timestamp: serverTimestamp(),
// // // //     });
// // // //   } catch (err) {
// // // //     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
// // // //   }
// // // // }

// // // // /**
// // // //  * Increment a counter on the user's top-level document.
// // // //  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
// // // //  */
// // // // async function incrementUserStat(userId, field, by = 1) {
// // // //   if (!userId) return;
// // // //   try {
// // // //     await setDoc(
// // // //       doc(db, "users", userId),
// // // //       { [field]: increment(by) },
// // // //       { merge: true }
// // // //     );
// // // //   } catch (err) {
// // // //     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // TRANSACTIONS
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Save a new verified transaction after Stripe payment succeeds.
// // // //  * Deduplicates by paymentIntentId — safe to call multiple times.
// // // //  */
// // // // export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
// // // //   try {
// // // //     // ── Deduplicate: don't create a second record for the same payment ──
// // // //     const existing = await getDocs(
// // // //       query(
// // // //         collection(db, "users", userId, "transactions"),
// // // //         where("paymentIntentId", "==", paymentIntentId)
// // // //       )
// // // //     );
// // // //     if (!existing.empty) {
// // // //       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
// // // //       return existing.docs[0].id;
// // // //     }

// // // //     // ── Default includes to planId if not provided ──
// // // //     const serviceIncludes = includes || [planId];

// // // //     // Get plan limits from config
// // // //     const limits = getPlanLimits(planId);

// // // //     // ── Snapshot plan name from config at time of purchase ──
// // // //     const planConfig = servicesConfig.plans.find(p => p.id === planId);

// // // //     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
// // // //       paymentIntentId,
// // // //       planId,
// // // //       planName:          paymentMeta.planName  || planConfig?.name  || planId,
// // // //       // Price frozen at payment time — never re-read from config
// // // //       amountPaid:        paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,  // cents
// // // //       amountDisplay:     paymentMeta.amountDisplay ?? planConfig?.price         ?? "",  // "$1.99"
// // // //       currency:          paymentMeta.currency  || "usd",
// // // //       includes:          serviceIncludes,
// // // //       status:            "paid",
// // // //       analysed:          false,
// // // //       analysisUsedCount: 0,
// // // //       analysisCount:     limits.analysisCount,
// // // //       resumeGenerated:   false,
// // // //       resumeGenCount:    limits.resumeGenCount,
// // // //       createdAt:         serverTimestamp(),
// // // //     });

// // // //     // ── Track payment event ──
// // // //     await trackEvent(userId, "payment_completed", {
// // // //       paymentIntentId,
// // // //       planId,
// // // //       includes:      serviceIncludes,
// // // //       transactionId: ref.id,
// // // //     });

// // // //     // ── Increment user payment counter ──
// // // //     await incrementUserStat(userId, "totalPayments");

// // // //     // ── Update user last paid timestamp ──
// // // //     await setDoc(
// // // //       doc(db, "users", userId),
// // // //       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
// // // //       { merge: true }
// // // //     );

// // // //     console.log("✅ Transaction saved:", ref.id);
// // // //     return ref.id;

// // // //   } catch (err) {
// // // //     console.error("❌ saveTransaction error:", err);
// // // //     throw err;
// // // //   }
// // // // }

// // // // /**
// // // //  * Mark a transaction as analysed (analysis complete).
// // // //  */
// // // // export async function markTransactionComplete(userId, transactionId) {
// // // //   if (!userId || !transactionId) {
// // // //     console.error("❌ markTransactionComplete: missing params");
// // // //     return;
// // // //   }
// // // //   try {
// // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // //     const snap = await getDoc(ref);
// // // //     if (!snap.exists()) {
// // // //       console.error("❌ Transaction not found:", transactionId);
// // // //       return;
// // // //     }

// // // //     const data        = snap.data();
// // // //     const newCount    = (data.analysisUsedCount || 0) + 1;
// // // //     // Always read limit from config — don't trust stale Firebase value
// // // //     const planLimits  = getPlanLimits(data.planId);
// // // //     const maxCount    = planLimits.analysisCount;
// // // //     const analysedAll = newCount >= maxCount;

// // // //     await setDoc(ref, {
// // // //       status:            "paid",
// // // //       analysed:          true,
// // // //       completedAt:       serverTimestamp(),
// // // //       analysisUsedCount: newCount,
// // // //       analysisCount:     maxCount,      // patch it in case it was missing
// // // //       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
// // // //       analysedAll,
// // // //     }, { merge: true });

// // // //     // ── Track analysis completion event ──
// // // //     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

// // // //     // ── Increment user analysis counter ──
// // // //     await incrementUserStat(userId, "totalAnalyses");

// // // //     // ── Update user last analysed timestamp ──
// // // //     await setDoc(
// // // //       doc(db, "users", userId),
// // // //       { lastAnalysisAt: serverTimestamp() },
// // // //       { merge: true }
// // // //     );

// // // //     console.log("✅ Transaction marked complete:", transactionId);

// // // //   } catch (err) {
// // // //     console.error("❌ markTransactionComplete error:", err.message);
// // // //     throw err;
// // // //   }
// // // // }

// // // // /**
// // // //  * Mark resume as generated for a transaction.
// // // //  */
// // // // export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
// // // //   if (!userId || !transactionId) {
// // // //     console.error("❌ markResumeGenerated: missing params");
// // // //     return;
// // // //   }
// // // //   try {
// // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // //     await setDoc(ref, {
// // // //       resumeGenerated:    true,
// // // //       resumeGeneratedAt:  serverTimestamp(),
// // // //       resumeTemplateId:   templateId,   // ← track which template was used
// // // //     }, { merge: true });

// // // //     // ── Track resume generation event with template ──
// // // //     await trackEvent(userId, "resume_generated", {
// // // //       transactionId,
// // // //       templateId,
// // // //     });

// // // //     // ── Increment user resume counter ──
// // // //     await incrementUserStat(userId, "totalResumesGenerated");

// // // //     // ── Update user last resume timestamp + template ──
// // // //     await setDoc(
// // // //       doc(db, "users", userId),
// // // //       {
// // // //         lastResumeGeneratedAt: serverTimestamp(),
// // // //         lastResumeTemplateId:  templateId,
// // // //       },
// // // //       { merge: true }
// // // //     );

// // // //     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

// // // //   } catch (err) {
// // // //     console.error("❌ markResumeGenerated error:", err);
// // // //   }
// // // // }

// // // // /**
// // // //  * Get pending transaction — paid but NOT yet analysed.
// // // //  */
// // // // export async function getPendingTransaction(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //     const pending = all
// // // //       .filter(t => t.status === "paid" && t.analysed === false)
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     if (pending.length === 0) return null;

// // // //     console.log("✅ Pending transaction found:", pending[0].id);
// // // //     return pending[0];

// // // //   } catch (err) {
// // // //     console.error("❌ getPendingTransaction error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get most recent completed transaction — paid AND analysed.
// // // //  */
// // // // export async function getCompletedTransaction(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //     const completed = all
// // // //       .filter(t => t.status === "paid" && t.analysed === true)
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     if (completed.length === 0) return null;

// // // //     console.log("✅ Completed transaction found:", completed[0].id);
// // // //     return completed[0];

// // // //   } catch (err) {
// // // //     console.error("❌ getCompletedTransaction error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get all transactions for a user (most recent first, max 50).
// // // //  */
// // // // export async function getAllTransactions(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return [];
// // // //     return snapshot.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // //       .slice(0, 50);
// // // //   } catch (err) {
// // // //     console.error("❌ getAllTransactions error:", err);
// // // //     return [];
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // ANALYSES
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Get most recent analysis for a user.
// // // //  */
// // // // export async function getLastAnalysis(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "analyses")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const sorted = snapshot.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     console.log("✅ Last analysis found");
// // // //     return sorted[0];

// // // //   } catch (err) {
// // // //     console.error("❌ getLastAnalysis error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get all analyses for a user (most recent first, max 20).
// // // //  */
// // // // export async function getAllAnalyses(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "analyses")
// // // //     );
// // // //     if (snapshot.empty) return [];

// // // //     return snapshot.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // //       .slice(0, 20);

// // // //   } catch (err) {
// // // //     console.error("❌ getAllAnalyses error:", err);
// // // //     return [];
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // GENERATED RESUMES
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Check if user is eligible for free resume generation.
// // // //  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
// // // //  */
// // // // export async function getFreeResumeEligibility(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

// // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

// // // //     // All paid transactions sorted newest first
// // // //     const paidTransactions = all
// // // //       .filter(t => t.status === "paid")
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     if (paidTransactions.length === 0) {
// // // //       return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // //     }

// // // //     // Always use the most recent paid plan for template access
// // // //     // normalizePlanId handles old transactions saved with service code as planId
// // // //     const mostRecentPlan = normalizePlanId(paidTransactions[0].planId) || "ats_basic";
// // // //     const mostRecentIncludes = paidTransactions[0].includes || [];

// // // //     // Find any analysed transaction where resume has NOT been generated yet
// // // //     // Resume unlock: user must have done at least 1 analysis
// // // //     const unusedAnalysis = all
// // // //       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     if (unusedAnalysis.length === 0) {
// // // //       // No eligible transaction — but still return planId so templates show correctly
// // // //       console.log("No unused analysis found");
// // // //       return {
// // // //         eligible:      false,
// // // //         transactionId: null,
// // // //         planId:        mostRecentPlan,
// // // //         includes:      mostRecentIncludes,
// // // //       };
// // // //     }

// // // //     // Use the most recent unused analysis transaction
// // // //     const eligible = unusedAnalysis[0];
// // // //     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
// // // //     return {
// // // //       eligible:      true,
// // // //       transactionId: eligible.id,
// // // //       planId:        normalizePlanId(eligible.planId) || mostRecentPlan,
// // // //       includes:      eligible.includes || mostRecentIncludes,
// // // //     };

// // // //   } catch (err) {
// // // //     console.error("getFreeResumeEligibility error:", err);
// // // //     return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // PLAN LIMITS — reads from servicesConfig
// // // // // ─────────────────────────────────────────────

// // // // export function getPlanLimits(planId) {
// // // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // // //   const limits = {
// // // //     analysisCount:  plan?.analysisCount  ?? 2,  // default 2 if not found
// // // //     resumeGenCount: plan?.resumeGenCount ?? 1,
// // // //   };
// // // //   console.log(`📊 getPlanLimits(${planId}):`, limits);
// // // //   return limits;
// // // // }

// // // // /**
// // // //  * Get full usage status for a transaction.
// // // //  * Used by dashboard to show analysis counter + generate button state.
// // // //  */
// // // // export async function getTransactionUsage(userId, transactionId) {
// // // //   if (!userId || !transactionId) return null;
// // // //   try {
// // // //     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
// // // //     if (!snap.exists()) return null;
// // // //     const data    = snap.data();
// // // //     const used   = data.analysisUsedCount || 0;
// // // //     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
// // // //     const limits = getPlanLimits(data.planId);
// // // //     const max    = limits.analysisCount;  // authoritative from config
// // // //     const resumeGenerated = data.resumeGenerated || false;
// // // //     // Once resume is generated — NO more analyses allowed for this transaction
// // // //     // User must pay again for new analyses
// // // //     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
// // // //     const canAnalyzeAgain   = !resumeGenerated && used < max;
// // // //     // canGenerateResume: true after at least 1 analysis, even if more analyses remain
// // // //     // User can choose to generate anytime after first analysis
// // // //     const canGenerateResume = used > 0 && !resumeGenerated;
// // // //     return {
// // // //       transactionId,
// // // //       planId:            data.planId,
// // // //       analysisUsedCount: used,
// // // //       analysisCount:     max,
// // // //       analysisRemaining: resumeGenerated ? 0 : Math.max(0, max - used),
// // // //       canAnalyzeAgain,
// // // //       resumeGenerated,
// // // //       resumeGenCount:    limits.resumeGenCount,
// // // //       canGenerateResume,
// // // //       resumeTemplateId:  data.resumeTemplateId || null,
// // // //       // Analyses list for selection modal
// // // //       analyses:          [],  // populated separately
// // // //     };
// // // //   } catch (err) {
// // // //     console.error("❌ getTransactionUsage error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get all paid transaction usages for a user.
// // // //  */
// // // // export async function getAllTransactionUsages(userId) {
// // // //   if (!userId) return [];
// // // //   try {
// // // //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// // // //     return snap.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .filter(t => t.status === "paid" || t.status === "completed")
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// // // //   } catch (err) {
// // // //     console.error("❌ getAllTransactionUsages error:", err);
// // // //     return [];
// // // //   }
// // // // }

// // // // export async function saveGeneratedResume(userId, transactionId, resumeData) {
// // // //   try {
// // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // //     await setDoc(ref, {
// // // //       resumeData,
// // // //       transactionId,
// // // //       createdAt: serverTimestamp(),
// // // //     });
// // // //     console.log("✅ Generated resume saved:", transactionId);
// // // //   } catch (err) {
// // // //     console.error("❌ saveGeneratedResume error:", err);
// // // //   }
// // // // }

// // // // /**
// // // //  * Get a saved generated resume by transactionId.
// // // //  */
// // // // export async function getGeneratedResume(userId, transactionId) {
// // // //   try {
// // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // //     const snap = await getDoc(ref);
// // // //     if (snap.exists()) {
// // // //       console.log("✅ Generated resume found");
// // // //       return snap.data().resumeData;
// // // //     }
// // // //     return null;
// // // //   } catch (err) {
// // // //     console.error("❌ getGeneratedResume error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get the latest generated resume for a user.
// // // //  */
// // // // export async function getLatestGeneratedResume(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "generatedResumes")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const sorted = snapshot.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     console.log("✅ Latest generated resume found");
// // // //     return sorted[0]?.resumeData || null;

// // // //   } catch (err) {
// // // //     console.error("❌ getLatestGeneratedResume error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // SERVICE ACCESS
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Check if user has access to a specific service from any of their transactions.
// // // //  * Works for single services AND bundles.
// // // //  */
// // // // export async function hasServiceAccess(userId, serviceCode) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return false;

// // // //     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //     return transactions.some(t => {
// // // //       if (t.status !== "paid") return false;
// // // //       // Direct service match
// // // //       if (t.serviceCode === serviceCode) return true;
// // // //       // Bundle match — check includes array
// // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // //       return false;
// // // //     });
// // // //   } catch (err) {
// // // //     console.error("❌ hasServiceAccess error:", err);
// // // //     return false;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get pending transaction for a specific service.
// // // //  * Works for both direct service and bundle.
// // // //  */
// // // // export async function getPendingTransactionForService(userId, serviceCode) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //     const pending = all.filter(t => {
// // // //       if (t.status !== "paid" || t.analysed !== false) return false;
// // // //       if (t.serviceCode === serviceCode) return true;
// // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // //       return false;
// // // //     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     return pending[0] || null;
// // // //   } catch (err) {
// // // //     console.error("❌ getPendingTransactionForService error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // SUPPORT TICKETS
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Save a support ticket.
// // // //  */
// // // // export async function saveSupportTicket(userId, ticketData) {
// // // //   try {
// // // //     const ref = await addDoc(collection(db, "supportTickets"), {
// // // //       userId:    userId || null,
// // // //       firstName: ticketData.firstName,
// // // //       lastName:  ticketData.lastName,
// // // //       email:     ticketData.email,
// // // //       topic:     ticketData.topic,
// // // //       message:   ticketData.message,
// // // //       status:    "open",
// // // //       createdAt: serverTimestamp(),
// // // //       updatedAt: serverTimestamp(),
// // // //       date:      new Date().toISOString().split("T")[0],
// // // //     });

// // // //     // ── Track support ticket event ──
// // // //     if (userId) {
// // // //       await trackEvent(userId, "support_ticket_created", {
// // // //         ticketId: ref.id,
// // // //         topic:    ticketData.topic,
// // // //       });
// // // //     }

// // // //     console.log("✅ Support ticket saved:", ref.id);
// // // //     return ref.id;

// // // //   } catch (err) {
// // // //     console.error("❌ saveSupportTicket error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get all support tickets for a user.
// // // //  * Uses a proper Firestore query instead of fetching all and filtering client-side.
// // // //  */
// // // // export async function getUserSupportTickets(userId) {
// // // //   try {
// // // //     const q = query(
// // // //       collection(db, "supportTickets"),
// // // //       where("userId", "==", userId),
// // // //       orderBy("createdAt", "desc"),
// // // //       limit(50)
// // // //     );
// // // //     const snapshot = await getDocs(q);
// // // //     if (snapshot.empty) return [];
// // // //     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //   } catch (err) {
// // // //     console.error("❌ getUserSupportTickets error:", err);
// // // //     return [];
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // SESSION / PAGE TRACKING
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Track a page view or dashboard step visit.
// // // //  * Call this from key screens: dashboard intro, upload, results, etc.
// // // //  */
// // // // export async function trackPageView(userId, page, extra = {}) {
// // // //   await trackEvent(userId, "page_view", { page, ...extra });
// // // // }

// // // // /**
// // // //  * Track a user action (button clicks, downloads, etc.)
// // // //  */
// // // // export async function trackUserAction(userId, action, extra = {}) {
// // // //   await trackEvent(userId, action, extra);
// // // // }

// // // // /**
// // // //  * Track analysis start — called when user clicks "Analyze My Resume".
// // // //  */
// // // // export async function trackAnalysisStart(userId, transactionId) {
// // // //   await trackEvent(userId, "analysis_started", { transactionId });
// // // //   await setDoc(
// // // //     doc(db, "users", userId),
// // // //     { lastActivityAt: serverTimestamp() },
// // // //     { merge: true }
// // // //   );
// // // // }

// // // // /**
// // // //  * Track analysis failure so you can investigate in Firebase console.
// // // //  */
// // // // export async function trackAnalysisError(userId, transactionId, errorMessage) {
// // // //   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// // // // }

// // // // /**
// // // //  * Track report download.
// // // //  */
// // // // export async function trackReportDownload(userId, analysisId) {
// // // //   await trackEvent(userId, "report_downloaded", { analysisId });
// // // //   await incrementUserStat(userId, "totalDownloads");
// // // // }

// // // // /**
// // // //  * Track service card click on dashboard intro.
// // // //  */
// // // // export async function trackServiceClick(userId, serviceCode) {
// // // //   await trackEvent(userId, "service_selected", { serviceCode });
// // // // }

// // // // /**
// // // //  * Track payment modal opened.
// // // //  */
// // // // export async function trackPaymentModalOpened(userId, serviceCode) {
// // // //   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// // // // }

// // // // /**
// // // //  * Track payment failure.
// // // //  */
// // // // export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
// // // //   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// // // // }



// // // import {
// // //   collection,
// // //   addDoc,
// // //   getDocs,
// // //   doc,
// // //   setDoc,
// // //   getDoc,
// // //   updateDoc,
// // //   serverTimestamp,
// // //   query,
// // //   where,
// // //   orderBy,
// // //   limit,
// // //   increment,
// // // } from "firebase/firestore";
// // // import { db } from "./firebase";
// // // import servicesConfig from "./servicesConfig";

// // // // ── Normalize legacy planIds saved as service codes ──
// // // const LEGACY_PLAN_MAP = {
// // //   "ATS_ANALYSIS":        "ats_basic",
// // //   "ATS_RESUME_SAMPLE":   "ats_basic",
// // //   "ATS_RESUME_IMPROVED": "ats_basic",
// // //   "DOCUMENT_SUMMARY":    "doc_pro",
// // //   "DOCUMENT_CHAT":       "doc_pro",
// // // };
// // // function normalizePlanId(planId) {
// // //   if (!planId) return "ats_basic";
// // //   return LEGACY_PLAN_MAP[planId] || planId;
// // // }

// // // // ─────────────────────────────────────────────
// // // // TRACKING HELPERS
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Write a tracking event to users/{uid}/events subcollection.
// // //  * Never throws — tracking must never break the main flow.
// // //  */
// // // async function trackEvent(userId, eventName, data = {}) {
// // //   if (!userId) return;
// // //   try {
// // //     await addDoc(collection(db, "users", userId, "events"), {
// // //       event:     eventName,
// // //       ...data,
// // //       timestamp: serverTimestamp(),
// // //     });
// // //   } catch (err) {
// // //     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
// // //   }
// // // }

// // // /**
// // //  * Increment a counter on the user's top-level document.
// // //  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
// // //  */
// // // async function incrementUserStat(userId, field, by = 1) {
// // //   if (!userId) return;
// // //   try {
// // //     await setDoc(
// // //       doc(db, "users", userId),
// // //       { [field]: increment(by) },
// // //       { merge: true }
// // //     );
// // //   } catch (err) {
// // //     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // TRANSACTIONS
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Save a new verified transaction after Stripe payment succeeds.
// // //  * Deduplicates by paymentIntentId — safe to call multiple times.
// // //  */
// // // export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
// // //   try {
// // //     // ── Deduplicate: don't create a second record for the same payment ──
// // //     const existing = await getDocs(
// // //       query(
// // //         collection(db, "users", userId, "transactions"),
// // //         where("paymentIntentId", "==", paymentIntentId)
// // //       )
// // //     );
// // //     if (!existing.empty) {
// // //       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
// // //       return existing.docs[0].id;
// // //     }

// // //     // ── Default includes to planId if not provided ──
// // //     const serviceIncludes = includes || [planId];

// // //     // Get plan limits from config
// // //     const limits = getPlanLimits(planId);

// // //     // ── Snapshot plan name from config at time of purchase ──
// // //     const planConfig = servicesConfig.plans.find(p => p.id === planId);

// // //     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
// // //       paymentIntentId,
// // //       planId,
// // //       planName:                paymentMeta.planName  || planConfig?.name  || planId,
// // //       // Price frozen at payment time — never re-read from config
// // //       amountPaid:              paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,  // cents
// // //       amountDisplay:           paymentMeta.amountDisplay ?? planConfig?.price         ?? "",  // "$1.99"
// // //       currency:                paymentMeta.currency  || "usd",
// // //       includes:                serviceIncludes,
// // //       status:                  "paid",
// // //       analysed:                false,
// // //       analysisUsedCount:       0,
// // //       analysisCount:           limits.analysisCount,
// // //       resumeGenerated:         false,
// // //       resumeGenCount:          limits.resumeGenCount,
// // //       // ── Cover letter tracking ──
// // //       coverLetterGenerated:    false,
// // //       coverLetterCount:        limits.coverLetterCount || 1,
// // //       coverLetterUsedCount:    0,
// // //       createdAt:               serverTimestamp(),
// // //     });

// // //     // ── Track payment event ──
// // //     await trackEvent(userId, "payment_completed", {
// // //       paymentIntentId,
// // //       planId,
// // //       includes:      serviceIncludes,
// // //       transactionId: ref.id,
// // //     });

// // //     // ── Increment user payment counter ──
// // //     await incrementUserStat(userId, "totalPayments");

// // //     // ── Update user last paid timestamp ──
// // //     await setDoc(
// // //       doc(db, "users", userId),
// // //       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
// // //       { merge: true }
// // //     );

// // //     console.log("✅ Transaction saved:", ref.id);
// // //     return ref.id;

// // //   } catch (err) {
// // //     console.error("❌ saveTransaction error:", err);
// // //     throw err;
// // //   }
// // // }

// // // /**
// // //  * Mark a transaction as analysed (analysis complete).
// // //  */
// // // export async function markTransactionComplete(userId, transactionId) {
// // //   if (!userId || !transactionId) {
// // //     console.error("❌ markTransactionComplete: missing params");
// // //     return;
// // //   }
// // //   try {
// // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // //     const snap = await getDoc(ref);
// // //     if (!snap.exists()) {
// // //       console.error("❌ Transaction not found:", transactionId);
// // //       return;
// // //     }

// // //     const data        = snap.data();
// // //     const newCount    = (data.analysisUsedCount || 0) + 1;
// // //     // Always read limit from config — don't trust stale Firebase value
// // //     const planLimits  = getPlanLimits(data.planId);
// // //     const maxCount    = planLimits.analysisCount;
// // //     const analysedAll = newCount >= maxCount;

// // //     await setDoc(ref, {
// // //       status:            "paid",
// // //       analysed:          true,
// // //       completedAt:       serverTimestamp(),
// // //       analysisUsedCount: newCount,
// // //       analysisCount:     maxCount,      // patch it in case it was missing
// // //       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
// // //       analysedAll,
// // //     }, { merge: true });

// // //     // ── Track analysis completion event ──
// // //     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

// // //     // ── Increment user analysis counter ──
// // //     await incrementUserStat(userId, "totalAnalyses");

// // //     // ── Update user last analysed timestamp ──
// // //     await setDoc(
// // //       doc(db, "users", userId),
// // //       { lastAnalysisAt: serverTimestamp() },
// // //       { merge: true }
// // //     );

// // //     console.log("✅ Transaction marked complete:", transactionId);

// // //   } catch (err) {
// // //     console.error("❌ markTransactionComplete error:", err.message);
// // //     throw err;
// // //   }
// // // }

// // // /**
// // //  * Mark resume as generated for a transaction.
// // //  */
// // // export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
// // //   if (!userId || !transactionId) {
// // //     console.error("❌ markResumeGenerated: missing params");
// // //     return;
// // //   }
// // //   try {
// // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // //     await setDoc(ref, {
// // //       resumeGenerated:    true,
// // //       resumeGeneratedAt:  serverTimestamp(),
// // //       resumeTemplateId:   templateId,   // ← track which template was used
// // //     }, { merge: true });

// // //     // ── Track resume generation event with template ──
// // //     await trackEvent(userId, "resume_generated", {
// // //       transactionId,
// // //       templateId,
// // //     });

// // //     // ── Increment user resume counter ──
// // //     await incrementUserStat(userId, "totalResumesGenerated");

// // //     // ── Update user last resume timestamp + template ──
// // //     await setDoc(
// // //       doc(db, "users", userId),
// // //       {
// // //         lastResumeGeneratedAt: serverTimestamp(),
// // //         lastResumeTemplateId:  templateId,
// // //       },
// // //       { merge: true }
// // //     );

// // //     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

// // //   } catch (err) {
// // //     console.error("❌ markResumeGenerated error:", err);
// // //   }
// // // }

// // // /**
// // //  * Get pending transaction — paid but NOT yet analysed.
// // //  */
// // // export async function getPendingTransaction(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //     const pending = all
// // //       .filter(t => t.status === "paid" && t.analysed === false)
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     if (pending.length === 0) return null;

// // //     console.log("✅ Pending transaction found:", pending[0].id);
// // //     return pending[0];

// // //   } catch (err) {
// // //     console.error("❌ getPendingTransaction error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get most recent completed transaction — paid AND analysed.
// // //  */
// // // export async function getCompletedTransaction(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //     const completed = all
// // //       .filter(t => t.status === "paid" && t.analysed === true)
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     if (completed.length === 0) return null;

// // //     console.log("✅ Completed transaction found:", completed[0].id);
// // //     return completed[0];

// // //   } catch (err) {
// // //     console.error("❌ getCompletedTransaction error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get all transactions for a user (most recent first, max 50).
// // //  */
// // // export async function getAllTransactions(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return [];
// // //     return snapshot.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // //       .slice(0, 50);
// // //   } catch (err) {
// // //     console.error("❌ getAllTransactions error:", err);
// // //     return [];
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // ANALYSES
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Get most recent analysis for a user.
// // //  */
// // // export async function getLastAnalysis(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "analyses")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const sorted = snapshot.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     console.log("✅ Last analysis found");
// // //     return sorted[0];

// // //   } catch (err) {
// // //     console.error("❌ getLastAnalysis error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get all analyses for a user (most recent first, max 20).
// // //  */
// // // export async function getAllAnalyses(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "analyses")
// // //     );
// // //     if (snapshot.empty) return [];

// // //     return snapshot.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // //       .slice(0, 20);

// // //   } catch (err) {
// // //     console.error("❌ getAllAnalyses error:", err);
// // //     return [];
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // GENERATED RESUMES
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Check if user is eligible for free resume generation.
// // //  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
// // //  */
// // // export async function getFreeResumeEligibility(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

// // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

// // //     // All paid transactions sorted newest first
// // //     const paidTransactions = all
// // //       .filter(t => t.status === "paid")
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     if (paidTransactions.length === 0) {
// // //       return { eligible: false, transactionId: null, planId: "ats_basic" };
// // //     }

// // //     // Always use the most recent paid plan for template access
// // //     // normalizePlanId handles old transactions saved with service code as planId
// // //     const mostRecentPlan = normalizePlanId(paidTransactions[0].planId) || "ats_basic";
// // //     const mostRecentIncludes = paidTransactions[0].includes || [];

// // //     // Find any analysed transaction where resume has NOT been generated yet
// // //     // Resume unlock: user must have done at least 1 analysis
// // //     const unusedAnalysis = all
// // //       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     if (unusedAnalysis.length === 0) {
// // //       // No eligible transaction — but still return planId so templates show correctly
// // //       console.log("No unused analysis found");
// // //       return {
// // //         eligible:      false,
// // //         transactionId: null,
// // //         planId:        mostRecentPlan,
// // //         includes:      mostRecentIncludes,
// // //       };
// // //     }

// // //     // Use the most recent unused analysis transaction
// // //     const eligible = unusedAnalysis[0];
// // //     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
// // //     return {
// // //       eligible:      true,
// // //       transactionId: eligible.id,
// // //       planId:        normalizePlanId(eligible.planId) || mostRecentPlan,
// // //       includes:      eligible.includes || mostRecentIncludes,
// // //     };

// // //   } catch (err) {
// // //     console.error("getFreeResumeEligibility error:", err);
// // //     return { eligible: false, transactionId: null, planId: "ats_basic" };
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // PLAN LIMITS — reads from servicesConfig
// // // // ─────────────────────────────────────────────

// // // export function getPlanLimits(planId) {
// // //   const id   = normalizePlanId(planId);
// // //   const plan = servicesConfig.plans.find(p => p.id === id);
// // //   const limits = {
// // //     analysisCount:    plan?.analysisCount    ?? 2,
// // //     resumeGenCount:   plan?.resumeGenCount   ?? 1,
// // //     coverLetterCount: plan?.coverLetterCount ?? 1,
// // //   };
// // //   console.log(`📊 getPlanLimits(${planId}):`, limits);
// // //   return limits;
// // // }

// // // /**
// // //  * Get full usage status for a transaction.
// // //  * Used by dashboard to show analysis counter + generate button state.
// // //  */
// // // export async function getTransactionUsage(userId, transactionId) {
// // //   if (!userId || !transactionId) return null;
// // //   try {
// // //     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
// // //     if (!snap.exists()) return null;
// // //     const data    = snap.data();
// // //     const used   = data.analysisUsedCount || 0;
// // //     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
// // //     const limits = getPlanLimits(data.planId);
// // //     const max    = limits.analysisCount;  // authoritative from config
// // //     const resumeGenerated = data.resumeGenerated || false;
// // //     // Once resume is generated — NO more analyses allowed for this transaction
// // //     // User must pay again for new analyses
// // //     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
// // //     const canAnalyzeAgain   = !resumeGenerated && used < max;
// // //     const canGenerateResume = used > 0 && !resumeGenerated;

// // //     // ── Cover letter usage ──
// // //     const coverLetterUsed      = data.coverLetterUsedCount || 0;
// // //     const coverLetterLimit     = data.coverLetterCount     || limits.coverLetterCount || 1;
// // //     const coverLetterRemaining = Math.max(0, coverLetterLimit - coverLetterUsed);

// // //     return {
// // //       transactionId,
// // //       planId:                data.planId,
// // //       analysisUsedCount:     used,
// // //       analysisCount:         max,
// // //       analysisRemaining:     resumeGenerated ? 0 : Math.max(0, max - used),
// // //       canAnalyzeAgain,
// // //       resumeGenerated,
// // //       resumeGenCount:        limits.resumeGenCount,
// // //       canGenerateResume,
// // //       resumeTemplateId:      data.resumeTemplateId || null,
// // //       coverLetterRemaining,
// // //       coverLetterGenerated:  data.coverLetterGenerated || false,
// // //       // Analyses list for selection modal
// // //       analyses:              [],  // populated separately
// // //     };
// // //   } catch (err) {
// // //     console.error("❌ getTransactionUsage error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get all paid transaction usages for a user.
// // //  */
// // // export async function getAllTransactionUsages(userId) {
// // //   if (!userId) return [];
// // //   try {
// // //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// // //     return snap.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .filter(t => t.status === "paid" || t.status === "completed")
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// // //   } catch (err) {
// // //     console.error("❌ getAllTransactionUsages error:", err);
// // //     return [];
// // //   }
// // // }

// // // /**
// // //  * Get the latest generated resume for a user.
// // //  */
// // // export async function getLatestGeneratedResume(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "generatedResumes")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const sorted = snapshot.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     console.log("✅ Latest generated resume found");
// // //     return sorted[0]?.resumeData || null;

// // //   } catch (err) {
// // //     console.error("❌ getLatestGeneratedResume error:", err);
// // //     return null;
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // SERVICE ACCESS
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Check if user has access to a specific service from any of their transactions.
// // //  * Works for single services AND bundles.
// // //  */
// // // export async function hasServiceAccess(userId, serviceCode) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return false;

// // //     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //     return transactions.some(t => {
// // //       if (t.status !== "paid") return false;
// // //       // Direct service match
// // //       if (t.serviceCode === serviceCode) return true;
// // //       // Bundle match — check includes array
// // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // //       return false;
// // //     });
// // //   } catch (err) {
// // //     console.error("❌ hasServiceAccess error:", err);
// // //     return false;
// // //   }
// // // }

// // // /**
// // //  * Get pending transaction for a specific service.
// // //  * Works for both direct service and bundle.
// // //  */
// // // export async function getPendingTransactionForService(userId, serviceCode) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //     const pending = all.filter(t => {
// // //       if (t.status !== "paid" || t.analysed !== false) return false;
// // //       if (t.serviceCode === serviceCode) return true;
// // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // //       return false;
// // //     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     return pending[0] || null;
// // //   } catch (err) {
// // //     console.error("❌ getPendingTransactionForService error:", err);
// // //     return null;
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // SUPPORT TICKETS
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Save a support ticket.
// // //  */
// // // export async function saveSupportTicket(userId, ticketData) {
// // //   try {
// // //     const ref = await addDoc(collection(db, "supportTickets"), {
// // //       userId:    userId || null,
// // //       firstName: ticketData.firstName,
// // //       lastName:  ticketData.lastName,
// // //       email:     ticketData.email,
// // //       topic:     ticketData.topic,
// // //       message:   ticketData.message,
// // //       status:    "open",
// // //       createdAt: serverTimestamp(),
// // //       updatedAt: serverTimestamp(),
// // //       date:      new Date().toISOString().split("T")[0],
// // //     });

// // //     // ── Track support ticket event ──
// // //     if (userId) {
// // //       await trackEvent(userId, "support_ticket_created", {
// // //         ticketId: ref.id,
// // //         topic:    ticketData.topic,
// // //       });
// // //     }

// // //     console.log("✅ Support ticket saved:", ref.id);
// // //     return ref.id;

// // //   } catch (err) {
// // //     console.error("❌ saveSupportTicket error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get all support tickets for a user.
// // //  * Uses a proper Firestore query instead of fetching all and filtering client-side.
// // //  */
// // // export async function getUserSupportTickets(userId) {
// // //   try {
// // //     const q = query(
// // //       collection(db, "supportTickets"),
// // //       where("userId", "==", userId),
// // //       orderBy("createdAt", "desc"),
// // //       limit(50)
// // //     );
// // //     const snapshot = await getDocs(q);
// // //     if (snapshot.empty) return [];
// // //     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //   } catch (err) {
// // //     console.error("❌ getUserSupportTickets error:", err);
// // //     return [];
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // SESSION / PAGE TRACKING
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Track a page view or dashboard step visit.
// // //  * Call this from key screens: dashboard intro, upload, results, etc.
// // //  */
// // // export async function trackPageView(userId, page, extra = {}) {
// // //   await trackEvent(userId, "page_view", { page, ...extra });
// // // }

// // // /**
// // //  * Track a user action (button clicks, downloads, etc.)
// // //  */
// // // export async function trackUserAction(userId, action, extra = {}) {
// // //   await trackEvent(userId, action, extra);
// // // }

// // // /**
// // //  * Track analysis start — called when user clicks "Analyze My Resume".
// // //  */
// // // export async function trackAnalysisStart(userId, transactionId) {
// // //   await trackEvent(userId, "analysis_started", { transactionId });
// // //   await setDoc(
// // //     doc(db, "users", userId),
// // //     { lastActivityAt: serverTimestamp() },
// // //     { merge: true }
// // //   );
// // // }

// // // /**
// // //  * Track analysis failure so you can investigate in Firebase console.
// // //  */
// // // export async function trackAnalysisError(userId, transactionId, errorMessage) {
// // //   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// // // }

// // // /**
// // //  * Track report download.
// // //  */
// // // export async function trackReportDownload(userId, analysisId) {
// // //   await trackEvent(userId, "report_downloaded", { analysisId });
// // //   await incrementUserStat(userId, "totalDownloads");
// // // }

// // // /**
// // //  * Track service card click on dashboard intro.
// // //  */
// // // export async function trackServiceClick(userId, serviceCode) {
// // //   await trackEvent(userId, "service_selected", { serviceCode });
// // // }

// // // /**
// // //  * Track payment modal opened.
// // //  */
// // // export async function trackPaymentModalOpened(userId, serviceCode) {
// // //   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// // // }

// // // /**
// // //  * Track payment failure.
// // //  */
// // // export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
// // //   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// // // }

// // // // ─────────────────────────────────────────────
// // // // COVER LETTER
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Mark cover letter as generated for a transaction.
// // //  * Increments coverLetterUsedCount — respects the per-plan limit.
// // //  */
// // // export async function markCoverLetterGenerated(userId, transactionId) {
// // //   try {
// // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // //     await updateDoc(ref, {
// // //       coverLetterGenerated:   true,
// // //       coverLetterUsedCount:   increment(1),
// // //       coverLetterGeneratedAt: serverTimestamp(),
// // //     });
// // //     await incrementUserStat(userId, "totalCoverLetters");
// // //     await trackEvent(userId, "cover_letter_generated", { transactionId });
// // //     console.log("✅ Cover letter marked as generated:", transactionId);
// // //   } catch (err) {
// // //     console.error("❌ markCoverLetterGenerated error:", err);
// // //     throw err;
// // //   }
// // // }

// // // /**
// // //  * Check if user has cover letter generation remaining.
// // //  * Returns { eligible, transactionId, remaining, limit }
// // //  */
// // // export async function getCoverLetterEligibility(userId) {
// // //   try {
// // //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// // //     const paid = snap.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .filter(t => t.status === "paid")
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     for (const tx of paid) {
// // //       const used  = tx.coverLetterUsedCount || 0;
// // //       const limit = tx.coverLetterCount     || 1;
// // //       if (used < limit) {
// // //         return {
// // //           eligible:      true,
// // //           transactionId: tx.id,
// // //           planId:        normalizePlanId(tx.planId),
// // //           remaining:     limit - used,
// // //           limit,
// // //         };
// // //       }
// // //     }
// // //     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
// // //   } catch (err) {
// // //     console.error("getCoverLetterEligibility error:", err);
// // //     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // GENERATED DOCUMENTS — resumes + cover letters
// // // // Saved to Firestore, available for 30 days
// // // // ─────────────────────────────────────────────

// // // const DOCS_TTL_DAYS = 30;

// // // /**
// // //  * Save a generated resume to Firestore.
// // //  * Stores the full resume JSON + template info for re-download.
// // //  */
// // // export async function saveGeneratedResume(userId, { resumeData, templateId, transactionId, planId }) {
// // //   try {
// // //     const expiresAt = new Date();
// // //     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

// // //     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), {
// // //       type:          "resume",
// // //       templateId:    templateId  || "classic",
// // //       planId:        planId      || "ats_basic",
// // //       transactionId: transactionId || null,
// // //       resumeData:    resumeData  || {},         // full resume JSON
// // //       createdAt:     serverTimestamp(),
// // //       expiresAt:     expiresAt.toISOString(),   // ISO string for easy comparison
// // //     });
// // //     console.log("✅ Resume saved to Firestore:", ref.id);
// // //     return ref.id;
// // //   } catch (err) {
// // //     console.error("saveGeneratedResume error:", err);
// // //     throw err;
// // //   }
// // // }

// // // /**
// // //  * Save a generated cover letter to Firestore.
// // //  * Stores full letter JSON (opening, body1, body2, closing etc).
// // //  */
// // // export async function saveGeneratedCoverLetter(userId, { letterData, tone, transactionId, planId }) {
// // //   try {
// // //     const expiresAt = new Date();
// // //     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

// // //     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), {
// // //       type:          "cover_letter",
// // //       tone:          tone          || "professional",
// // //       planId:        planId        || "ats_basic",
// // //       transactionId: transactionId || null,
// // //       letterData:    letterData    || {},        // full letter JSON
// // //       createdAt:     serverTimestamp(),
// // //       expiresAt:     expiresAt.toISOString(),
// // //     });
// // //     console.log("✅ Cover letter saved to Firestore:", ref.id);
// // //     return ref.id;
// // //   } catch (err) {
// // //     console.error("saveGeneratedCoverLetter error:", err);
// // //     throw err;
// // //   }
// // // }

// // // /**
// // //  * Get all generated docs for a user (resumes + cover letters).
// // //  * Filters out expired docs (older than 30 days).
// // //  */
// // // export async function getUserGeneratedDocs(userId) {
// // //   try {
// // //     const snap = await getDocs(collection(db, "users", userId, "generatedDocs"));
// // //     const now  = new Date();
// // //     return snap.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .filter(doc => {
// // //         if (!doc.expiresAt) return true; // keep docs without expiry
// // //         return new Date(doc.expiresAt) > now;
// // //       })
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// // //   } catch (err) {
// // //     console.error("getUserGeneratedDocs error:", err);
// // //     return [];
// // //   }
// // // }

// // // /**
// // //  * Get only generated resumes.
// // //  */
// // // export async function getUserGeneratedResumes(userId) {
// // //   const docs = await getUserGeneratedDocs(userId);
// // //   return docs.filter(d => d.type === "resume");
// // // }

// // // /**
// // //  * Get only generated cover letters.
// // //  */
// // // export async function getUserGeneratedCoverLetters(userId) {
// // //   const docs = await getUserGeneratedDocs(userId);
// // //   return docs.filter(d => d.type === "cover_letter");
// // // }

// // import {
// //   collection,
// //   addDoc,
// //   getDocs,
// //   doc,
// //   setDoc,
// //   getDoc,
// //   updateDoc,
// //   serverTimestamp,
// //   query,
// //   where,
// //   orderBy,
// //   limit,
// //   increment,
// // } from "firebase/firestore";
// // import { db } from "./firebase";
// // import servicesConfig from "./servicesConfig";

// // // ── Normalize legacy planIds saved as service codes ──
// // const LEGACY_PLAN_MAP = {
// //   "ATS_ANALYSIS":        "ats_basic",
// //   "ATS_RESUME_SAMPLE":   "ats_basic",
// //   "ATS_RESUME_IMPROVED": "ats_basic",
// //   "DOCUMENT_SUMMARY":    "doc_pro",
// //   "DOCUMENT_CHAT":       "doc_pro",
// // };
// // function normalizePlanId(planId) {
// //   if (!planId) return "ats_basic";
// //   return LEGACY_PLAN_MAP[planId] || planId;
// // }

// // // ─────────────────────────────────────────────
// // // TRACKING HELPERS
// // // ─────────────────────────────────────────────

// // /**
// //  * Write a tracking event to users/{uid}/events subcollection.
// //  * Never throws — tracking must never break the main flow.
// //  */
// // async function trackEvent(userId, eventName, data = {}) {
// //   if (!userId) return;
// //   try {
// //     await addDoc(collection(db, "users", userId, "events"), {
// //       event:     eventName,
// //       ...data,
// //       timestamp: serverTimestamp(),
// //     });
// //   } catch (err) {
// //     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
// //   }
// // }

// // /**
// //  * Increment a counter on the user's top-level document.
// //  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
// //  */
// // async function incrementUserStat(userId, field, by = 1) {
// //   if (!userId) return;
// //   try {
// //     await setDoc(
// //       doc(db, "users", userId),
// //       { [field]: increment(by) },
// //       { merge: true }
// //     );
// //   } catch (err) {
// //     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // TRANSACTIONS
// // // ─────────────────────────────────────────────

// // /**
// //  * Save a new verified transaction after Stripe payment succeeds.
// //  * Deduplicates by paymentIntentId — safe to call multiple times.
// //  */
// // export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
// //   try {
// //     // ── Deduplicate: don't create a second record for the same payment ──
// //     const existing = await getDocs(
// //       query(
// //         collection(db, "users", userId, "transactions"),
// //         where("paymentIntentId", "==", paymentIntentId)
// //       )
// //     );
// //     if (!existing.empty) {
// //       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
// //       return existing.docs[0].id;
// //     }

// //     // ── Default includes to planId if not provided ──
// //     const serviceIncludes = includes || [planId];

// //     // Get plan limits from config
// //     const limits = getPlanLimits(planId);

// //     // ── Snapshot plan name from config at time of purchase ──
// //     const planConfig = servicesConfig.plans.find(p => p.id === planId);

// //     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
// //       paymentIntentId,
// //       planId,
// //       planName:                paymentMeta.planName  || planConfig?.name  || planId,
// //       // Price frozen at payment time — never re-read from config
// //       amountPaid:              paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,  // cents
// //       amountDisplay:           paymentMeta.amountDisplay ?? planConfig?.price         ?? "",  // "$1.99"
// //       currency:                paymentMeta.currency  || "usd",
// //       includes:                serviceIncludes,
// //       status:                  "paid",
// //       analysed:                false,
// //       analysisUsedCount:       0,
// //       analysisCount:           limits.analysisCount,
// //       resumeGenerated:         false,
// //       resumeGenCount:          limits.resumeGenCount,
// //       // ── Cover letter tracking ──
// //       coverLetterGenerated:    false,
// //       coverLetterCount:        limits.coverLetterCount || 1,
// //       coverLetterUsedCount:    0,
// //       createdAt:               serverTimestamp(),
// //     });

// //     // ── Track payment event ──
// //     await trackEvent(userId, "payment_completed", {
// //       paymentIntentId,
// //       planId,
// //       includes:      serviceIncludes,
// //       transactionId: ref.id,
// //     });

// //     // ── Increment user payment counter ──
// //     await incrementUserStat(userId, "totalPayments");

// //     // ── Update user last paid timestamp ──
// //     await setDoc(
// //       doc(db, "users", userId),
// //       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
// //       { merge: true }
// //     );

// //     console.log("✅ Transaction saved:", ref.id);
// //     return ref.id;

// //   } catch (err) {
// //     console.error("❌ saveTransaction error:", err);
// //     throw err;
// //   }
// // }

// // /**
// //  * Mark a transaction as analysed (analysis complete).
// //  */
// // export async function markTransactionComplete(userId, transactionId) {
// //   if (!userId || !transactionId) {
// //     console.error("❌ markTransactionComplete: missing params");
// //     return;
// //   }
// //   try {
// //     const ref = doc(db, "users", userId, "transactions", transactionId);
// //     const snap = await getDoc(ref);
// //     if (!snap.exists()) {
// //       console.error("❌ Transaction not found:", transactionId);
// //       return;
// //     }

// //     const data        = snap.data();
// //     const newCount    = (data.analysisUsedCount || 0) + 1;
// //     // Always read limit from config — don't trust stale Firebase value
// //     const planLimits  = getPlanLimits(data.planId);
// //     const maxCount    = planLimits.analysisCount;
// //     const analysedAll = newCount >= maxCount;

// //     await setDoc(ref, {
// //       status:            "paid",
// //       analysed:          true,
// //       completedAt:       serverTimestamp(),
// //       analysisUsedCount: newCount,
// //       analysisCount:     maxCount,      // patch it in case it was missing
// //       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
// //       analysedAll,
// //     }, { merge: true });

// //     // ── Track analysis completion event ──
// //     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

// //     // ── Increment user analysis counter ──
// //     await incrementUserStat(userId, "totalAnalyses");

// //     // ── Update user last analysed timestamp ──
// //     await setDoc(
// //       doc(db, "users", userId),
// //       { lastAnalysisAt: serverTimestamp() },
// //       { merge: true }
// //     );

// //     console.log("✅ Transaction marked complete:", transactionId);

// //   } catch (err) {
// //     console.error("❌ markTransactionComplete error:", err.message);
// //     throw err;
// //   }
// // }

// // /**
// //  * Mark resume as generated for a transaction.
// //  */
// // export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
// //   if (!userId || !transactionId) {
// //     console.error("❌ markResumeGenerated: missing params");
// //     return;
// //   }
// //   try {
// //     const ref = doc(db, "users", userId, "transactions", transactionId);
// //     await setDoc(ref, {
// //       resumeGenerated:    true,
// //       resumeGeneratedAt:  serverTimestamp(),
// //       resumeTemplateId:   templateId,   // ← track which template was used
// //     }, { merge: true });

// //     // ── Track resume generation event with template ──
// //     await trackEvent(userId, "resume_generated", {
// //       transactionId,
// //       templateId,
// //     });

// //     // ── Increment user resume counter ──
// //     await incrementUserStat(userId, "totalResumesGenerated");

// //     // ── Update user last resume timestamp + template ──
// //     await setDoc(
// //       doc(db, "users", userId),
// //       {
// //         lastResumeGeneratedAt: serverTimestamp(),
// //         lastResumeTemplateId:  templateId,
// //       },
// //       { merge: true }
// //     );

// //     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

// //   } catch (err) {
// //     console.error("❌ markResumeGenerated error:", err);
// //   }
// // }

// // /**
// //  * Get pending transaction — paid but NOT yet analysed.
// //  */
// // export async function getPendingTransaction(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return null;

// //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //     const pending = all
// //       .filter(t => t.status === "paid" && t.analysed === false)
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     if (pending.length === 0) return null;

// //     console.log("✅ Pending transaction found:", pending[0].id);
// //     return pending[0];

// //   } catch (err) {
// //     console.error("❌ getPendingTransaction error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get most recent completed transaction — paid AND analysed.
// //  */
// // export async function getCompletedTransaction(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return null;

// //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //     const completed = all
// //       .filter(t => t.status === "paid" && t.analysed === true)
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     if (completed.length === 0) return null;

// //     console.log("✅ Completed transaction found:", completed[0].id);
// //     return completed[0];

// //   } catch (err) {
// //     console.error("❌ getCompletedTransaction error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get all transactions for a user (most recent first, max 50).
// //  */
// // export async function getAllTransactions(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return [];
// //     return snapshot.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// //       .slice(0, 50);
// //   } catch (err) {
// //     console.error("❌ getAllTransactions error:", err);
// //     return [];
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // ANALYSES
// // // ─────────────────────────────────────────────

// // /**
// //  * Get most recent analysis for a user.
// //  */
// // export async function getLastAnalysis(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "analyses")
// //     );
// //     if (snapshot.empty) return null;

// //     const sorted = snapshot.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     console.log("✅ Last analysis found");
// //     return sorted[0];

// //   } catch (err) {
// //     console.error("❌ getLastAnalysis error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get all analyses for a user (most recent first, max 20).
// //  */
// // export async function getAllAnalyses(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "analyses")
// //     );
// //     if (snapshot.empty) return [];

// //     return snapshot.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// //       .slice(0, 20);

// //   } catch (err) {
// //     console.error("❌ getAllAnalyses error:", err);
// //     return [];
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // GENERATED RESUMES
// // // ─────────────────────────────────────────────

// // /**
// //  * Check if user is eligible for free resume generation.
// //  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
// //  */
// // export async function getFreeResumeEligibility(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

// //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

// //     // All paid transactions sorted newest first
// //     const paidTransactions = all
// //       .filter(t => t.status === "paid")
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     if (paidTransactions.length === 0) {
// //       return { eligible: false, transactionId: null, planId: "ats_basic" };
// //     }

// //     // Always use the most recent paid plan for template access
// //     // normalizePlanId handles old transactions saved with service code as planId
// //     const mostRecentPlan = normalizePlanId(paidTransactions[0].planId) || "ats_basic";
// //     const mostRecentIncludes = paidTransactions[0].includes || [];

// //     // Find any analysed transaction where resume has NOT been generated yet
// //     // Resume unlock: user must have done at least 1 analysis
// //     const unusedAnalysis = all
// //       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     if (unusedAnalysis.length === 0) {
// //       // No eligible transaction — but still return planId so templates show correctly
// //       console.log("No unused analysis found");
// //       return {
// //         eligible:      false,
// //         transactionId: null,
// //         planId:        mostRecentPlan,
// //         includes:      mostRecentIncludes,
// //       };
// //     }

// //     // Use the most recent unused analysis transaction
// //     const eligible = unusedAnalysis[0];
// //     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
// //     return {
// //       eligible:      true,
// //       transactionId: eligible.id,
// //       planId:        normalizePlanId(eligible.planId) || mostRecentPlan,
// //       includes:      eligible.includes || mostRecentIncludes,
// //     };

// //   } catch (err) {
// //     console.error("getFreeResumeEligibility error:", err);
// //     return { eligible: false, transactionId: null, planId: "ats_basic" };
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // PLAN LIMITS — reads from servicesConfig
// // // ─────────────────────────────────────────────

// // export function getPlanLimits(planId) {
// //   const id   = normalizePlanId(planId);
// //   const plan = servicesConfig.plans.find(p => p.id === id);
// //   const limits = {
// //     analysisCount:    plan?.analysisCount    ?? 2,
// //     resumeGenCount:   plan?.resumeGenCount   ?? 1,
// //     coverLetterCount: plan?.coverLetterCount ?? 1,
// //   };
// //   console.log(`📊 getPlanLimits(${planId}):`, limits);
// //   return limits;
// // }

// // /**
// //  * Get full usage status for a transaction.
// //  * Used by dashboard to show analysis counter + generate button state.
// //  */
// // export async function getTransactionUsage(userId, transactionId) {
// //   if (!userId || !transactionId) return null;
// //   try {
// //     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
// //     if (!snap.exists()) return null;
// //     const data    = snap.data();
// //     const used   = data.analysisUsedCount || 0;
// //     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
// //     const limits = getPlanLimits(data.planId);
// //     const max    = limits.analysisCount;  // authoritative from config
// //     const resumeGenerated = data.resumeGenerated || false;
// //     // Once resume is generated — NO more analyses allowed for this transaction
// //     // User must pay again for new analyses
// //     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
// //     const canAnalyzeAgain   = !resumeGenerated && used < max;
// //     const canGenerateResume = used > 0 && !resumeGenerated;

// //     // ── Cover letter usage ──
// //     const coverLetterUsed      = data.coverLetterUsedCount || 0;
// //     const coverLetterLimit     = data.coverLetterCount     || limits.coverLetterCount || 1;
// //     const coverLetterRemaining = Math.max(0, coverLetterLimit - coverLetterUsed);

// //     return {
// //       transactionId,
// //       planId:                data.planId,
// //       analysisUsedCount:     used,
// //       analysisCount:         max,
// //       analysisRemaining:     resumeGenerated ? 0 : Math.max(0, max - used),
// //       canAnalyzeAgain,
// //       resumeGenerated,
// //       resumeGenCount:        limits.resumeGenCount,
// //       canGenerateResume,
// //       resumeTemplateId:      data.resumeTemplateId || null,
// //       coverLetterRemaining,
// //       coverLetterGenerated:  data.coverLetterGenerated || false,
// //       // Analyses list for selection modal
// //       analyses:              [],  // populated separately
// //     };
// //   } catch (err) {
// //     console.error("❌ getTransactionUsage error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get all paid transaction usages for a user.
// //  */
// // export async function getAllTransactionUsages(userId) {
// //   if (!userId) return [];
// //   try {
// //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// //     return snap.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .filter(t => t.status === "paid" || t.status === "completed")
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// //   } catch (err) {
// //     console.error("❌ getAllTransactionUsages error:", err);
// //     return [];
// //   }
// // }

// // /**
// //  * Get the latest generated resume for a user.
// //  */
// // export async function getLatestGeneratedResume(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "generatedResumes")
// //     );
// //     if (snapshot.empty) return null;

// //     const sorted = snapshot.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     console.log("✅ Latest generated resume found");
// //     return sorted[0]?.resumeData || null;

// //   } catch (err) {
// //     console.error("❌ getLatestGeneratedResume error:", err);
// //     return null;
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // SERVICE ACCESS
// // // ─────────────────────────────────────────────

// // /**
// //  * Check if user has access to a specific service from any of their transactions.
// //  * Works for single services AND bundles.
// //  */
// // export async function hasServiceAccess(userId, serviceCode) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return false;

// //     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //     return transactions.some(t => {
// //       if (t.status !== "paid") return false;
// //       // Direct service match
// //       if (t.serviceCode === serviceCode) return true;
// //       // Bundle match — check includes array
// //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// //       return false;
// //     });
// //   } catch (err) {
// //     console.error("❌ hasServiceAccess error:", err);
// //     return false;
// //   }
// // }

// // /**
// //  * Get pending transaction for a specific service.
// //  * Works for both direct service and bundle.
// //  */
// // export async function getPendingTransactionForService(userId, serviceCode) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return null;

// //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //     const pending = all.filter(t => {
// //       if (t.status !== "paid" || t.analysed !== false) return false;
// //       if (t.serviceCode === serviceCode) return true;
// //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// //       return false;
// //     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     return pending[0] || null;
// //   } catch (err) {
// //     console.error("❌ getPendingTransactionForService error:", err);
// //     return null;
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // SUPPORT TICKETS
// // // ─────────────────────────────────────────────

// // /**
// //  * Save a support ticket.
// //  */
// // export async function saveSupportTicket(userId, ticketData) {
// //   try {
// //     const ref = await addDoc(collection(db, "supportTickets"), {
// //       userId:    userId || null,
// //       firstName: ticketData.firstName,
// //       lastName:  ticketData.lastName,
// //       email:     ticketData.email,
// //       topic:     ticketData.topic,
// //       message:   ticketData.message,
// //       status:    "open",
// //       createdAt: serverTimestamp(),
// //       updatedAt: serverTimestamp(),
// //       date:      new Date().toISOString().split("T")[0],
// //     });

// //     // ── Track support ticket event ──
// //     if (userId) {
// //       await trackEvent(userId, "support_ticket_created", {
// //         ticketId: ref.id,
// //         topic:    ticketData.topic,
// //       });
// //     }

// //     console.log("✅ Support ticket saved:", ref.id);
// //     return ref.id;

// //   } catch (err) {
// //     console.error("❌ saveSupportTicket error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get all support tickets for a user.
// //  * Uses a proper Firestore query instead of fetching all and filtering client-side.
// //  */
// // export async function getUserSupportTickets(userId) {
// //   try {
// //     const q = query(
// //       collection(db, "supportTickets"),
// //       where("userId", "==", userId),
// //       orderBy("createdAt", "desc"),
// //       limit(50)
// //     );
// //     const snapshot = await getDocs(q);
// //     if (snapshot.empty) return [];
// //     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //   } catch (err) {
// //     console.error("❌ getUserSupportTickets error:", err);
// //     return [];
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // SESSION / PAGE TRACKING
// // // ─────────────────────────────────────────────

// // /**
// //  * Track a page view or dashboard step visit.
// //  * Call this from key screens: dashboard intro, upload, results, etc.
// //  */
// // export async function trackPageView(userId, page, extra = {}) {
// //   await trackEvent(userId, "page_view", { page, ...extra });
// // }

// // /**
// //  * Track a user action (button clicks, downloads, etc.)
// //  */
// // export async function trackUserAction(userId, action, extra = {}) {
// //   await trackEvent(userId, action, extra);
// // }

// // /**
// //  * Track analysis start — called when user clicks "Analyze My Resume".
// //  */
// // export async function trackAnalysisStart(userId, transactionId) {
// //   await trackEvent(userId, "analysis_started", { transactionId });
// //   await setDoc(
// //     doc(db, "users", userId),
// //     { lastActivityAt: serverTimestamp() },
// //     { merge: true }
// //   );
// // }

// // /**
// //  * Track analysis failure so you can investigate in Firebase console.
// //  */
// // export async function trackAnalysisError(userId, transactionId, errorMessage) {
// //   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// // }

// // /**
// //  * Track report download.
// //  */
// // export async function trackReportDownload(userId, analysisId) {
// //   await trackEvent(userId, "report_downloaded", { analysisId });
// //   await incrementUserStat(userId, "totalDownloads");
// // }

// // /**
// //  * Track service card click on dashboard intro.
// //  */
// // export async function trackServiceClick(userId, serviceCode) {
// //   await trackEvent(userId, "service_selected", { serviceCode });
// // }

// // /**
// //  * Track payment modal opened.
// //  */
// // export async function trackPaymentModalOpened(userId, serviceCode) {
// //   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// // }

// // /**
// //  * Track payment failure.
// //  */
// // export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
// //   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// // }

// // // ─────────────────────────────────────────────
// // // COVER LETTER
// // // ─────────────────────────────────────────────

// // /**
// //  * Mark cover letter as generated for a transaction.
// //  * Increments coverLetterUsedCount — respects the per-plan limit.
// //  */
// // export async function markCoverLetterGenerated(userId, transactionId) {
// //   try {
// //     const ref = doc(db, "users", userId, "transactions", transactionId);
// //     await updateDoc(ref, {
// //       coverLetterGenerated:   true,
// //       coverLetterUsedCount:   increment(1),
// //       coverLetterGeneratedAt: serverTimestamp(),
// //     });
// //     await incrementUserStat(userId, "totalCoverLetters");
// //     await trackEvent(userId, "cover_letter_generated", { transactionId });
// //     console.log("✅ Cover letter marked as generated:", transactionId);
// //   } catch (err) {
// //     console.error("❌ markCoverLetterGenerated error:", err);
// //     throw err;
// //   }
// // }

// // /**
// //  * Check if user has cover letter generation remaining.
// //  * Returns { eligible, transactionId, remaining, limit }
// //  */
// // export async function getCoverLetterEligibility(userId) {
// //   try {
// //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// //     const paid = snap.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .filter(t => t.status === "paid")
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     for (const tx of paid) {
// //       const used  = tx.coverLetterUsedCount || 0;
// //       const limit = tx.coverLetterCount     || 1;
// //       if (used < limit) {
// //         return {
// //           eligible:      true,
// //           transactionId: tx.id,
// //           planId:        normalizePlanId(tx.planId),
// //           remaining:     limit - used,
// //           limit,
// //         };
// //       }
// //     }
// //     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
// //   } catch (err) {
// //     console.error("getCoverLetterEligibility error:", err);
// //     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // GENERATED DOCUMENTS — resumes + cover letters
// // // Saved to Firestore, available for 30 days
// // // ─────────────────────────────────────────────

// // const DOCS_TTL_DAYS = 30;

// // /**
// //  * Save a generated resume to Firestore.
// //  * Stores the full resume JSON + template info for re-download.
// //  */
// // export async function saveGeneratedResume(userId, { resumeData, templateId, transactionId, planId }) {
// //   try {
// //     if (!userId) throw new Error("No userId provided to saveGeneratedResume");
// //     if (!resumeData) throw new Error("No resumeData provided to saveGeneratedResume");

// //     const expiresAt = new Date();
// //     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

// //     const docData = {
// //       type:          "resume",
// //       templateId:    templateId    || "classic",
// //       planId:        planId        || "ats_basic",
// //       transactionId: transactionId || null,
// //       resumeData:    resumeData,
// //       createdAt:     serverTimestamp(),
// //       expiresAt:     expiresAt.toISOString(),
// //     };

// //     console.log("💾 Saving resume to Firestore for user:", userId, "template:", templateId);
// //     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), docData);
// //     console.log("✅ Resume saved to generatedDocs:", ref.id);
// //     return ref.id;
// //   } catch (err) {
// //     console.error("❌ saveGeneratedResume FAILED:", err.message, err);
// //     throw err;
// //   }
// // }

// // /**
// //  * Save a generated cover letter to Firestore.
// //  * Stores full letter JSON (opening, body1, body2, closing etc).
// //  */
// // export async function saveGeneratedCoverLetter(userId, { letterData, tone, transactionId, planId }) {
// //   try {
// //     if (!userId) throw new Error("No userId provided to saveGeneratedCoverLetter");
// //     if (!letterData) throw new Error("No letterData provided to saveGeneratedCoverLetter");

// //     const expiresAt = new Date();
// //     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

// //     const docData = {
// //       type:          "cover_letter",
// //       tone:          tone          || "professional",
// //       planId:        planId        || "ats_basic",
// //       transactionId: transactionId || null,
// //       letterData:    letterData,
// //       createdAt:     serverTimestamp(),
// //       expiresAt:     expiresAt.toISOString(),
// //     };

// //     console.log("💾 Saving cover letter to Firestore for user:", userId, "tone:", tone);
// //     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), docData);
// //     console.log("✅ Cover letter saved to generatedDocs:", ref.id);
// //     return ref.id;
// //   } catch (err) {
// //     console.error("❌ saveGeneratedCoverLetter FAILED:", err.message, err);
// //     throw err;
// //   }
// // }

// // /**
// //  * Get all generated docs for a user (resumes + cover letters).
// //  * Filters out expired docs (older than 30 days).
// //  */
// // export async function getUserGeneratedDocs(userId) {
// //   try {
// //     const snap = await getDocs(collection(db, "users", userId, "generatedDocs"));
// //     const now  = new Date();
// //     return snap.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .filter(doc => {
// //         if (!doc.expiresAt) return true; // keep docs without expiry
// //         return new Date(doc.expiresAt) > now;
// //       })
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// //   } catch (err) {
// //     console.error("getUserGeneratedDocs error:", err);
// //     return [];
// //   }
// // }

// // /**
// //  * Get only generated resumes.
// //  */
// // export async function getUserGeneratedResumes(userId) {
// //   const docs = await getUserGeneratedDocs(userId);
// //   return docs.filter(d => d.type === "resume");
// // }

// // /**
// //  * Get only generated cover letters.
// //  */
// // export async function getUserGeneratedCoverLetters(userId) {
// //   const docs = await getUserGeneratedDocs(userId);
// //   return docs.filter(d => d.type === "cover_letter");
// // }

// import {
//   collection,
//   addDoc,
//   getDocs,
//   doc,
//   setDoc,
//   getDoc,
//   updateDoc,
//   serverTimestamp,
//   query,
//   where,
//   orderBy,
//   limit,
//   increment,
// } from "firebase/firestore";
// import { db } from "./firebase";
// import servicesConfig from "./servicesConfig";

// // ── Normalize legacy planIds saved as service codes ──
// const LEGACY_PLAN_MAP = {
//   "ATS_ANALYSIS":        "ats_basic",
//   "ATS_RESUME_SAMPLE":   "ats_basic",
//   "ATS_RESUME_IMPROVED": "ats_basic",
//   "DOCUMENT_SUMMARY":    "doc_pro",
//   "DOCUMENT_CHAT":       "doc_pro",
// };
// function normalizePlanId(planId) {
//   if (!planId) return "ats_basic";
//   return LEGACY_PLAN_MAP[planId] || planId;
// }

// // ─────────────────────────────────────────────
// // TRACKING HELPERS
// // ─────────────────────────────────────────────

// /**
//  * Write a tracking event to users/{uid}/events subcollection.
//  * Never throws — tracking must never break the main flow.
//  */
// async function trackEvent(userId, eventName, data = {}) {
//   if (!userId) return;
//   try {
//     await addDoc(collection(db, "users", userId, "events"), {
//       event:     eventName,
//       ...data,
//       timestamp: serverTimestamp(),
//     });
//   } catch (err) {
//     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
//   }
// }

// /**
//  * Increment a counter on the user's top-level document.
//  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
//  */
// async function incrementUserStat(userId, field, by = 1) {
//   if (!userId) return;
//   try {
//     await setDoc(
//       doc(db, "users", userId),
//       { [field]: increment(by) },
//       { merge: true }
//     );
//   } catch (err) {
//     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
//   }
// }

// // ─────────────────────────────────────────────
// // TRANSACTIONS
// // ─────────────────────────────────────────────

// /**
//  * Save a new verified transaction after Stripe payment succeeds.
//  * Deduplicates by paymentIntentId — safe to call multiple times.
//  */
// export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
//   try {
//     // ── Deduplicate: don't create a second record for the same payment ──
//     const existing = await getDocs(
//       query(
//         collection(db, "users", userId, "transactions"),
//         where("paymentIntentId", "==", paymentIntentId)
//       )
//     );
//     if (!existing.empty) {
//       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
//       return existing.docs[0].id;
//     }

//     // ── Default includes to planId if not provided ──
//     const serviceIncludes = includes || [planId];

//     // Get plan limits from config
//     const limits = getPlanLimits(planId);

//     // ── Snapshot plan name from config at time of purchase ──
//     const planConfig = servicesConfig.plans.find(p => p.id === planId);

//     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
//       paymentIntentId,
//       planId,
//       planName:                paymentMeta.planName  || planConfig?.name  || planId,
//       // Price frozen at payment time — never re-read from config
//       amountPaid:              paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,  // cents
//       amountDisplay:           paymentMeta.amountDisplay ?? planConfig?.price         ?? "",  // "$1.99"
//       currency:                paymentMeta.currency  || "usd",
//       includes:                serviceIncludes,
//       status:                  "paid",
//       analysed:                false,
//       analysisUsedCount:       0,
//       analysisCount:           limits.analysisCount,
//       resumeGenerated:         false,
//       resumeGenCount:          limits.resumeGenCount,
//       // ── Cover letter tracking ──
//       coverLetterGenerated:    false,
//       coverLetterCount:        limits.coverLetterCount || 1,
//       coverLetterUsedCount:    0,
//       createdAt:               serverTimestamp(),
//     });

//     // ── Track payment event ──
//     await trackEvent(userId, "payment_completed", {
//       paymentIntentId,
//       planId,
//       includes:      serviceIncludes,
//       transactionId: ref.id,
//     });

//     // ── Increment user payment counter ──
//     await incrementUserStat(userId, "totalPayments");

//     // ── Update user last paid timestamp ──
//     await setDoc(
//       doc(db, "users", userId),
//       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
//       { merge: true }
//     );

//     console.log("✅ Transaction saved:", ref.id);
//     return ref.id;

//   } catch (err) {
//     console.error("❌ saveTransaction error:", err);
//     throw err;
//   }
// }

// /**
//  * Mark a transaction as analysed (analysis complete).
//  */
// export async function markTransactionComplete(userId, transactionId) {
//   if (!userId || !transactionId) {
//     console.error("❌ markTransactionComplete: missing params");
//     return;
//   }
//   try {
//     const ref = doc(db, "users", userId, "transactions", transactionId);
//     const snap = await getDoc(ref);
//     if (!snap.exists()) {
//       console.error("❌ Transaction not found:", transactionId);
//       return;
//     }

//     const data        = snap.data();
//     const newCount    = (data.analysisUsedCount || 0) + 1;
//     // Always read limit from config — don't trust stale Firebase value
//     const planLimits  = getPlanLimits(data.planId);
//     const maxCount    = planLimits.analysisCount;
//     const analysedAll = newCount >= maxCount;

//     await setDoc(ref, {
//       status:            "paid",
//       analysed:          true,
//       completedAt:       serverTimestamp(),
//       analysisUsedCount: newCount,
//       analysisCount:     maxCount,      // patch it in case it was missing
//       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
//       analysedAll,
//     }, { merge: true });

//     // ── Track analysis completion event ──
//     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

//     // ── Increment user analysis counter ──
//     await incrementUserStat(userId, "totalAnalyses");

//     // ── Update user last analysed timestamp ──
//     await setDoc(
//       doc(db, "users", userId),
//       { lastAnalysisAt: serverTimestamp() },
//       { merge: true }
//     );

//     console.log("✅ Transaction marked complete:", transactionId);

//   } catch (err) {
//     console.error("❌ markTransactionComplete error:", err.message);
//     throw err;
//   }
// }

// /**
//  * Mark resume as generated for a transaction.
//  */
// export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
//   if (!userId || !transactionId) {
//     console.error("❌ markResumeGenerated: missing params");
//     return;
//   }
//   try {
//     const ref = doc(db, "users", userId, "transactions", transactionId);
//     await setDoc(ref, {
//       resumeGenerated:    true,
//       resumeGeneratedAt:  serverTimestamp(),
//       resumeTemplateId:   templateId,   // ← track which template was used
//     }, { merge: true });

//     // ── Track resume generation event with template ──
//     await trackEvent(userId, "resume_generated", {
//       transactionId,
//       templateId,
//     });

//     // ── Increment user resume counter ──
//     await incrementUserStat(userId, "totalResumesGenerated");

//     // ── Update user last resume timestamp + template ──
//     await setDoc(
//       doc(db, "users", userId),
//       {
//         lastResumeGeneratedAt: serverTimestamp(),
//         lastResumeTemplateId:  templateId,
//       },
//       { merge: true }
//     );

//     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

//   } catch (err) {
//     console.error("❌ markResumeGenerated error:", err);
//   }
// }

// /**
//  * Get pending transaction — paid but NOT yet analysed.
//  */
// export async function getPendingTransaction(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return null;

//     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//     const pending = all
//       .filter(t => t.status === "paid" && t.analysed === false)
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     if (pending.length === 0) return null;

//     console.log("✅ Pending transaction found:", pending[0].id);
//     return pending[0];

//   } catch (err) {
//     console.error("❌ getPendingTransaction error:", err);
//     return null;
//   }
// }

// /**
//  * Get most recent completed transaction — paid AND analysed.
//  */
// export async function getCompletedTransaction(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return null;

//     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//     const completed = all
//       .filter(t => t.status === "paid" && t.analysed === true)
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     if (completed.length === 0) return null;

//     console.log("✅ Completed transaction found:", completed[0].id);
//     return completed[0];

//   } catch (err) {
//     console.error("❌ getCompletedTransaction error:", err);
//     return null;
//   }
// }

// /**
//  * Get all transactions for a user (most recent first, max 50).
//  */
// export async function getAllTransactions(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return [];
//     return snapshot.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
//       .slice(0, 50);
//   } catch (err) {
//     console.error("❌ getAllTransactions error:", err);
//     return [];
//   }
// }

// // ─────────────────────────────────────────────
// // ANALYSES
// // ─────────────────────────────────────────────

// /**
//  * Get most recent analysis for a user.
//  */
// export async function getLastAnalysis(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "analyses")
//     );
//     if (snapshot.empty) return null;

//     const sorted = snapshot.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     console.log("✅ Last analysis found");
//     return sorted[0];

//   } catch (err) {
//     console.error("❌ getLastAnalysis error:", err);
//     return null;
//   }
// }

// /**
//  * Get all analyses for a user (most recent first, max 20).
//  */
// export async function getAllAnalyses(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "analyses")
//     );
//     if (snapshot.empty) return [];

//     return snapshot.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
//       .slice(0, 20);

//   } catch (err) {
//     console.error("❌ getAllAnalyses error:", err);
//     return [];
//   }
// }

// // ─────────────────────────────────────────────
// // GENERATED RESUMES
// // ─────────────────────────────────────────────

// /**
//  * Check if user is eligible for free resume generation.
//  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
//  */
// export async function getFreeResumeEligibility(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

//     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

//     // All paid transactions sorted newest first
//     const paidTransactions = all
//       .filter(t => t.status === "paid")
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     if (paidTransactions.length === 0) {
//       return { eligible: false, transactionId: null, planId: "ats_basic" };
//     }

//     // Always use the most recent paid plan for template access
//     // normalizePlanId handles old transactions saved with service code as planId
//     const mostRecentPlan = normalizePlanId(paidTransactions[0].planId) || "ats_basic";
//     const mostRecentIncludes = paidTransactions[0].includes || [];

//     // Find any analysed transaction where resume has NOT been generated yet
//     // Resume unlock: user must have done at least 1 analysis
//     const unusedAnalysis = all
//       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     if (unusedAnalysis.length === 0) {
//       // No eligible transaction — but still return planId so templates show correctly
//       console.log("No unused analysis found");
//       return {
//         eligible:      false,
//         transactionId: null,
//         planId:        mostRecentPlan,
//         includes:      mostRecentIncludes,
//       };
//     }

//     // Use the most recent unused analysis transaction
//     const eligible = unusedAnalysis[0];
//     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
//     return {
//       eligible:      true,
//       transactionId: eligible.id,
//       planId:        normalizePlanId(eligible.planId) || mostRecentPlan,
//       includes:      eligible.includes || mostRecentIncludes,
//     };

//   } catch (err) {
//     console.error("getFreeResumeEligibility error:", err);
//     return { eligible: false, transactionId: null, planId: "ats_basic" };
//   }
// }

// // ─────────────────────────────────────────────
// // PLAN LIMITS — reads from servicesConfig
// // ─────────────────────────────────────────────

// export function getPlanLimits(planId) {
//   const id   = normalizePlanId(planId);
//   const plan = servicesConfig.plans.find(p => p.id === id);
//   const limits = {
//     analysisCount:    plan?.analysisCount    ?? 2,
//     resumeGenCount:   plan?.resumeGenCount   ?? 1,
//     coverLetterCount: plan?.coverLetterCount ?? 1,
//   };
//   console.log(`📊 getPlanLimits(${planId}):`, limits);
//   return limits;
// }

// /**
//  * Get full usage status for a transaction.
//  * Used by dashboard to show analysis counter + generate button state.
//  */
// export async function getTransactionUsage(userId, transactionId) {
//   if (!userId || !transactionId) return null;
//   try {
//     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
//     if (!snap.exists()) return null;
//     const data    = snap.data();
//     const used   = data.analysisUsedCount || 0;
//     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
//     const limits = getPlanLimits(data.planId);
//     const max    = limits.analysisCount;  // authoritative from config
//     const resumeGenerated = data.resumeGenerated || false;
//     // Once resume is generated — NO more analyses allowed for this transaction
//     // User must pay again for new analyses
//     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
//     const canAnalyzeAgain   = !resumeGenerated && used < max;
//     const canGenerateResume = used > 0 && !resumeGenerated;

//     // ── Cover letter usage ──
//     const coverLetterUsed      = data.coverLetterUsedCount || 0;
//     const coverLetterLimit     = data.coverLetterCount     || limits.coverLetterCount || 1;
//     const coverLetterRemaining = Math.max(0, coverLetterLimit - coverLetterUsed);

//     return {
//       transactionId,
//       planId:                data.planId,
//       analysisUsedCount:     used,
//       analysisCount:         max,
//       analysisRemaining:     resumeGenerated ? 0 : Math.max(0, max - used),
//       canAnalyzeAgain,
//       resumeGenerated,
//       resumeGenCount:        limits.resumeGenCount,
//       canGenerateResume,
//       resumeTemplateId:      data.resumeTemplateId || null,
//       coverLetterRemaining,
//       coverLetterGenerated:  data.coverLetterGenerated || false,
//       // Analyses list for selection modal
//       analyses:              [],  // populated separately
//     };
//   } catch (err) {
//     console.error("❌ getTransactionUsage error:", err);
//     return null;
//   }
// }

// /**
//  * Get all paid transaction usages for a user.
//  */
// export async function getAllTransactionUsages(userId) {
//   if (!userId) return [];
//   try {
//     const snap = await getDocs(collection(db, "users", userId, "transactions"));
//     return snap.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .filter(t => t.status === "paid" || t.status === "completed")
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
//   } catch (err) {
//     console.error("❌ getAllTransactionUsages error:", err);
//     return [];
//   }
// }

// /**
//  * Get the latest generated resume for a user.
//  */
// export async function getLatestGeneratedResume(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "generatedResumes")
//     );
//     if (snapshot.empty) return null;

//     const sorted = snapshot.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     console.log("✅ Latest generated resume found");
//     return sorted[0]?.resumeData || null;

//   } catch (err) {
//     console.error("❌ getLatestGeneratedResume error:", err);
//     return null;
//   }
// }

// // ─────────────────────────────────────────────
// // SERVICE ACCESS
// // ─────────────────────────────────────────────

// /**
//  * Check if user has access to a specific service from any of their transactions.
//  * Works for single services AND bundles.
//  */
// export async function hasServiceAccess(userId, serviceCode) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return false;

//     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//     return transactions.some(t => {
//       if (t.status !== "paid") return false;
//       // Direct service match
//       if (t.serviceCode === serviceCode) return true;
//       // Bundle match — check includes array
//       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
//       return false;
//     });
//   } catch (err) {
//     console.error("❌ hasServiceAccess error:", err);
//     return false;
//   }
// }

// /**
//  * Get pending transaction for a specific service.
//  * Works for both direct service and bundle.
//  */
// export async function getPendingTransactionForService(userId, serviceCode) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return null;

//     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//     const pending = all.filter(t => {
//       if (t.status !== "paid" || t.analysed !== false) return false;
//       if (t.serviceCode === serviceCode) return true;
//       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
//       return false;
//     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     return pending[0] || null;
//   } catch (err) {
//     console.error("❌ getPendingTransactionForService error:", err);
//     return null;
//   }
// }

// // ─────────────────────────────────────────────
// // SUPPORT TICKETS
// // ─────────────────────────────────────────────

// /**
//  * Save a support ticket.
//  */
// export async function saveSupportTicket(userId, ticketData) {
//   try {
//     const ref = await addDoc(collection(db, "supportTickets"), {
//       userId:    userId || null,
//       firstName: ticketData.firstName,
//       lastName:  ticketData.lastName,
//       email:     ticketData.email,
//       topic:     ticketData.topic,
//       message:   ticketData.message,
//       status:    "open",
//       createdAt: serverTimestamp(),
//       updatedAt: serverTimestamp(),
//       date:      new Date().toISOString().split("T")[0],
//     });

//     // ── Track support ticket event ──
//     if (userId) {
//       await trackEvent(userId, "support_ticket_created", {
//         ticketId: ref.id,
//         topic:    ticketData.topic,
//       });
//     }

//     console.log("✅ Support ticket saved:", ref.id);
//     return ref.id;

//   } catch (err) {
//     console.error("❌ saveSupportTicket error:", err);
//     return null;
//   }
// }

// /**
//  * Get all support tickets for a user.
//  * Uses a proper Firestore query instead of fetching all and filtering client-side.
//  */
// export async function getUserSupportTickets(userId) {
//   try {
//     const q = query(
//       collection(db, "supportTickets"),
//       where("userId", "==", userId),
//       orderBy("createdAt", "desc"),
//       limit(50)
//     );
//     const snapshot = await getDocs(q);
//     if (snapshot.empty) return [];
//     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//   } catch (err) {
//     console.error("❌ getUserSupportTickets error:", err);
//     return [];
//   }
// }

// // ─────────────────────────────────────────────
// // SESSION / PAGE TRACKING
// // ─────────────────────────────────────────────

// /**
//  * Track a page view or dashboard step visit.
//  * Call this from key screens: dashboard intro, upload, results, etc.
//  */
// export async function trackPageView(userId, page, extra = {}) {
//   await trackEvent(userId, "page_view", { page, ...extra });
// }

// /**
//  * Track a user action (button clicks, downloads, etc.)
//  */
// export async function trackUserAction(userId, action, extra = {}) {
//   await trackEvent(userId, action, extra);
// }

// /**
//  * Track analysis start — called when user clicks "Analyze My Resume".
//  */
// export async function trackAnalysisStart(userId, transactionId) {
//   await trackEvent(userId, "analysis_started", { transactionId });
//   await setDoc(
//     doc(db, "users", userId),
//     { lastActivityAt: serverTimestamp() },
//     { merge: true }
//   );
// }

// /**
//  * Track analysis failure so you can investigate in Firebase console.
//  */
// export async function trackAnalysisError(userId, transactionId, errorMessage) {
//   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// }

// /**
//  * Track report download.
//  */
// export async function trackReportDownload(userId, analysisId) {
//   await trackEvent(userId, "report_downloaded", { analysisId });
//   await incrementUserStat(userId, "totalDownloads");
// }

// /**
//  * Track service card click on dashboard intro.
//  */
// export async function trackServiceClick(userId, serviceCode) {
//   await trackEvent(userId, "service_selected", { serviceCode });
// }

// /**
//  * Track payment modal opened.
//  */
// export async function trackPaymentModalOpened(userId, serviceCode) {
//   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// }

// /**
//  * Track payment failure.
//  */
// export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
//   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// }

// // ─────────────────────────────────────────────
// // COVER LETTER
// // ─────────────────────────────────────────────

// /**
//  * Mark cover letter as generated for a transaction.
//  * Increments coverLetterUsedCount — respects the per-plan limit.
//  */
// export async function markCoverLetterGenerated(userId, transactionId) {
//   try {
//     const ref = doc(db, "users", userId, "transactions", transactionId);
//     await updateDoc(ref, {
//       coverLetterGenerated:   true,
//       coverLetterUsedCount:   increment(1),
//       coverLetterGeneratedAt: serverTimestamp(),
//     });
//     await incrementUserStat(userId, "totalCoverLetters");
//     await trackEvent(userId, "cover_letter_generated", { transactionId });
//     console.log("✅ Cover letter marked as generated:", transactionId);
//   } catch (err) {
//     console.error("❌ markCoverLetterGenerated error:", err);
//     throw err;
//   }
// }

// /**
//  * Check if user has cover letter generation remaining.
//  * Returns { eligible, transactionId, remaining, limit }
//  */
// export async function getCoverLetterEligibility(userId) {
//   try {
//     const snap = await getDocs(collection(db, "users", userId, "transactions"));
//     const paid = snap.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .filter(t => t.status === "paid")
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     for (const tx of paid) {
//       const used  = tx.coverLetterUsedCount || 0;
//       const limit = tx.coverLetterCount     || 1;
//       if (used < limit) {
//         return {
//           eligible:      true,
//           transactionId: tx.id,
//           planId:        normalizePlanId(tx.planId),
//           remaining:     limit - used,
//           limit,
//         };
//       }
//     }
//     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
//   } catch (err) {
//     console.error("getCoverLetterEligibility error:", err);
//     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
//   }
// }

// // ─────────────────────────────────────────────
// // GENERATED DOCUMENTS — resumes + cover letters
// // Saved to Firestore, available for 30 days
// // ─────────────────────────────────────────────

// const DOCS_TTL_DAYS = 30;

// /**
//  * Save a generated resume to Firestore.
//  * Stores the full resume JSON + template info for re-download.
//  */
// export async function saveGeneratedResume(userId, { resumeData, templateId, transactionId, planId }) {
//   try {
//     if (!userId) throw new Error("No userId provided to saveGeneratedResume");
//     if (!resumeData) throw new Error("No resumeData provided to saveGeneratedResume");

//     const expiresAt = new Date();
//     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

//     const docData = {
//       type:          "resume",
//       templateId:    templateId    || "classic",
//       planId:        planId        || "ats_basic",
//       transactionId: transactionId || null,
//       resumeData:    resumeData,
//       createdAt:     serverTimestamp(),
//       expiresAt:     expiresAt.toISOString(),
//     };

//     console.log("💾 Saving resume to Firestore for user:", userId, "template:", templateId);
//     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), docData);
//     console.log("✅ Resume saved to generatedDocs:", ref.id);
//     return ref.id;
//   } catch (err) {
//     console.error("❌ saveGeneratedResume FAILED:", err.message, err);
//     throw err;
//   }
// }

// /**
//  * Save a generated cover letter to Firestore.
//  * Stores full letter JSON (opening, body1, body2, closing etc).
//  */
// export async function saveGeneratedCoverLetter(userId, { letterData, tone, transactionId, planId }) {
//   try {
//     if (!userId) throw new Error("No userId provided to saveGeneratedCoverLetter");
//     if (!letterData) throw new Error("No letterData provided to saveGeneratedCoverLetter");

//     const expiresAt = new Date();
//     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

//     const docData = {
//       type:          "cover_letter",
//       tone:          tone          || "professional",
//       planId:        planId        || "ats_basic",
//       transactionId: transactionId || null,
//       letterData:    letterData,
//       createdAt:     serverTimestamp(),
//       expiresAt:     expiresAt.toISOString(),
//     };

//     console.log("💾 Saving cover letter to Firestore for user:", userId, "tone:", tone);
//     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), docData);
//     console.log("✅ Cover letter saved to generatedDocs:", ref.id);
//     return ref.id;
//   } catch (err) {
//     console.error("❌ saveGeneratedCoverLetter FAILED:", err.message, err);
//     throw err;
//   }
// }

// /**
//  * Get all generated docs for a user (resumes + cover letters).
//  * Filters out expired docs (older than 30 days).
//  */
// export async function getUserGeneratedDocs(userId) {
//   try {
//     const snap = await getDocs(collection(db, "users", userId, "generatedDocs"));
//     const now  = new Date();
//     return snap.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .filter(doc => {
//         if (!doc.expiresAt) return true; // keep docs without expiry
//         return new Date(doc.expiresAt) > now;
//       })
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
//   } catch (err) {
//     console.error("getUserGeneratedDocs error:", err);
//     return [];
//   }
// }

// /**
//  * Get only generated resumes.
//  */
// export async function getUserGeneratedResumes(userId) {
//   const docs = await getUserGeneratedDocs(userId);
//   return docs.filter(d => d.type === "resume");
// }

// /**
//  * Get only generated cover letters.
//  */
// export async function getUserGeneratedCoverLetters(userId) {
//   const docs = await getUserGeneratedDocs(userId);
//   return docs.filter(d => d.type === "cover_letter");
// }


//new code in the evening
// // // // // import {
// // // // //   collection,
// // // // //   addDoc,
// // // // //   getDocs,
// // // // //   doc,
// // // // //   setDoc,
// // // // //   getDoc,
// // // // //   serverTimestamp,
// // // // //   query,
// // // // //   where,
// // // // //   orderBy,
// // // // //   limit,
// // // // //   increment,
// // // // // } from "firebase/firestore";
// // // // // import { db } from "./firebase";
// // // // // import servicesConfig from "./servicesConfig";

// // // // // // ─────────────────────────────────────────────
// // // // // // TRACKING HELPERS
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Write a tracking event to users/{uid}/events subcollection.
// // // // //  * Never throws — tracking must never break the main flow.
// // // // //  */
// // // // // async function trackEvent(userId, eventName, data = {}) {
// // // // //   if (!userId) return;
// // // // //   try {
// // // // //     await addDoc(collection(db, "users", userId, "events"), {
// // // // //       event:     eventName,
// // // // //       ...data,
// // // // //       timestamp: serverTimestamp(),
// // // // //     });
// // // // //   } catch (err) {
// // // // //     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Increment a counter on the user's top-level document.
// // // // //  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
// // // // //  */
// // // // // async function incrementUserStat(userId, field, by = 1) {
// // // // //   if (!userId) return;
// // // // //   try {
// // // // //     await setDoc(
// // // // //       doc(db, "users", userId),
// // // // //       { [field]: increment(by) },
// // // // //       { merge: true }
// // // // //     );
// // // // //   } catch (err) {
// // // // //     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // TRANSACTIONS
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Save a new verified transaction after Stripe payment succeeds.
// // // // //  * Deduplicates by paymentIntentId — safe to call multiple times.
// // // // //  */
// // // // // export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null) {
// // // // //   try {
// // // // //     // ── Deduplicate: don't create a second record for the same payment ──
// // // // //     const existing = await getDocs(
// // // // //       query(
// // // // //         collection(db, "users", userId, "transactions"),
// // // // //         where("paymentIntentId", "==", paymentIntentId)
// // // // //       )
// // // // //     );
// // // // //     if (!existing.empty) {
// // // // //       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
// // // // //       return existing.docs[0].id;
// // // // //     }

// // // // //     // ── Default includes to planId if not provided ──
// // // // //     const serviceIncludes = includes || [planId];

// // // // //     // Get plan limits from config
// // // // //     const limits = getPlanLimits(planId);

// // // // //     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
// // // // //       paymentIntentId,
// // // // //       planId,
// // // // //       includes:          serviceIncludes,
// // // // //       status:            "paid",
// // // // //       analysed:          false,
// // // // //       analysisUsedCount: 0,
// // // // //       analysisCount:     limits.analysisCount,
// // // // //       resumeGenerated:   false,
// // // // //       resumeGenCount:    limits.resumeGenCount,
// // // // //       createdAt:         serverTimestamp(),
// // // // //     });

// // // // //     // ── Track payment event ──
// // // // //     await trackEvent(userId, "payment_completed", {
// // // // //       paymentIntentId,
// // // // //       planId,
// // // // //       includes:      serviceIncludes,
// // // // //       transactionId: ref.id,
// // // // //     });

// // // // //     // ── Increment user payment counter ──
// // // // //     await incrementUserStat(userId, "totalPayments");

// // // // //     // ── Update user last paid timestamp ──
// // // // //     await setDoc(
// // // // //       doc(db, "users", userId),
// // // // //       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
// // // // //       { merge: true }
// // // // //     );

// // // // //     console.log("✅ Transaction saved:", ref.id);
// // // // //     return ref.id;

// // // // //   } catch (err) {
// // // // //     console.error("❌ saveTransaction error:", err);
// // // // //     throw err;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Mark a transaction as analysed (analysis complete).
// // // // //  */
// // // // // export async function markTransactionComplete(userId, transactionId) {
// // // // //   if (!userId || !transactionId) {
// // // // //     console.error("❌ markTransactionComplete: missing params");
// // // // //     return;
// // // // //   }
// // // // //   try {
// // // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // // //     const snap = await getDoc(ref);
// // // // //     if (!snap.exists()) {
// // // // //       console.error("❌ Transaction not found:", transactionId);
// // // // //       return;
// // // // //     }

// // // // //     const data        = snap.data();
// // // // //     const newCount    = (data.analysisUsedCount || 0) + 1;
// // // // //     // Always read limit from config — don't trust stale Firebase value
// // // // //     const planLimits  = getPlanLimits(data.planId);
// // // // //     const maxCount    = planLimits.analysisCount;
// // // // //     const analysedAll = newCount >= maxCount;

// // // // //     await setDoc(ref, {
// // // // //       status:            "paid",
// // // // //       analysed:          true,
// // // // //       completedAt:       serverTimestamp(),
// // // // //       analysisUsedCount: newCount,
// // // // //       analysisCount:     maxCount,      // patch it in case it was missing
// // // // //       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
// // // // //       analysedAll,
// // // // //     }, { merge: true });

// // // // //     // ── Track analysis completion event ──
// // // // //     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

// // // // //     // ── Increment user analysis counter ──
// // // // //     await incrementUserStat(userId, "totalAnalyses");

// // // // //     // ── Update user last analysed timestamp ──
// // // // //     await setDoc(
// // // // //       doc(db, "users", userId),
// // // // //       { lastAnalysisAt: serverTimestamp() },
// // // // //       { merge: true }
// // // // //     );

// // // // //     console.log("✅ Transaction marked complete:", transactionId);

// // // // //   } catch (err) {
// // // // //     console.error("❌ markTransactionComplete error:", err.message);
// // // // //     throw err;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Mark resume as generated for a transaction.
// // // // //  */
// // // // // export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
// // // // //   if (!userId || !transactionId) {
// // // // //     console.error("❌ markResumeGenerated: missing params");
// // // // //     return;
// // // // //   }
// // // // //   try {
// // // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // // //     await setDoc(ref, {
// // // // //       resumeGenerated:    true,
// // // // //       resumeGeneratedAt:  serverTimestamp(),
// // // // //       resumeTemplateId:   templateId,   // ← track which template was used
// // // // //     }, { merge: true });

// // // // //     // ── Track resume generation event with template ──
// // // // //     await trackEvent(userId, "resume_generated", {
// // // // //       transactionId,
// // // // //       templateId,
// // // // //     });

// // // // //     // ── Increment user resume counter ──
// // // // //     await incrementUserStat(userId, "totalResumesGenerated");

// // // // //     // ── Update user last resume timestamp + template ──
// // // // //     await setDoc(
// // // // //       doc(db, "users", userId),
// // // // //       {
// // // // //         lastResumeGeneratedAt: serverTimestamp(),
// // // // //         lastResumeTemplateId:  templateId,
// // // // //       },
// // // // //       { merge: true }
// // // // //     );

// // // // //     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

// // // // //   } catch (err) {
// // // // //     console.error("❌ markResumeGenerated error:", err);
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get pending transaction — paid but NOT yet analysed.
// // // // //  */
// // // // // export async function getPendingTransaction(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //     const pending = all
// // // // //       .filter(t => t.status === "paid" && t.analysed === false)
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     if (pending.length === 0) return null;

// // // // //     console.log("✅ Pending transaction found:", pending[0].id);
// // // // //     return pending[0];

// // // // //   } catch (err) {
// // // // //     console.error("❌ getPendingTransaction error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get most recent completed transaction — paid AND analysed.
// // // // //  */
// // // // // export async function getCompletedTransaction(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //     const completed = all
// // // // //       .filter(t => t.status === "paid" && t.analysed === true)
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     if (completed.length === 0) return null;

// // // // //     console.log("✅ Completed transaction found:", completed[0].id);
// // // // //     return completed[0];

// // // // //   } catch (err) {
// // // // //     console.error("❌ getCompletedTransaction error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get all transactions for a user (most recent first, max 50).
// // // // //  */
// // // // // export async function getAllTransactions(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return [];
// // // // //     return snapshot.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // // //       .slice(0, 50);
// // // // //   } catch (err) {
// // // // //     console.error("❌ getAllTransactions error:", err);
// // // // //     return [];
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // ANALYSES
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Get most recent analysis for a user.
// // // // //  */
// // // // // export async function getLastAnalysis(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "analyses")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const sorted = snapshot.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     console.log("✅ Last analysis found");
// // // // //     return sorted[0];

// // // // //   } catch (err) {
// // // // //     console.error("❌ getLastAnalysis error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get all analyses for a user (most recent first, max 20).
// // // // //  */
// // // // // export async function getAllAnalyses(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "analyses")
// // // // //     );
// // // // //     if (snapshot.empty) return [];

// // // // //     return snapshot.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // // //       .slice(0, 20);

// // // // //   } catch (err) {
// // // // //     console.error("❌ getAllAnalyses error:", err);
// // // // //     return [];
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // GENERATED RESUMES
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Check if user is eligible for free resume generation.
// // // // //  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
// // // // //  */
// // // // // export async function getFreeResumeEligibility(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

// // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

// // // // //     // All paid transactions sorted newest first
// // // // //     const paidTransactions = all
// // // // //       .filter(t => t.status === "paid")
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     if (paidTransactions.length === 0) {
// // // // //       return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // // //     }

// // // // //     // Always use the most recent paid plan for template access
// // // // //     const mostRecentPlan = paidTransactions[0].planId || "ats_basic";
// // // // //     const mostRecentIncludes = paidTransactions[0].includes || [];

// // // // //     // Find any analysed transaction where resume has NOT been generated yet
// // // // //     // Resume unlock: user must have done at least 1 analysis
// // // // //     const unusedAnalysis = all
// // // // //       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     if (unusedAnalysis.length === 0) {
// // // // //       // No eligible transaction — but still return planId so templates show correctly
// // // // //       console.log("No unused analysis found");
// // // // //       return {
// // // // //         eligible:      false,
// // // // //         transactionId: null,
// // // // //         planId:        mostRecentPlan,
// // // // //         includes:      mostRecentIncludes,
// // // // //       };
// // // // //     }

// // // // //     // Use the most recent unused analysis transaction
// // // // //     const eligible = unusedAnalysis[0];
// // // // //     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
// // // // //     return {
// // // // //       eligible:      true,
// // // // //       transactionId: eligible.id,
// // // // //       planId:        eligible.planId || mostRecentPlan,
// // // // //       includes:      eligible.includes || mostRecentIncludes,
// // // // //     };

// // // // //   } catch (err) {
// // // // //     console.error("getFreeResumeEligibility error:", err);
// // // // //     return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // PLAN LIMITS — reads from servicesConfig
// // // // // // ─────────────────────────────────────────────

// // // // // export function getPlanLimits(planId) {
// // // // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // // // //   const limits = {
// // // // //     analysisCount:  plan?.analysisCount  ?? 2,  // default 2 if not found
// // // // //     resumeGenCount: plan?.resumeGenCount ?? 1,
// // // // //   };
// // // // //   console.log(`📊 getPlanLimits(${planId}):`, limits);
// // // // //   return limits;
// // // // // }

// // // // // /**
// // // // //  * Get full usage status for a transaction.
// // // // //  * Used by dashboard to show analysis counter + generate button state.
// // // // //  */
// // // // // export async function getTransactionUsage(userId, transactionId) {
// // // // //   if (!userId || !transactionId) return null;
// // // // //   try {
// // // // //     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
// // // // //     if (!snap.exists()) return null;
// // // // //     const data    = snap.data();
// // // // //     const used   = data.analysisUsedCount || 0;
// // // // //     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
// // // // //     const limits = getPlanLimits(data.planId);
// // // // //     const max    = limits.analysisCount;  // authoritative from config
// // // // //     const resumeGenerated = data.resumeGenerated || false;
// // // // //     // Once resume is generated — NO more analyses allowed for this transaction
// // // // //     // User must pay again for new analyses
// // // // //     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
// // // // //     const canAnalyzeAgain   = !resumeGenerated && used < max;
// // // // //     // canGenerateResume: true after at least 1 analysis, even if more analyses remain
// // // // //     // User can choose to generate anytime after first analysis
// // // // //     const canGenerateResume = used > 0 && !resumeGenerated;
// // // // //     return {
// // // // //       transactionId,
// // // // //       planId:            data.planId,
// // // // //       analysisUsedCount: used,
// // // // //       analysisCount:     max,
// // // // //       analysisRemaining: resumeGenerated ? 0 : Math.max(0, max - used),
// // // // //       canAnalyzeAgain,
// // // // //       resumeGenerated,
// // // // //       resumeGenCount:    limits.resumeGenCount,
// // // // //       canGenerateResume,
// // // // //       resumeTemplateId:  data.resumeTemplateId || null,
// // // // //       // Analyses list for selection modal
// // // // //       analyses:          [],  // populated separately
// // // // //     };
// // // // //   } catch (err) {
// // // // //     console.error("❌ getTransactionUsage error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get all paid transaction usages for a user.
// // // // //  */
// // // // // export async function getAllTransactionUsages(userId) {
// // // // //   if (!userId) return [];
// // // // //   try {
// // // // //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// // // // //     return snap.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .filter(t => t.status === "paid" || t.status === "completed")
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// // // // //   } catch (err) {
// // // // //     console.error("❌ getAllTransactionUsages error:", err);
// // // // //     return [];
// // // // //   }
// // // // // }

// // // // // export async function saveGeneratedResume(userId, transactionId, resumeData) {
// // // // //   try {
// // // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // // //     await setDoc(ref, {
// // // // //       resumeData,
// // // // //       transactionId,
// // // // //       createdAt: serverTimestamp(),
// // // // //     });
// // // // //     console.log("✅ Generated resume saved:", transactionId);
// // // // //   } catch (err) {
// // // // //     console.error("❌ saveGeneratedResume error:", err);
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get a saved generated resume by transactionId.
// // // // //  */
// // // // // export async function getGeneratedResume(userId, transactionId) {
// // // // //   try {
// // // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // // //     const snap = await getDoc(ref);
// // // // //     if (snap.exists()) {
// // // // //       console.log("✅ Generated resume found");
// // // // //       return snap.data().resumeData;
// // // // //     }
// // // // //     return null;
// // // // //   } catch (err) {
// // // // //     console.error("❌ getGeneratedResume error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get the latest generated resume for a user.
// // // // //  */
// // // // // export async function getLatestGeneratedResume(userId) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "generatedResumes")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const sorted = snapshot.docs
// // // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     console.log("✅ Latest generated resume found");
// // // // //     return sorted[0]?.resumeData || null;

// // // // //   } catch (err) {
// // // // //     console.error("❌ getLatestGeneratedResume error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // SERVICE ACCESS
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Check if user has access to a specific service from any of their transactions.
// // // // //  * Works for single services AND bundles.
// // // // //  */
// // // // // export async function hasServiceAccess(userId, serviceCode) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return false;

// // // // //     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //     return transactions.some(t => {
// // // // //       if (t.status !== "paid") return false;
// // // // //       // Direct service match
// // // // //       if (t.serviceCode === serviceCode) return true;
// // // // //       // Bundle match — check includes array
// // // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // // //       return false;
// // // // //     });
// // // // //   } catch (err) {
// // // // //     console.error("❌ hasServiceAccess error:", err);
// // // // //     return false;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get pending transaction for a specific service.
// // // // //  * Works for both direct service and bundle.
// // // // //  */
// // // // // export async function getPendingTransactionForService(userId, serviceCode) {
// // // // //   try {
// // // // //     const snapshot = await getDocs(
// // // // //       collection(db, "users", userId, "transactions")
// // // // //     );
// // // // //     if (snapshot.empty) return null;

// // // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //     const pending = all.filter(t => {
// // // // //       if (t.status !== "paid" || t.analysed !== false) return false;
// // // // //       if (t.serviceCode === serviceCode) return true;
// // // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // // //       return false;
// // // // //     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // // //     return pending[0] || null;
// // // // //   } catch (err) {
// // // // //     console.error("❌ getPendingTransactionForService error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // SUPPORT TICKETS
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Save a support ticket.
// // // // //  */
// // // // // export async function saveSupportTicket(userId, ticketData) {
// // // // //   try {
// // // // //     const ref = await addDoc(collection(db, "supportTickets"), {
// // // // //       userId:    userId || null,
// // // // //       firstName: ticketData.firstName,
// // // // //       lastName:  ticketData.lastName,
// // // // //       email:     ticketData.email,
// // // // //       topic:     ticketData.topic,
// // // // //       message:   ticketData.message,
// // // // //       status:    "open",
// // // // //       createdAt: serverTimestamp(),
// // // // //       updatedAt: serverTimestamp(),
// // // // //       date:      new Date().toISOString().split("T")[0],
// // // // //     });

// // // // //     // ── Track support ticket event ──
// // // // //     if (userId) {
// // // // //       await trackEvent(userId, "support_ticket_created", {
// // // // //         ticketId: ref.id,
// // // // //         topic:    ticketData.topic,
// // // // //       });
// // // // //     }

// // // // //     console.log("✅ Support ticket saved:", ref.id);
// // // // //     return ref.id;

// // // // //   } catch (err) {
// // // // //     console.error("❌ saveSupportTicket error:", err);
// // // // //     return null;
// // // // //   }
// // // // // }

// // // // // /**
// // // // //  * Get all support tickets for a user.
// // // // //  * Uses a proper Firestore query instead of fetching all and filtering client-side.
// // // // //  */
// // // // // export async function getUserSupportTickets(userId) {
// // // // //   try {
// // // // //     const q = query(
// // // // //       collection(db, "supportTickets"),
// // // // //       where("userId", "==", userId),
// // // // //       orderBy("createdAt", "desc"),
// // // // //       limit(50)
// // // // //     );
// // // // //     const snapshot = await getDocs(q);
// // // // //     if (snapshot.empty) return [];
// // // // //     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // // //   } catch (err) {
// // // // //     console.error("❌ getUserSupportTickets error:", err);
// // // // //     return [];
// // // // //   }
// // // // // }

// // // // // // ─────────────────────────────────────────────
// // // // // // SESSION / PAGE TRACKING
// // // // // // ─────────────────────────────────────────────

// // // // // /**
// // // // //  * Track a page view or dashboard step visit.
// // // // //  * Call this from key screens: dashboard intro, upload, results, etc.
// // // // //  */
// // // // // export async function trackPageView(userId, page, extra = {}) {
// // // // //   await trackEvent(userId, "page_view", { page, ...extra });
// // // // // }

// // // // // /**
// // // // //  * Track a user action (button clicks, downloads, etc.)
// // // // //  */
// // // // // export async function trackUserAction(userId, action, extra = {}) {
// // // // //   await trackEvent(userId, action, extra);
// // // // // }

// // // // // /**
// // // // //  * Track analysis start — called when user clicks "Analyze My Resume".
// // // // //  */
// // // // // export async function trackAnalysisStart(userId, transactionId) {
// // // // //   await trackEvent(userId, "analysis_started", { transactionId });
// // // // //   await setDoc(
// // // // //     doc(db, "users", userId),
// // // // //     { lastActivityAt: serverTimestamp() },
// // // // //     { merge: true }
// // // // //   );
// // // // // }

// // // // // /**
// // // // //  * Track analysis failure so you can investigate in Firebase console.
// // // // //  */
// // // // // export async function trackAnalysisError(userId, transactionId, errorMessage) {
// // // // //   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// // // // // }

// // // // // /**
// // // // //  * Track report download.
// // // // //  */
// // // // // export async function trackReportDownload(userId, analysisId) {
// // // // //   await trackEvent(userId, "report_downloaded", { analysisId });
// // // // //   await incrementUserStat(userId, "totalDownloads");
// // // // // }

// // // // // /**
// // // // //  * Track service card click on dashboard intro.
// // // // //  */
// // // // // export async function trackServiceClick(userId, serviceCode) {
// // // // //   await trackEvent(userId, "service_selected", { serviceCode });
// // // // // }

// // // // // /**
// // // // //  * Track payment modal opened.
// // // // //  */
// // // // // export async function trackPaymentModalOpened(userId, serviceCode) {
// // // // //   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// // // // // }

// // // // // /**
// // // // //  * Track payment failure.
// // // // //  */
// // // // // export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
// // // // //   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// // // // // }

// // // // import {
// // // //   collection,
// // // //   addDoc,
// // // //   getDocs,
// // // //   doc,
// // // //   setDoc,
// // // //   getDoc,
// // // //   serverTimestamp,
// // // //   query,
// // // //   where,
// // // //   orderBy,
// // // //   limit,
// // // //   increment,
// // // // } from "firebase/firestore";
// // // // import { db } from "./firebase";
// // // // import servicesConfig from "./servicesConfig";

// // // // // ─────────────────────────────────────────────
// // // // // TRACKING HELPERS
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Write a tracking event to users/{uid}/events subcollection.
// // // //  * Never throws — tracking must never break the main flow.
// // // //  */
// // // // async function trackEvent(userId, eventName, data = {}) {
// // // //   if (!userId) return;
// // // //   try {
// // // //     await addDoc(collection(db, "users", userId, "events"), {
// // // //       event:     eventName,
// // // //       ...data,
// // // //       timestamp: serverTimestamp(),
// // // //     });
// // // //   } catch (err) {
// // // //     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
// // // //   }
// // // // }

// // // // /**
// // // //  * Increment a counter on the user's top-level document.
// // // //  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
// // // //  */
// // // // async function incrementUserStat(userId, field, by = 1) {
// // // //   if (!userId) return;
// // // //   try {
// // // //     await setDoc(
// // // //       doc(db, "users", userId),
// // // //       { [field]: increment(by) },
// // // //       { merge: true }
// // // //     );
// // // //   } catch (err) {
// // // //     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // TRANSACTIONS
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Save a new verified transaction after Stripe payment succeeds.
// // // //  * Deduplicates by paymentIntentId — safe to call multiple times.
// // // //  */
// // // // export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
// // // //   try {
// // // //     // ── Deduplicate: don't create a second record for the same payment ──
// // // //     const existing = await getDocs(
// // // //       query(
// // // //         collection(db, "users", userId, "transactions"),
// // // //         where("paymentIntentId", "==", paymentIntentId)
// // // //       )
// // // //     );
// // // //     if (!existing.empty) {
// // // //       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
// // // //       return existing.docs[0].id;
// // // //     }

// // // //     // ── Default includes to planId if not provided ──
// // // //     const serviceIncludes = includes || [planId];

// // // //     // Get plan limits from config
// // // //     const limits = getPlanLimits(planId);

// // // //     // ── Snapshot plan name from config at time of purchase ──
// // // //     const planConfig = servicesConfig.plans.find(p => p.id === planId);

// // // //     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
// // // //       paymentIntentId,
// // // //       planId,
// // // //       planName:          paymentMeta.planName  || planConfig?.name  || planId,
// // // //       // Price frozen at payment time — never re-read from config
// // // //       amountPaid:        paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,  // cents
// // // //       amountDisplay:     paymentMeta.amountDisplay ?? planConfig?.price         ?? "",  // "$1.99"
// // // //       currency:          paymentMeta.currency  || "usd",
// // // //       includes:          serviceIncludes,
// // // //       status:            "paid",
// // // //       analysed:          false,
// // // //       analysisUsedCount: 0,
// // // //       analysisCount:     limits.analysisCount,
// // // //       resumeGenerated:   false,
// // // //       resumeGenCount:    limits.resumeGenCount,
// // // //       createdAt:         serverTimestamp(),
// // // //     });

// // // //     // ── Track payment event ──
// // // //     await trackEvent(userId, "payment_completed", {
// // // //       paymentIntentId,
// // // //       planId,
// // // //       includes:      serviceIncludes,
// // // //       transactionId: ref.id,
// // // //     });

// // // //     // ── Increment user payment counter ──
// // // //     await incrementUserStat(userId, "totalPayments");

// // // //     // ── Update user last paid timestamp ──
// // // //     await setDoc(
// // // //       doc(db, "users", userId),
// // // //       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
// // // //       { merge: true }
// // // //     );

// // // //     console.log("✅ Transaction saved:", ref.id);
// // // //     return ref.id;

// // // //   } catch (err) {
// // // //     console.error("❌ saveTransaction error:", err);
// // // //     throw err;
// // // //   }
// // // // }

// // // // /**
// // // //  * Mark a transaction as analysed (analysis complete).
// // // //  */
// // // // export async function markTransactionComplete(userId, transactionId) {
// // // //   if (!userId || !transactionId) {
// // // //     console.error("❌ markTransactionComplete: missing params");
// // // //     return;
// // // //   }
// // // //   try {
// // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // //     const snap = await getDoc(ref);
// // // //     if (!snap.exists()) {
// // // //       console.error("❌ Transaction not found:", transactionId);
// // // //       return;
// // // //     }

// // // //     const data        = snap.data();
// // // //     const newCount    = (data.analysisUsedCount || 0) + 1;
// // // //     // Always read limit from config — don't trust stale Firebase value
// // // //     const planLimits  = getPlanLimits(data.planId);
// // // //     const maxCount    = planLimits.analysisCount;
// // // //     const analysedAll = newCount >= maxCount;

// // // //     await setDoc(ref, {
// // // //       status:            "paid",
// // // //       analysed:          true,
// // // //       completedAt:       serverTimestamp(),
// // // //       analysisUsedCount: newCount,
// // // //       analysisCount:     maxCount,      // patch it in case it was missing
// // // //       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
// // // //       analysedAll,
// // // //     }, { merge: true });

// // // //     // ── Track analysis completion event ──
// // // //     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

// // // //     // ── Increment user analysis counter ──
// // // //     await incrementUserStat(userId, "totalAnalyses");

// // // //     // ── Update user last analysed timestamp ──
// // // //     await setDoc(
// // // //       doc(db, "users", userId),
// // // //       { lastAnalysisAt: serverTimestamp() },
// // // //       { merge: true }
// // // //     );

// // // //     console.log("✅ Transaction marked complete:", transactionId);

// // // //   } catch (err) {
// // // //     console.error("❌ markTransactionComplete error:", err.message);
// // // //     throw err;
// // // //   }
// // // // }

// // // // /**
// // // //  * Mark resume as generated for a transaction.
// // // //  */
// // // // export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
// // // //   if (!userId || !transactionId) {
// // // //     console.error("❌ markResumeGenerated: missing params");
// // // //     return;
// // // //   }
// // // //   try {
// // // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // // //     await setDoc(ref, {
// // // //       resumeGenerated:    true,
// // // //       resumeGeneratedAt:  serverTimestamp(),
// // // //       resumeTemplateId:   templateId,   // ← track which template was used
// // // //     }, { merge: true });

// // // //     // ── Track resume generation event with template ──
// // // //     await trackEvent(userId, "resume_generated", {
// // // //       transactionId,
// // // //       templateId,
// // // //     });

// // // //     // ── Increment user resume counter ──
// // // //     await incrementUserStat(userId, "totalResumesGenerated");

// // // //     // ── Update user last resume timestamp + template ──
// // // //     await setDoc(
// // // //       doc(db, "users", userId),
// // // //       {
// // // //         lastResumeGeneratedAt: serverTimestamp(),
// // // //         lastResumeTemplateId:  templateId,
// // // //       },
// // // //       { merge: true }
// // // //     );

// // // //     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

// // // //   } catch (err) {
// // // //     console.error("❌ markResumeGenerated error:", err);
// // // //   }
// // // // }

// // // // /**
// // // //  * Get pending transaction — paid but NOT yet analysed.
// // // //  */
// // // // export async function getPendingTransaction(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //     const pending = all
// // // //       .filter(t => t.status === "paid" && t.analysed === false)
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     if (pending.length === 0) return null;

// // // //     console.log("✅ Pending transaction found:", pending[0].id);
// // // //     return pending[0];

// // // //   } catch (err) {
// // // //     console.error("❌ getPendingTransaction error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get most recent completed transaction — paid AND analysed.
// // // //  */
// // // // export async function getCompletedTransaction(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //     const completed = all
// // // //       .filter(t => t.status === "paid" && t.analysed === true)
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     if (completed.length === 0) return null;

// // // //     console.log("✅ Completed transaction found:", completed[0].id);
// // // //     return completed[0];

// // // //   } catch (err) {
// // // //     console.error("❌ getCompletedTransaction error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get all transactions for a user (most recent first, max 50).
// // // //  */
// // // // export async function getAllTransactions(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return [];
// // // //     return snapshot.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // //       .slice(0, 50);
// // // //   } catch (err) {
// // // //     console.error("❌ getAllTransactions error:", err);
// // // //     return [];
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // ANALYSES
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Get most recent analysis for a user.
// // // //  */
// // // // export async function getLastAnalysis(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "analyses")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const sorted = snapshot.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     console.log("✅ Last analysis found");
// // // //     return sorted[0];

// // // //   } catch (err) {
// // // //     console.error("❌ getLastAnalysis error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get all analyses for a user (most recent first, max 20).
// // // //  */
// // // // export async function getAllAnalyses(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "analyses")
// // // //     );
// // // //     if (snapshot.empty) return [];

// // // //     return snapshot.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // // //       .slice(0, 20);

// // // //   } catch (err) {
// // // //     console.error("❌ getAllAnalyses error:", err);
// // // //     return [];
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // GENERATED RESUMES
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Check if user is eligible for free resume generation.
// // // //  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
// // // //  */
// // // // export async function getFreeResumeEligibility(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

// // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

// // // //     // All paid transactions sorted newest first
// // // //     const paidTransactions = all
// // // //       .filter(t => t.status === "paid")
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     if (paidTransactions.length === 0) {
// // // //       return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // //     }

// // // //     // Always use the most recent paid plan for template access
// // // //     const mostRecentPlan = paidTransactions[0].planId || "ats_basic";
// // // //     const mostRecentIncludes = paidTransactions[0].includes || [];

// // // //     // Find any analysed transaction where resume has NOT been generated yet
// // // //     // Resume unlock: user must have done at least 1 analysis
// // // //     const unusedAnalysis = all
// // // //       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     if (unusedAnalysis.length === 0) {
// // // //       // No eligible transaction — but still return planId so templates show correctly
// // // //       console.log("No unused analysis found");
// // // //       return {
// // // //         eligible:      false,
// // // //         transactionId: null,
// // // //         planId:        mostRecentPlan,
// // // //         includes:      mostRecentIncludes,
// // // //       };
// // // //     }

// // // //     // Use the most recent unused analysis transaction
// // // //     const eligible = unusedAnalysis[0];
// // // //     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
// // // //     return {
// // // //       eligible:      true,
// // // //       transactionId: eligible.id,
// // // //       planId:        eligible.planId || mostRecentPlan,
// // // //       includes:      eligible.includes || mostRecentIncludes,
// // // //     };

// // // //   } catch (err) {
// // // //     console.error("getFreeResumeEligibility error:", err);
// // // //     return { eligible: false, transactionId: null, planId: "ats_basic" };
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // PLAN LIMITS — reads from servicesConfig
// // // // // ─────────────────────────────────────────────

// // // // export function getPlanLimits(planId) {
// // // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // // //   const limits = {
// // // //     analysisCount:  plan?.analysisCount  ?? 2,  // default 2 if not found
// // // //     resumeGenCount: plan?.resumeGenCount ?? 1,
// // // //   };
// // // //   console.log(`📊 getPlanLimits(${planId}):`, limits);
// // // //   return limits;
// // // // }

// // // // /**
// // // //  * Get full usage status for a transaction.
// // // //  * Used by dashboard to show analysis counter + generate button state.
// // // //  */
// // // // export async function getTransactionUsage(userId, transactionId) {
// // // //   if (!userId || !transactionId) return null;
// // // //   try {
// // // //     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
// // // //     if (!snap.exists()) return null;
// // // //     const data    = snap.data();
// // // //     const used   = data.analysisUsedCount || 0;
// // // //     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
// // // //     const limits = getPlanLimits(data.planId);
// // // //     const max    = limits.analysisCount;  // authoritative from config
// // // //     const resumeGenerated = data.resumeGenerated || false;
// // // //     // Once resume is generated — NO more analyses allowed for this transaction
// // // //     // User must pay again for new analyses
// // // //     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
// // // //     const canAnalyzeAgain   = !resumeGenerated && used < max;
// // // //     // canGenerateResume: true after at least 1 analysis, even if more analyses remain
// // // //     // User can choose to generate anytime after first analysis
// // // //     const canGenerateResume = used > 0 && !resumeGenerated;
// // // //     return {
// // // //       transactionId,
// // // //       planId:            data.planId,
// // // //       analysisUsedCount: used,
// // // //       analysisCount:     max,
// // // //       analysisRemaining: resumeGenerated ? 0 : Math.max(0, max - used),
// // // //       canAnalyzeAgain,
// // // //       resumeGenerated,
// // // //       resumeGenCount:    limits.resumeGenCount,
// // // //       canGenerateResume,
// // // //       resumeTemplateId:  data.resumeTemplateId || null,
// // // //       // Analyses list for selection modal
// // // //       analyses:          [],  // populated separately
// // // //     };
// // // //   } catch (err) {
// // // //     console.error("❌ getTransactionUsage error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get all paid transaction usages for a user.
// // // //  */
// // // // export async function getAllTransactionUsages(userId) {
// // // //   if (!userId) return [];
// // // //   try {
// // // //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// // // //     return snap.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .filter(t => t.status === "paid" || t.status === "completed")
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// // // //   } catch (err) {
// // // //     console.error("❌ getAllTransactionUsages error:", err);
// // // //     return [];
// // // //   }
// // // // }

// // // // export async function saveGeneratedResume(userId, transactionId, resumeData) {
// // // //   try {
// // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // //     await setDoc(ref, {
// // // //       resumeData,
// // // //       transactionId,
// // // //       createdAt: serverTimestamp(),
// // // //     });
// // // //     console.log("✅ Generated resume saved:", transactionId);
// // // //   } catch (err) {
// // // //     console.error("❌ saveGeneratedResume error:", err);
// // // //   }
// // // // }

// // // // /**
// // // //  * Get a saved generated resume by transactionId.
// // // //  */
// // // // export async function getGeneratedResume(userId, transactionId) {
// // // //   try {
// // // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // // //     const snap = await getDoc(ref);
// // // //     if (snap.exists()) {
// // // //       console.log("✅ Generated resume found");
// // // //       return snap.data().resumeData;
// // // //     }
// // // //     return null;
// // // //   } catch (err) {
// // // //     console.error("❌ getGeneratedResume error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get the latest generated resume for a user.
// // // //  */
// // // // export async function getLatestGeneratedResume(userId) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "generatedResumes")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const sorted = snapshot.docs
// // // //       .map(d => ({ id: d.id, ...d.data() }))
// // // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     console.log("✅ Latest generated resume found");
// // // //     return sorted[0]?.resumeData || null;

// // // //   } catch (err) {
// // // //     console.error("❌ getLatestGeneratedResume error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // SERVICE ACCESS
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Check if user has access to a specific service from any of their transactions.
// // // //  * Works for single services AND bundles.
// // // //  */
// // // // export async function hasServiceAccess(userId, serviceCode) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return false;

// // // //     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //     return transactions.some(t => {
// // // //       if (t.status !== "paid") return false;
// // // //       // Direct service match
// // // //       if (t.serviceCode === serviceCode) return true;
// // // //       // Bundle match — check includes array
// // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // //       return false;
// // // //     });
// // // //   } catch (err) {
// // // //     console.error("❌ hasServiceAccess error:", err);
// // // //     return false;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get pending transaction for a specific service.
// // // //  * Works for both direct service and bundle.
// // // //  */
// // // // export async function getPendingTransactionForService(userId, serviceCode) {
// // // //   try {
// // // //     const snapshot = await getDocs(
// // // //       collection(db, "users", userId, "transactions")
// // // //     );
// // // //     if (snapshot.empty) return null;

// // // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //     const pending = all.filter(t => {
// // // //       if (t.status !== "paid" || t.analysed !== false) return false;
// // // //       if (t.serviceCode === serviceCode) return true;
// // // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // // //       return false;
// // // //     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // // //     return pending[0] || null;
// // // //   } catch (err) {
// // // //     console.error("❌ getPendingTransactionForService error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // SUPPORT TICKETS
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Save a support ticket.
// // // //  */
// // // // export async function saveSupportTicket(userId, ticketData) {
// // // //   try {
// // // //     const ref = await addDoc(collection(db, "supportTickets"), {
// // // //       userId:    userId || null,
// // // //       firstName: ticketData.firstName,
// // // //       lastName:  ticketData.lastName,
// // // //       email:     ticketData.email,
// // // //       topic:     ticketData.topic,
// // // //       message:   ticketData.message,
// // // //       status:    "open",
// // // //       createdAt: serverTimestamp(),
// // // //       updatedAt: serverTimestamp(),
// // // //       date:      new Date().toISOString().split("T")[0],
// // // //     });

// // // //     // ── Track support ticket event ──
// // // //     if (userId) {
// // // //       await trackEvent(userId, "support_ticket_created", {
// // // //         ticketId: ref.id,
// // // //         topic:    ticketData.topic,
// // // //       });
// // // //     }

// // // //     console.log("✅ Support ticket saved:", ref.id);
// // // //     return ref.id;

// // // //   } catch (err) {
// // // //     console.error("❌ saveSupportTicket error:", err);
// // // //     return null;
// // // //   }
// // // // }

// // // // /**
// // // //  * Get all support tickets for a user.
// // // //  * Uses a proper Firestore query instead of fetching all and filtering client-side.
// // // //  */
// // // // export async function getUserSupportTickets(userId) {
// // // //   try {
// // // //     const q = query(
// // // //       collection(db, "supportTickets"),
// // // //       where("userId", "==", userId),
// // // //       orderBy("createdAt", "desc"),
// // // //       limit(50)
// // // //     );
// // // //     const snapshot = await getDocs(q);
// // // //     if (snapshot.empty) return [];
// // // //     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // // //   } catch (err) {
// // // //     console.error("❌ getUserSupportTickets error:", err);
// // // //     return [];
// // // //   }
// // // // }

// // // // // ─────────────────────────────────────────────
// // // // // SESSION / PAGE TRACKING
// // // // // ─────────────────────────────────────────────

// // // // /**
// // // //  * Track a page view or dashboard step visit.
// // // //  * Call this from key screens: dashboard intro, upload, results, etc.
// // // //  */
// // // // export async function trackPageView(userId, page, extra = {}) {
// // // //   await trackEvent(userId, "page_view", { page, ...extra });
// // // // }

// // // // /**
// // // //  * Track a user action (button clicks, downloads, etc.)
// // // //  */
// // // // export async function trackUserAction(userId, action, extra = {}) {
// // // //   await trackEvent(userId, action, extra);
// // // // }

// // // // /**
// // // //  * Track analysis start — called when user clicks "Analyze My Resume".
// // // //  */
// // // // export async function trackAnalysisStart(userId, transactionId) {
// // // //   await trackEvent(userId, "analysis_started", { transactionId });
// // // //   await setDoc(
// // // //     doc(db, "users", userId),
// // // //     { lastActivityAt: serverTimestamp() },
// // // //     { merge: true }
// // // //   );
// // // // }

// // // // /**
// // // //  * Track analysis failure so you can investigate in Firebase console.
// // // //  */
// // // // export async function trackAnalysisError(userId, transactionId, errorMessage) {
// // // //   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// // // // }

// // // // /**
// // // //  * Track report download.
// // // //  */
// // // // export async function trackReportDownload(userId, analysisId) {
// // // //   await trackEvent(userId, "report_downloaded", { analysisId });
// // // //   await incrementUserStat(userId, "totalDownloads");
// // // // }

// // // // /**
// // // //  * Track service card click on dashboard intro.
// // // //  */
// // // // export async function trackServiceClick(userId, serviceCode) {
// // // //   await trackEvent(userId, "service_selected", { serviceCode });
// // // // }

// // // // /**
// // // //  * Track payment modal opened.
// // // //  */
// // // // export async function trackPaymentModalOpened(userId, serviceCode) {
// // // //   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// // // // }

// // // // /**
// // // //  * Track payment failure.
// // // //  */
// // // // export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
// // // //   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// // // // }

// // // import {
// // //   collection,
// // //   addDoc,
// // //   getDocs,
// // //   doc,
// // //   setDoc,
// // //   getDoc,
// // //   serverTimestamp,
// // //   query,
// // //   where,
// // //   orderBy,
// // //   limit,
// // //   increment,
// // // } from "firebase/firestore";
// // // import { db } from "./firebase";
// // // import servicesConfig from "./servicesConfig";

// // // // ── Normalize legacy planIds saved as service codes ──
// // // const LEGACY_PLAN_MAP = {
// // //   "ATS_ANALYSIS":        "ats_basic",
// // //   "ATS_RESUME_SAMPLE":   "ats_basic",
// // //   "ATS_RESUME_IMPROVED": "ats_basic",
// // //   "DOCUMENT_SUMMARY":    "doc_pro",
// // //   "DOCUMENT_CHAT":       "doc_pro",
// // // };
// // // function normalizePlanId(planId) {
// // //   if (!planId) return "ats_basic";
// // //   return LEGACY_PLAN_MAP[planId] || planId;
// // // }

// // // // ─────────────────────────────────────────────
// // // // TRACKING HELPERS
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Write a tracking event to users/{uid}/events subcollection.
// // //  * Never throws — tracking must never break the main flow.
// // //  */
// // // async function trackEvent(userId, eventName, data = {}) {
// // //   if (!userId) return;
// // //   try {
// // //     await addDoc(collection(db, "users", userId, "events"), {
// // //       event:     eventName,
// // //       ...data,
// // //       timestamp: serverTimestamp(),
// // //     });
// // //   } catch (err) {
// // //     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
// // //   }
// // // }

// // // /**
// // //  * Increment a counter on the user's top-level document.
// // //  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
// // //  */
// // // async function incrementUserStat(userId, field, by = 1) {
// // //   if (!userId) return;
// // //   try {
// // //     await setDoc(
// // //       doc(db, "users", userId),
// // //       { [field]: increment(by) },
// // //       { merge: true }
// // //     );
// // //   } catch (err) {
// // //     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // TRANSACTIONS
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Save a new verified transaction after Stripe payment succeeds.
// // //  * Deduplicates by paymentIntentId — safe to call multiple times.
// // //  */
// // // export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
// // //   try {
// // //     // ── Deduplicate: don't create a second record for the same payment ──
// // //     const existing = await getDocs(
// // //       query(
// // //         collection(db, "users", userId, "transactions"),
// // //         where("paymentIntentId", "==", paymentIntentId)
// // //       )
// // //     );
// // //     if (!existing.empty) {
// // //       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
// // //       return existing.docs[0].id;
// // //     }

// // //     // ── Default includes to planId if not provided ──
// // //     const serviceIncludes = includes || [planId];

// // //     // Get plan limits from config
// // //     const limits = getPlanLimits(planId);

// // //     // ── Snapshot plan name from config at time of purchase ──
// // //     const planConfig = servicesConfig.plans.find(p => p.id === planId);

// // //     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
// // //       paymentIntentId,
// // //       planId,
// // //       planName:          paymentMeta.planName  || planConfig?.name  || planId,
// // //       // Price frozen at payment time — never re-read from config
// // //       amountPaid:        paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,  // cents
// // //       amountDisplay:     paymentMeta.amountDisplay ?? planConfig?.price         ?? "",  // "$1.99"
// // //       currency:          paymentMeta.currency  || "usd",
// // //       includes:          serviceIncludes,
// // //       status:            "paid",
// // //       analysed:          false,
// // //       analysisUsedCount: 0,
// // //       analysisCount:     limits.analysisCount,
// // //       resumeGenerated:   false,
// // //       resumeGenCount:    limits.resumeGenCount,
// // //       createdAt:         serverTimestamp(),
// // //     });

// // //     // ── Track payment event ──
// // //     await trackEvent(userId, "payment_completed", {
// // //       paymentIntentId,
// // //       planId,
// // //       includes:      serviceIncludes,
// // //       transactionId: ref.id,
// // //     });

// // //     // ── Increment user payment counter ──
// // //     await incrementUserStat(userId, "totalPayments");

// // //     // ── Update user last paid timestamp ──
// // //     await setDoc(
// // //       doc(db, "users", userId),
// // //       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
// // //       { merge: true }
// // //     );

// // //     console.log("✅ Transaction saved:", ref.id);
// // //     return ref.id;

// // //   } catch (err) {
// // //     console.error("❌ saveTransaction error:", err);
// // //     throw err;
// // //   }
// // // }

// // // /**
// // //  * Mark a transaction as analysed (analysis complete).
// // //  */
// // // export async function markTransactionComplete(userId, transactionId) {
// // //   if (!userId || !transactionId) {
// // //     console.error("❌ markTransactionComplete: missing params");
// // //     return;
// // //   }
// // //   try {
// // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // //     const snap = await getDoc(ref);
// // //     if (!snap.exists()) {
// // //       console.error("❌ Transaction not found:", transactionId);
// // //       return;
// // //     }

// // //     const data        = snap.data();
// // //     const newCount    = (data.analysisUsedCount || 0) + 1;
// // //     // Always read limit from config — don't trust stale Firebase value
// // //     const planLimits  = getPlanLimits(data.planId);
// // //     const maxCount    = planLimits.analysisCount;
// // //     const analysedAll = newCount >= maxCount;

// // //     await setDoc(ref, {
// // //       status:            "paid",
// // //       analysed:          true,
// // //       completedAt:       serverTimestamp(),
// // //       analysisUsedCount: newCount,
// // //       analysisCount:     maxCount,      // patch it in case it was missing
// // //       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
// // //       analysedAll,
// // //     }, { merge: true });

// // //     // ── Track analysis completion event ──
// // //     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

// // //     // ── Increment user analysis counter ──
// // //     await incrementUserStat(userId, "totalAnalyses");

// // //     // ── Update user last analysed timestamp ──
// // //     await setDoc(
// // //       doc(db, "users", userId),
// // //       { lastAnalysisAt: serverTimestamp() },
// // //       { merge: true }
// // //     );

// // //     console.log("✅ Transaction marked complete:", transactionId);

// // //   } catch (err) {
// // //     console.error("❌ markTransactionComplete error:", err.message);
// // //     throw err;
// // //   }
// // // }

// // // /**
// // //  * Mark resume as generated for a transaction.
// // //  */
// // // export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
// // //   if (!userId || !transactionId) {
// // //     console.error("❌ markResumeGenerated: missing params");
// // //     return;
// // //   }
// // //   try {
// // //     const ref = doc(db, "users", userId, "transactions", transactionId);
// // //     await setDoc(ref, {
// // //       resumeGenerated:    true,
// // //       resumeGeneratedAt:  serverTimestamp(),
// // //       resumeTemplateId:   templateId,   // ← track which template was used
// // //     }, { merge: true });

// // //     // ── Track resume generation event with template ──
// // //     await trackEvent(userId, "resume_generated", {
// // //       transactionId,
// // //       templateId,
// // //     });

// // //     // ── Increment user resume counter ──
// // //     await incrementUserStat(userId, "totalResumesGenerated");

// // //     // ── Update user last resume timestamp + template ──
// // //     await setDoc(
// // //       doc(db, "users", userId),
// // //       {
// // //         lastResumeGeneratedAt: serverTimestamp(),
// // //         lastResumeTemplateId:  templateId,
// // //       },
// // //       { merge: true }
// // //     );

// // //     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

// // //   } catch (err) {
// // //     console.error("❌ markResumeGenerated error:", err);
// // //   }
// // // }

// // // /**
// // //  * Get pending transaction — paid but NOT yet analysed.
// // //  */
// // // export async function getPendingTransaction(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //     const pending = all
// // //       .filter(t => t.status === "paid" && t.analysed === false)
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     if (pending.length === 0) return null;

// // //     console.log("✅ Pending transaction found:", pending[0].id);
// // //     return pending[0];

// // //   } catch (err) {
// // //     console.error("❌ getPendingTransaction error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get most recent completed transaction — paid AND analysed.
// // //  */
// // // export async function getCompletedTransaction(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //     const completed = all
// // //       .filter(t => t.status === "paid" && t.analysed === true)
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     if (completed.length === 0) return null;

// // //     console.log("✅ Completed transaction found:", completed[0].id);
// // //     return completed[0];

// // //   } catch (err) {
// // //     console.error("❌ getCompletedTransaction error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get all transactions for a user (most recent first, max 50).
// // //  */
// // // export async function getAllTransactions(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return [];
// // //     return snapshot.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // //       .slice(0, 50);
// // //   } catch (err) {
// // //     console.error("❌ getAllTransactions error:", err);
// // //     return [];
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // ANALYSES
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Get most recent analysis for a user.
// // //  */
// // // export async function getLastAnalysis(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "analyses")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const sorted = snapshot.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     console.log("✅ Last analysis found");
// // //     return sorted[0];

// // //   } catch (err) {
// // //     console.error("❌ getLastAnalysis error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get all analyses for a user (most recent first, max 20).
// // //  */
// // // export async function getAllAnalyses(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "analyses")
// // //     );
// // //     if (snapshot.empty) return [];

// // //     return snapshot.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// // //       .slice(0, 20);

// // //   } catch (err) {
// // //     console.error("❌ getAllAnalyses error:", err);
// // //     return [];
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // GENERATED RESUMES
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Check if user is eligible for free resume generation.
// // //  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
// // //  */
// // // export async function getFreeResumeEligibility(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

// // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

// // //     // All paid transactions sorted newest first
// // //     const paidTransactions = all
// // //       .filter(t => t.status === "paid")
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     if (paidTransactions.length === 0) {
// // //       return { eligible: false, transactionId: null, planId: "ats_basic" };
// // //     }

// // //     // Always use the most recent paid plan for template access
// // //     // normalizePlanId handles old transactions saved with service code as planId
// // //     const mostRecentPlan = normalizePlanId(paidTransactions[0].planId) || "ats_basic";
// // //     const mostRecentIncludes = paidTransactions[0].includes || [];

// // //     // Find any analysed transaction where resume has NOT been generated yet
// // //     // Resume unlock: user must have done at least 1 analysis
// // //     const unusedAnalysis = all
// // //       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     if (unusedAnalysis.length === 0) {
// // //       // No eligible transaction — but still return planId so templates show correctly
// // //       console.log("No unused analysis found");
// // //       return {
// // //         eligible:      false,
// // //         transactionId: null,
// // //         planId:        mostRecentPlan,
// // //         includes:      mostRecentIncludes,
// // //       };
// // //     }

// // //     // Use the most recent unused analysis transaction
// // //     const eligible = unusedAnalysis[0];
// // //     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
// // //     return {
// // //       eligible:      true,
// // //       transactionId: eligible.id,
// // //       planId:        normalizePlanId(eligible.planId) || mostRecentPlan,
// // //       includes:      eligible.includes || mostRecentIncludes,
// // //     };

// // //   } catch (err) {
// // //     console.error("getFreeResumeEligibility error:", err);
// // //     return { eligible: false, transactionId: null, planId: "ats_basic" };
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // PLAN LIMITS — reads from servicesConfig
// // // // ─────────────────────────────────────────────

// // // export function getPlanLimits(planId) {
// // //   const plan = servicesConfig.plans.find(p => p.id === planId);
// // //   const limits = {
// // //     analysisCount:  plan?.analysisCount  ?? 2,  // default 2 if not found
// // //     resumeGenCount: plan?.resumeGenCount ?? 1,
// // //   };
// // //   console.log(`📊 getPlanLimits(${planId}):`, limits);
// // //   return limits;
// // // }

// // // /**
// // //  * Get full usage status for a transaction.
// // //  * Used by dashboard to show analysis counter + generate button state.
// // //  */
// // // export async function getTransactionUsage(userId, transactionId) {
// // //   if (!userId || !transactionId) return null;
// // //   try {
// // //     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
// // //     if (!snap.exists()) return null;
// // //     const data    = snap.data();
// // //     const used   = data.analysisUsedCount || 0;
// // //     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
// // //     const limits = getPlanLimits(data.planId);
// // //     const max    = limits.analysisCount;  // authoritative from config
// // //     const resumeGenerated = data.resumeGenerated || false;
// // //     // Once resume is generated — NO more analyses allowed for this transaction
// // //     // User must pay again for new analyses
// // //     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
// // //     const canAnalyzeAgain   = !resumeGenerated && used < max;
// // //     // canGenerateResume: true after at least 1 analysis, even if more analyses remain
// // //     // User can choose to generate anytime after first analysis
// // //     const canGenerateResume = used > 0 && !resumeGenerated;
// // //     return {
// // //       transactionId,
// // //       planId:            data.planId,
// // //       analysisUsedCount: used,
// // //       analysisCount:     max,
// // //       analysisRemaining: resumeGenerated ? 0 : Math.max(0, max - used),
// // //       canAnalyzeAgain,
// // //       resumeGenerated,
// // //       resumeGenCount:    limits.resumeGenCount,
// // //       canGenerateResume,
// // //       resumeTemplateId:  data.resumeTemplateId || null,
// // //       // Analyses list for selection modal
// // //       analyses:          [],  // populated separately
// // //     };
// // //   } catch (err) {
// // //     console.error("❌ getTransactionUsage error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get all paid transaction usages for a user.
// // //  */
// // // export async function getAllTransactionUsages(userId) {
// // //   if (!userId) return [];
// // //   try {
// // //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// // //     return snap.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .filter(t => t.status === "paid" || t.status === "completed")
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// // //   } catch (err) {
// // //     console.error("❌ getAllTransactionUsages error:", err);
// // //     return [];
// // //   }
// // // }

// // // export async function saveGeneratedResume(userId, transactionId, resumeData) {
// // //   try {
// // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // //     await setDoc(ref, {
// // //       resumeData,
// // //       transactionId,
// // //       createdAt: serverTimestamp(),
// // //     });
// // //     console.log("✅ Generated resume saved:", transactionId);
// // //   } catch (err) {
// // //     console.error("❌ saveGeneratedResume error:", err);
// // //   }
// // // }

// // // /**
// // //  * Get a saved generated resume by transactionId.
// // //  */
// // // export async function getGeneratedResume(userId, transactionId) {
// // //   try {
// // //     const ref = doc(db, "users", userId, "generatedResumes", transactionId);
// // //     const snap = await getDoc(ref);
// // //     if (snap.exists()) {
// // //       console.log("✅ Generated resume found");
// // //       return snap.data().resumeData;
// // //     }
// // //     return null;
// // //   } catch (err) {
// // //     console.error("❌ getGeneratedResume error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get the latest generated resume for a user.
// // //  */
// // // export async function getLatestGeneratedResume(userId) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "generatedResumes")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const sorted = snapshot.docs
// // //       .map(d => ({ id: d.id, ...d.data() }))
// // //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     console.log("✅ Latest generated resume found");
// // //     return sorted[0]?.resumeData || null;

// // //   } catch (err) {
// // //     console.error("❌ getLatestGeneratedResume error:", err);
// // //     return null;
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // SERVICE ACCESS
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Check if user has access to a specific service from any of their transactions.
// // //  * Works for single services AND bundles.
// // //  */
// // // export async function hasServiceAccess(userId, serviceCode) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return false;

// // //     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //     return transactions.some(t => {
// // //       if (t.status !== "paid") return false;
// // //       // Direct service match
// // //       if (t.serviceCode === serviceCode) return true;
// // //       // Bundle match — check includes array
// // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // //       return false;
// // //     });
// // //   } catch (err) {
// // //     console.error("❌ hasServiceAccess error:", err);
// // //     return false;
// // //   }
// // // }

// // // /**
// // //  * Get pending transaction for a specific service.
// // //  * Works for both direct service and bundle.
// // //  */
// // // export async function getPendingTransactionForService(userId, serviceCode) {
// // //   try {
// // //     const snapshot = await getDocs(
// // //       collection(db, "users", userId, "transactions")
// // //     );
// // //     if (snapshot.empty) return null;

// // //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //     const pending = all.filter(t => {
// // //       if (t.status !== "paid" || t.analysed !== false) return false;
// // //       if (t.serviceCode === serviceCode) return true;
// // //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// // //       return false;
// // //     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// // //     return pending[0] || null;
// // //   } catch (err) {
// // //     console.error("❌ getPendingTransactionForService error:", err);
// // //     return null;
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // SUPPORT TICKETS
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Save a support ticket.
// // //  */
// // // export async function saveSupportTicket(userId, ticketData) {
// // //   try {
// // //     const ref = await addDoc(collection(db, "supportTickets"), {
// // //       userId:    userId || null,
// // //       firstName: ticketData.firstName,
// // //       lastName:  ticketData.lastName,
// // //       email:     ticketData.email,
// // //       topic:     ticketData.topic,
// // //       message:   ticketData.message,
// // //       status:    "open",
// // //       createdAt: serverTimestamp(),
// // //       updatedAt: serverTimestamp(),
// // //       date:      new Date().toISOString().split("T")[0],
// // //     });

// // //     // ── Track support ticket event ──
// // //     if (userId) {
// // //       await trackEvent(userId, "support_ticket_created", {
// // //         ticketId: ref.id,
// // //         topic:    ticketData.topic,
// // //       });
// // //     }

// // //     console.log("✅ Support ticket saved:", ref.id);
// // //     return ref.id;

// // //   } catch (err) {
// // //     console.error("❌ saveSupportTicket error:", err);
// // //     return null;
// // //   }
// // // }

// // // /**
// // //  * Get all support tickets for a user.
// // //  * Uses a proper Firestore query instead of fetching all and filtering client-side.
// // //  */
// // // export async function getUserSupportTickets(userId) {
// // //   try {
// // //     const q = query(
// // //       collection(db, "supportTickets"),
// // //       where("userId", "==", userId),
// // //       orderBy("createdAt", "desc"),
// // //       limit(50)
// // //     );
// // //     const snapshot = await getDocs(q);
// // //     if (snapshot.empty) return [];
// // //     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// // //   } catch (err) {
// // //     console.error("❌ getUserSupportTickets error:", err);
// // //     return [];
// // //   }
// // // }

// // // // ─────────────────────────────────────────────
// // // // SESSION / PAGE TRACKING
// // // // ─────────────────────────────────────────────

// // // /**
// // //  * Track a page view or dashboard step visit.
// // //  * Call this from key screens: dashboard intro, upload, results, etc.
// // //  */
// // // export async function trackPageView(userId, page, extra = {}) {
// // //   await trackEvent(userId, "page_view", { page, ...extra });
// // // }

// // // /**
// // //  * Track a user action (button clicks, downloads, etc.)
// // //  */
// // // export async function trackUserAction(userId, action, extra = {}) {
// // //   await trackEvent(userId, action, extra);
// // // }

// // // /**
// // //  * Track analysis start — called when user clicks "Analyze My Resume".
// // //  */
// // // export async function trackAnalysisStart(userId, transactionId) {
// // //   await trackEvent(userId, "analysis_started", { transactionId });
// // //   await setDoc(
// // //     doc(db, "users", userId),
// // //     { lastActivityAt: serverTimestamp() },
// // //     { merge: true }
// // //   );
// // // }

// // // /**
// // //  * Track analysis failure so you can investigate in Firebase console.
// // //  */
// // // export async function trackAnalysisError(userId, transactionId, errorMessage) {
// // //   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// // // }

// // // /**
// // //  * Track report download.
// // //  */
// // // export async function trackReportDownload(userId, analysisId) {
// // //   await trackEvent(userId, "report_downloaded", { analysisId });
// // //   await incrementUserStat(userId, "totalDownloads");
// // // }

// // // /**
// // //  * Track service card click on dashboard intro.
// // //  */
// // // export async function trackServiceClick(userId, serviceCode) {
// // //   await trackEvent(userId, "service_selected", { serviceCode });
// // // }

// // // /**
// // //  * Track payment modal opened.
// // //  */
// // // export async function trackPaymentModalOpened(userId, serviceCode) {
// // //   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// // // }

// // // /**
// // //  * Track payment failure.
// // //  */
// // // export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
// // //   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// // // }



// // import {
// //   collection,
// //   addDoc,
// //   getDocs,
// //   doc,
// //   setDoc,
// //   getDoc,
// //   updateDoc,
// //   serverTimestamp,
// //   query,
// //   where,
// //   orderBy,
// //   limit,
// //   increment,
// // } from "firebase/firestore";
// // import { db } from "./firebase";
// // import servicesConfig from "./servicesConfig";

// // // ── Normalize legacy planIds saved as service codes ──
// // const LEGACY_PLAN_MAP = {
// //   "ATS_ANALYSIS":        "ats_basic",
// //   "ATS_RESUME_SAMPLE":   "ats_basic",
// //   "ATS_RESUME_IMPROVED": "ats_basic",
// //   "DOCUMENT_SUMMARY":    "doc_pro",
// //   "DOCUMENT_CHAT":       "doc_pro",
// // };
// // function normalizePlanId(planId) {
// //   if (!planId) return "ats_basic";
// //   return LEGACY_PLAN_MAP[planId] || planId;
// // }

// // // ─────────────────────────────────────────────
// // // TRACKING HELPERS
// // // ─────────────────────────────────────────────

// // /**
// //  * Write a tracking event to users/{uid}/events subcollection.
// //  * Never throws — tracking must never break the main flow.
// //  */
// // async function trackEvent(userId, eventName, data = {}) {
// //   if (!userId) return;
// //   try {
// //     await addDoc(collection(db, "users", userId, "events"), {
// //       event:     eventName,
// //       ...data,
// //       timestamp: serverTimestamp(),
// //     });
// //   } catch (err) {
// //     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
// //   }
// // }

// // /**
// //  * Increment a counter on the user's top-level document.
// //  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
// //  */
// // async function incrementUserStat(userId, field, by = 1) {
// //   if (!userId) return;
// //   try {
// //     await setDoc(
// //       doc(db, "users", userId),
// //       { [field]: increment(by) },
// //       { merge: true }
// //     );
// //   } catch (err) {
// //     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // TRANSACTIONS
// // // ─────────────────────────────────────────────

// // /**
// //  * Save a new verified transaction after Stripe payment succeeds.
// //  * Deduplicates by paymentIntentId — safe to call multiple times.
// //  */
// // export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
// //   try {
// //     // ── Deduplicate: don't create a second record for the same payment ──
// //     const existing = await getDocs(
// //       query(
// //         collection(db, "users", userId, "transactions"),
// //         where("paymentIntentId", "==", paymentIntentId)
// //       )
// //     );
// //     if (!existing.empty) {
// //       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
// //       return existing.docs[0].id;
// //     }

// //     // ── Default includes to planId if not provided ──
// //     const serviceIncludes = includes || [planId];

// //     // Get plan limits from config
// //     const limits = getPlanLimits(planId);

// //     // ── Snapshot plan name from config at time of purchase ──
// //     const planConfig = servicesConfig.plans.find(p => p.id === planId);

// //     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
// //       paymentIntentId,
// //       planId,
// //       planName:                paymentMeta.planName  || planConfig?.name  || planId,
// //       // Price frozen at payment time — never re-read from config
// //       amountPaid:              paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,  // cents
// //       amountDisplay:           paymentMeta.amountDisplay ?? planConfig?.price         ?? "",  // "$1.99"
// //       currency:                paymentMeta.currency  || "usd",
// //       includes:                serviceIncludes,
// //       status:                  "paid",
// //       analysed:                false,
// //       analysisUsedCount:       0,
// //       analysisCount:           limits.analysisCount,
// //       resumeGenerated:         false,
// //       resumeGenCount:          limits.resumeGenCount,
// //       // ── Cover letter tracking ──
// //       coverLetterGenerated:    false,
// //       coverLetterCount:        limits.coverLetterCount || 1,
// //       coverLetterUsedCount:    0,
// //       createdAt:               serverTimestamp(),
// //     });

// //     // ── Track payment event ──
// //     await trackEvent(userId, "payment_completed", {
// //       paymentIntentId,
// //       planId,
// //       includes:      serviceIncludes,
// //       transactionId: ref.id,
// //     });

// //     // ── Increment user payment counter ──
// //     await incrementUserStat(userId, "totalPayments");

// //     // ── Update user last paid timestamp ──
// //     await setDoc(
// //       doc(db, "users", userId),
// //       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
// //       { merge: true }
// //     );

// //     console.log("✅ Transaction saved:", ref.id);
// //     return ref.id;

// //   } catch (err) {
// //     console.error("❌ saveTransaction error:", err);
// //     throw err;
// //   }
// // }

// // /**
// //  * Mark a transaction as analysed (analysis complete).
// //  */
// // export async function markTransactionComplete(userId, transactionId) {
// //   if (!userId || !transactionId) {
// //     console.error("❌ markTransactionComplete: missing params");
// //     return;
// //   }
// //   try {
// //     const ref = doc(db, "users", userId, "transactions", transactionId);
// //     const snap = await getDoc(ref);
// //     if (!snap.exists()) {
// //       console.error("❌ Transaction not found:", transactionId);
// //       return;
// //     }

// //     const data        = snap.data();
// //     const newCount    = (data.analysisUsedCount || 0) + 1;
// //     // Always read limit from config — don't trust stale Firebase value
// //     const planLimits  = getPlanLimits(data.planId);
// //     const maxCount    = planLimits.analysisCount;
// //     const analysedAll = newCount >= maxCount;

// //     await setDoc(ref, {
// //       status:            "paid",
// //       analysed:          true,
// //       completedAt:       serverTimestamp(),
// //       analysisUsedCount: newCount,
// //       analysisCount:     maxCount,      // patch it in case it was missing
// //       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
// //       analysedAll,
// //     }, { merge: true });

// //     // ── Track analysis completion event ──
// //     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

// //     // ── Increment user analysis counter ──
// //     await incrementUserStat(userId, "totalAnalyses");

// //     // ── Update user last analysed timestamp ──
// //     await setDoc(
// //       doc(db, "users", userId),
// //       { lastAnalysisAt: serverTimestamp() },
// //       { merge: true }
// //     );

// //     console.log("✅ Transaction marked complete:", transactionId);

// //   } catch (err) {
// //     console.error("❌ markTransactionComplete error:", err.message);
// //     throw err;
// //   }
// // }

// // /**
// //  * Mark resume as generated for a transaction.
// //  */
// // export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
// //   if (!userId || !transactionId) {
// //     console.error("❌ markResumeGenerated: missing params");
// //     return;
// //   }
// //   try {
// //     const ref = doc(db, "users", userId, "transactions", transactionId);
// //     await setDoc(ref, {
// //       resumeGenerated:    true,
// //       resumeGeneratedAt:  serverTimestamp(),
// //       resumeTemplateId:   templateId,   // ← track which template was used
// //     }, { merge: true });

// //     // ── Track resume generation event with template ──
// //     await trackEvent(userId, "resume_generated", {
// //       transactionId,
// //       templateId,
// //     });

// //     // ── Increment user resume counter ──
// //     await incrementUserStat(userId, "totalResumesGenerated");

// //     // ── Update user last resume timestamp + template ──
// //     await setDoc(
// //       doc(db, "users", userId),
// //       {
// //         lastResumeGeneratedAt: serverTimestamp(),
// //         lastResumeTemplateId:  templateId,
// //       },
// //       { merge: true }
// //     );

// //     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

// //   } catch (err) {
// //     console.error("❌ markResumeGenerated error:", err);
// //   }
// // }

// // /**
// //  * Get pending transaction — paid but NOT yet analysed.
// //  */
// // export async function getPendingTransaction(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return null;

// //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //     const pending = all
// //       .filter(t => t.status === "paid" && t.analysed === false)
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     if (pending.length === 0) return null;

// //     console.log("✅ Pending transaction found:", pending[0].id);
// //     return pending[0];

// //   } catch (err) {
// //     console.error("❌ getPendingTransaction error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get most recent completed transaction — paid AND analysed.
// //  */
// // export async function getCompletedTransaction(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return null;

// //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //     const completed = all
// //       .filter(t => t.status === "paid" && t.analysed === true)
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     if (completed.length === 0) return null;

// //     console.log("✅ Completed transaction found:", completed[0].id);
// //     return completed[0];

// //   } catch (err) {
// //     console.error("❌ getCompletedTransaction error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get all transactions for a user (most recent first, max 50).
// //  */
// // export async function getAllTransactions(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return [];
// //     return snapshot.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// //       .slice(0, 50);
// //   } catch (err) {
// //     console.error("❌ getAllTransactions error:", err);
// //     return [];
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // ANALYSES
// // // ─────────────────────────────────────────────

// // /**
// //  * Get most recent analysis for a user.
// //  */
// // export async function getLastAnalysis(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "analyses")
// //     );
// //     if (snapshot.empty) return null;

// //     const sorted = snapshot.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     console.log("✅ Last analysis found");
// //     return sorted[0];

// //   } catch (err) {
// //     console.error("❌ getLastAnalysis error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get all analyses for a user (most recent first, max 20).
// //  */
// // export async function getAllAnalyses(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "analyses")
// //     );
// //     if (snapshot.empty) return [];

// //     return snapshot.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
// //       .slice(0, 20);

// //   } catch (err) {
// //     console.error("❌ getAllAnalyses error:", err);
// //     return [];
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // GENERATED RESUMES
// // // ─────────────────────────────────────────────

// // /**
// //  * Check if user is eligible for free resume generation.
// //  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
// //  */
// // export async function getFreeResumeEligibility(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

// //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

// //     // All paid transactions sorted newest first
// //     const paidTransactions = all
// //       .filter(t => t.status === "paid")
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     if (paidTransactions.length === 0) {
// //       return { eligible: false, transactionId: null, planId: "ats_basic" };
// //     }

// //     // Always use the most recent paid plan for template access
// //     // normalizePlanId handles old transactions saved with service code as planId
// //     const mostRecentPlan = normalizePlanId(paidTransactions[0].planId) || "ats_basic";
// //     const mostRecentIncludes = paidTransactions[0].includes || [];

// //     // Find any analysed transaction where resume has NOT been generated yet
// //     // Resume unlock: user must have done at least 1 analysis
// //     const unusedAnalysis = all
// //       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     if (unusedAnalysis.length === 0) {
// //       // No eligible transaction — but still return planId so templates show correctly
// //       console.log("No unused analysis found");
// //       return {
// //         eligible:      false,
// //         transactionId: null,
// //         planId:        mostRecentPlan,
// //         includes:      mostRecentIncludes,
// //       };
// //     }

// //     // Use the most recent unused analysis transaction
// //     const eligible = unusedAnalysis[0];
// //     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
// //     return {
// //       eligible:      true,
// //       transactionId: eligible.id,
// //       planId:        normalizePlanId(eligible.planId) || mostRecentPlan,
// //       includes:      eligible.includes || mostRecentIncludes,
// //     };

// //   } catch (err) {
// //     console.error("getFreeResumeEligibility error:", err);
// //     return { eligible: false, transactionId: null, planId: "ats_basic" };
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // PLAN LIMITS — reads from servicesConfig
// // // ─────────────────────────────────────────────

// // export function getPlanLimits(planId) {
// //   const id   = normalizePlanId(planId);
// //   const plan = servicesConfig.plans.find(p => p.id === id);
// //   const limits = {
// //     analysisCount:    plan?.analysisCount    ?? 2,
// //     resumeGenCount:   plan?.resumeGenCount   ?? 1,
// //     coverLetterCount: plan?.coverLetterCount ?? 1,
// //   };
// //   console.log(`📊 getPlanLimits(${planId}):`, limits);
// //   return limits;
// // }

// // /**
// //  * Get full usage status for a transaction.
// //  * Used by dashboard to show analysis counter + generate button state.
// //  */
// // export async function getTransactionUsage(userId, transactionId) {
// //   if (!userId || !transactionId) return null;
// //   try {
// //     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
// //     if (!snap.exists()) return null;
// //     const data    = snap.data();
// //     const used   = data.analysisUsedCount || 0;
// //     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
// //     const limits = getPlanLimits(data.planId);
// //     const max    = limits.analysisCount;  // authoritative from config
// //     const resumeGenerated = data.resumeGenerated || false;
// //     // Once resume is generated — NO more analyses allowed for this transaction
// //     // User must pay again for new analyses
// //     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
// //     const canAnalyzeAgain   = !resumeGenerated && used < max;
// //     const canGenerateResume = used > 0 && !resumeGenerated;

// //     // ── Cover letter usage ──
// //     const coverLetterUsed      = data.coverLetterUsedCount || 0;
// //     const coverLetterLimit     = data.coverLetterCount     || limits.coverLetterCount || 1;
// //     const coverLetterRemaining = Math.max(0, coverLetterLimit - coverLetterUsed);

// //     return {
// //       transactionId,
// //       planId:                data.planId,
// //       analysisUsedCount:     used,
// //       analysisCount:         max,
// //       analysisRemaining:     resumeGenerated ? 0 : Math.max(0, max - used),
// //       canAnalyzeAgain,
// //       resumeGenerated,
// //       resumeGenCount:        limits.resumeGenCount,
// //       canGenerateResume,
// //       resumeTemplateId:      data.resumeTemplateId || null,
// //       coverLetterRemaining,
// //       coverLetterGenerated:  data.coverLetterGenerated || false,
// //       // Analyses list for selection modal
// //       analyses:              [],  // populated separately
// //     };
// //   } catch (err) {
// //     console.error("❌ getTransactionUsage error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get all paid transaction usages for a user.
// //  */
// // export async function getAllTransactionUsages(userId) {
// //   if (!userId) return [];
// //   try {
// //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// //     return snap.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .filter(t => t.status === "paid" || t.status === "completed")
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// //   } catch (err) {
// //     console.error("❌ getAllTransactionUsages error:", err);
// //     return [];
// //   }
// // }

// // /**
// //  * Get the latest generated resume for a user.
// //  */
// // export async function getLatestGeneratedResume(userId) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "generatedResumes")
// //     );
// //     if (snapshot.empty) return null;

// //     const sorted = snapshot.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     console.log("✅ Latest generated resume found");
// //     return sorted[0]?.resumeData || null;

// //   } catch (err) {
// //     console.error("❌ getLatestGeneratedResume error:", err);
// //     return null;
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // SERVICE ACCESS
// // // ─────────────────────────────────────────────

// // /**
// //  * Check if user has access to a specific service from any of their transactions.
// //  * Works for single services AND bundles.
// //  */
// // export async function hasServiceAccess(userId, serviceCode) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return false;

// //     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //     return transactions.some(t => {
// //       if (t.status !== "paid") return false;
// //       // Direct service match
// //       if (t.serviceCode === serviceCode) return true;
// //       // Bundle match — check includes array
// //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// //       return false;
// //     });
// //   } catch (err) {
// //     console.error("❌ hasServiceAccess error:", err);
// //     return false;
// //   }
// // }

// // /**
// //  * Get pending transaction for a specific service.
// //  * Works for both direct service and bundle.
// //  */
// // export async function getPendingTransactionForService(userId, serviceCode) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "transactions")
// //     );
// //     if (snapshot.empty) return null;

// //     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //     const pending = all.filter(t => {
// //       if (t.status !== "paid" || t.analysed !== false) return false;
// //       if (t.serviceCode === serviceCode) return true;
// //       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
// //       return false;
// //     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     return pending[0] || null;
// //   } catch (err) {
// //     console.error("❌ getPendingTransactionForService error:", err);
// //     return null;
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // SUPPORT TICKETS
// // // ─────────────────────────────────────────────

// // /**
// //  * Save a support ticket.
// //  */
// // export async function saveSupportTicket(userId, ticketData) {
// //   try {
// //     const ref = await addDoc(collection(db, "supportTickets"), {
// //       userId:    userId || null,
// //       firstName: ticketData.firstName,
// //       lastName:  ticketData.lastName,
// //       email:     ticketData.email,
// //       topic:     ticketData.topic,
// //       message:   ticketData.message,
// //       status:    "open",
// //       createdAt: serverTimestamp(),
// //       updatedAt: serverTimestamp(),
// //       date:      new Date().toISOString().split("T")[0],
// //     });

// //     // ── Track support ticket event ──
// //     if (userId) {
// //       await trackEvent(userId, "support_ticket_created", {
// //         ticketId: ref.id,
// //         topic:    ticketData.topic,
// //       });
// //     }

// //     console.log("✅ Support ticket saved:", ref.id);
// //     return ref.id;

// //   } catch (err) {
// //     console.error("❌ saveSupportTicket error:", err);
// //     return null;
// //   }
// // }

// // /**
// //  * Get all support tickets for a user.
// //  * Uses a proper Firestore query instead of fetching all and filtering client-side.
// //  */
// // export async function getUserSupportTickets(userId) {
// //   try {
// //     const q = query(
// //       collection(db, "supportTickets"),
// //       where("userId", "==", userId),
// //       orderBy("createdAt", "desc"),
// //       limit(50)
// //     );
// //     const snapshot = await getDocs(q);
// //     if (snapshot.empty) return [];
// //     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
// //   } catch (err) {
// //     console.error("❌ getUserSupportTickets error:", err);
// //     return [];
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // SESSION / PAGE TRACKING
// // // ─────────────────────────────────────────────

// // /**
// //  * Track a page view or dashboard step visit.
// //  * Call this from key screens: dashboard intro, upload, results, etc.
// //  */
// // export async function trackPageView(userId, page, extra = {}) {
// //   await trackEvent(userId, "page_view", { page, ...extra });
// // }

// // /**
// //  * Track a user action (button clicks, downloads, etc.)
// //  */
// // export async function trackUserAction(userId, action, extra = {}) {
// //   await trackEvent(userId, action, extra);
// // }

// // /**
// //  * Track analysis start — called when user clicks "Analyze My Resume".
// //  */
// // export async function trackAnalysisStart(userId, transactionId) {
// //   await trackEvent(userId, "analysis_started", { transactionId });
// //   await setDoc(
// //     doc(db, "users", userId),
// //     { lastActivityAt: serverTimestamp() },
// //     { merge: true }
// //   );
// // }

// // /**
// //  * Track analysis failure so you can investigate in Firebase console.
// //  */
// // export async function trackAnalysisError(userId, transactionId, errorMessage) {
// //   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// // }

// // /**
// //  * Track report download.
// //  */
// // export async function trackReportDownload(userId, analysisId) {
// //   await trackEvent(userId, "report_downloaded", { analysisId });
// //   await incrementUserStat(userId, "totalDownloads");
// // }

// // /**
// //  * Track service card click on dashboard intro.
// //  */
// // export async function trackServiceClick(userId, serviceCode) {
// //   await trackEvent(userId, "service_selected", { serviceCode });
// // }

// // /**
// //  * Track payment modal opened.
// //  */
// // export async function trackPaymentModalOpened(userId, serviceCode) {
// //   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// // }

// // /**
// //  * Track payment failure.
// //  */
// // export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
// //   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// // }

// // // ─────────────────────────────────────────────
// // // COVER LETTER
// // // ─────────────────────────────────────────────

// // /**
// //  * Mark cover letter as generated for a transaction.
// //  * Increments coverLetterUsedCount — respects the per-plan limit.
// //  */
// // export async function markCoverLetterGenerated(userId, transactionId) {
// //   try {
// //     const ref = doc(db, "users", userId, "transactions", transactionId);
// //     await updateDoc(ref, {
// //       coverLetterGenerated:   true,
// //       coverLetterUsedCount:   increment(1),
// //       coverLetterGeneratedAt: serverTimestamp(),
// //     });
// //     await incrementUserStat(userId, "totalCoverLetters");
// //     await trackEvent(userId, "cover_letter_generated", { transactionId });
// //     console.log("✅ Cover letter marked as generated:", transactionId);
// //   } catch (err) {
// //     console.error("❌ markCoverLetterGenerated error:", err);
// //     throw err;
// //   }
// // }

// // /**
// //  * Check if user has cover letter generation remaining.
// //  * Returns { eligible, transactionId, remaining, limit }
// //  */
// // export async function getCoverLetterEligibility(userId) {
// //   try {
// //     const snap = await getDocs(collection(db, "users", userId, "transactions"));
// //     const paid = snap.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .filter(t => t.status === "paid")
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

// //     for (const tx of paid) {
// //       const used  = tx.coverLetterUsedCount || 0;
// //       const limit = tx.coverLetterCount     || 1;
// //       if (used < limit) {
// //         return {
// //           eligible:      true,
// //           transactionId: tx.id,
// //           planId:        normalizePlanId(tx.planId),
// //           remaining:     limit - used,
// //           limit,
// //         };
// //       }
// //     }
// //     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
// //   } catch (err) {
// //     console.error("getCoverLetterEligibility error:", err);
// //     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
// //   }
// // }

// // // ─────────────────────────────────────────────
// // // GENERATED DOCUMENTS — resumes + cover letters
// // // Saved to Firestore, available for 30 days
// // // ─────────────────────────────────────────────

// // const DOCS_TTL_DAYS = 30;

// // /**
// //  * Save a generated resume to Firestore.
// //  * Stores the full resume JSON + template info for re-download.
// //  */
// // export async function saveGeneratedResume(userId, { resumeData, templateId, transactionId, planId }) {
// //   try {
// //     const expiresAt = new Date();
// //     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

// //     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), {
// //       type:          "resume",
// //       templateId:    templateId  || "classic",
// //       planId:        planId      || "ats_basic",
// //       transactionId: transactionId || null,
// //       resumeData:    resumeData  || {},         // full resume JSON
// //       createdAt:     serverTimestamp(),
// //       expiresAt:     expiresAt.toISOString(),   // ISO string for easy comparison
// //     });
// //     console.log("✅ Resume saved to Firestore:", ref.id);
// //     return ref.id;
// //   } catch (err) {
// //     console.error("saveGeneratedResume error:", err);
// //     throw err;
// //   }
// // }

// // /**
// //  * Save a generated cover letter to Firestore.
// //  * Stores full letter JSON (opening, body1, body2, closing etc).
// //  */
// // export async function saveGeneratedCoverLetter(userId, { letterData, tone, transactionId, planId }) {
// //   try {
// //     const expiresAt = new Date();
// //     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

// //     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), {
// //       type:          "cover_letter",
// //       tone:          tone          || "professional",
// //       planId:        planId        || "ats_basic",
// //       transactionId: transactionId || null,
// //       letterData:    letterData    || {},        // full letter JSON
// //       createdAt:     serverTimestamp(),
// //       expiresAt:     expiresAt.toISOString(),
// //     });
// //     console.log("✅ Cover letter saved to Firestore:", ref.id);
// //     return ref.id;
// //   } catch (err) {
// //     console.error("saveGeneratedCoverLetter error:", err);
// //     throw err;
// //   }
// // }

// // /**
// //  * Get all generated docs for a user (resumes + cover letters).
// //  * Filters out expired docs (older than 30 days).
// //  */
// // export async function getUserGeneratedDocs(userId) {
// //   try {
// //     const snap = await getDocs(collection(db, "users", userId, "generatedDocs"));
// //     const now  = new Date();
// //     return snap.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .filter(doc => {
// //         if (!doc.expiresAt) return true; // keep docs without expiry
// //         return new Date(doc.expiresAt) > now;
// //       })
// //       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
// //   } catch (err) {
// //     console.error("getUserGeneratedDocs error:", err);
// //     return [];
// //   }
// // }

// // /**
// //  * Get only generated resumes.
// //  */
// // export async function getUserGeneratedResumes(userId) {
// //   const docs = await getUserGeneratedDocs(userId);
// //   return docs.filter(d => d.type === "resume");
// // }

// // /**
// //  * Get only generated cover letters.
// //  */
// // export async function getUserGeneratedCoverLetters(userId) {
// //   const docs = await getUserGeneratedDocs(userId);
// //   return docs.filter(d => d.type === "cover_letter");
// // }

// import {
//   collection,
//   addDoc,
//   getDocs,
//   doc,
//   setDoc,
//   getDoc,
//   updateDoc,
//   serverTimestamp,
//   query,
//   where,
//   orderBy,
//   limit,
//   increment,
// } from "firebase/firestore";
// import { db } from "./firebase";
// import servicesConfig from "./servicesConfig";

// // ── Normalize legacy planIds saved as service codes ──
// const LEGACY_PLAN_MAP = {
//   "ATS_ANALYSIS":        "ats_basic",
//   "ATS_RESUME_SAMPLE":   "ats_basic",
//   "ATS_RESUME_IMPROVED": "ats_basic",
//   "DOCUMENT_SUMMARY":    "doc_pro",
//   "DOCUMENT_CHAT":       "doc_pro",
// };
// function normalizePlanId(planId) {
//   if (!planId) return "ats_basic";
//   return LEGACY_PLAN_MAP[planId] || planId;
// }

// // ─────────────────────────────────────────────
// // TRACKING HELPERS
// // ─────────────────────────────────────────────

// /**
//  * Write a tracking event to users/{uid}/events subcollection.
//  * Never throws — tracking must never break the main flow.
//  */
// async function trackEvent(userId, eventName, data = {}) {
//   if (!userId) return;
//   try {
//     await addDoc(collection(db, "users", userId, "events"), {
//       event:     eventName,
//       ...data,
//       timestamp: serverTimestamp(),
//     });
//   } catch (err) {
//     console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
//   }
// }

// /**
//  * Increment a counter on the user's top-level document.
//  * e.g. totalPayments, totalAnalyses, totalResumesGenerated
//  */
// async function incrementUserStat(userId, field, by = 1) {
//   if (!userId) return;
//   try {
//     await setDoc(
//       doc(db, "users", userId),
//       { [field]: increment(by) },
//       { merge: true }
//     );
//   } catch (err) {
//     console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
//   }
// }

// // ─────────────────────────────────────────────
// // TRANSACTIONS
// // ─────────────────────────────────────────────

// /**
//  * Save a new verified transaction after Stripe payment succeeds.
//  * Deduplicates by paymentIntentId — safe to call multiple times.
//  */
// export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
//   try {
//     // ── Deduplicate: don't create a second record for the same payment ──
//     const existing = await getDocs(
//       query(
//         collection(db, "users", userId, "transactions"),
//         where("paymentIntentId", "==", paymentIntentId)
//       )
//     );
//     if (!existing.empty) {
//       console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
//       return existing.docs[0].id;
//     }

//     // ── Default includes to planId if not provided ──
//     const serviceIncludes = includes || [planId];

//     // Get plan limits from config
//     const limits = getPlanLimits(planId);

//     // ── Snapshot plan name from config at time of purchase ──
//     const planConfig = servicesConfig.plans.find(p => p.id === planId);

//     const ref = await addDoc(collection(db, "users", userId, "transactions"), {
//       paymentIntentId,
//       planId,
//       planName:                paymentMeta.planName  || planConfig?.name  || planId,
//       // Price frozen at payment time — never re-read from config
//       amountPaid:              paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,  // cents
//       amountDisplay:           paymentMeta.amountDisplay ?? planConfig?.price         ?? "",  // "$1.99"
//       currency:                paymentMeta.currency  || "usd",
//       includes:                serviceIncludes,
//       status:                  "paid",
//       analysed:                false,
//       analysisUsedCount:       0,
//       analysisCount:           limits.analysisCount,
//       resumeGenerated:         false,
//       resumeGenCount:          limits.resumeGenCount,
//       // ── Cover letter tracking ──
//       coverLetterGenerated:    false,
//       coverLetterCount:        limits.coverLetterCount || 1,
//       coverLetterUsedCount:    0,
//       createdAt:               serverTimestamp(),
//     });

//     // ── Track payment event ──
//     await trackEvent(userId, "payment_completed", {
//       paymentIntentId,
//       planId,
//       includes:      serviceIncludes,
//       transactionId: ref.id,
//     });

//     // ── Increment user payment counter ──
//     await incrementUserStat(userId, "totalPayments");

//     // ── Update user last paid timestamp ──
//     await setDoc(
//       doc(db, "users", userId),
//       { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
//       { merge: true }
//     );

//     console.log("✅ Transaction saved:", ref.id);
//     return ref.id;

//   } catch (err) {
//     console.error("❌ saveTransaction error:", err);
//     throw err;
//   }
// }

// /**
//  * Mark a transaction as analysed (analysis complete).
//  */
// export async function markTransactionComplete(userId, transactionId) {
//   if (!userId || !transactionId) {
//     console.error("❌ markTransactionComplete: missing params");
//     return;
//   }
//   try {
//     const ref = doc(db, "users", userId, "transactions", transactionId);
//     const snap = await getDoc(ref);
//     if (!snap.exists()) {
//       console.error("❌ Transaction not found:", transactionId);
//       return;
//     }

//     const data        = snap.data();
//     const newCount    = (data.analysisUsedCount || 0) + 1;
//     // Always read limit from config — don't trust stale Firebase value
//     const planLimits  = getPlanLimits(data.planId);
//     const maxCount    = planLimits.analysisCount;
//     const analysedAll = newCount >= maxCount;

//     await setDoc(ref, {
//       status:            "paid",
//       analysed:          true,
//       completedAt:       serverTimestamp(),
//       analysisUsedCount: newCount,
//       analysisCount:     maxCount,      // patch it in case it was missing
//       resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
//       analysedAll,
//     }, { merge: true });

//     // ── Track analysis completion event ──
//     await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

//     // ── Increment user analysis counter ──
//     await incrementUserStat(userId, "totalAnalyses");

//     // ── Update user last analysed timestamp ──
//     await setDoc(
//       doc(db, "users", userId),
//       { lastAnalysisAt: serverTimestamp() },
//       { merge: true }
//     );

//     console.log("✅ Transaction marked complete:", transactionId);

//   } catch (err) {
//     console.error("❌ markTransactionComplete error:", err.message);
//     throw err;
//   }
// }

// /**
//  * Mark resume as generated for a transaction.
//  */
// export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
//   if (!userId || !transactionId) {
//     console.error("❌ markResumeGenerated: missing params");
//     return;
//   }
//   try {
//     const ref = doc(db, "users", userId, "transactions", transactionId);
//     await setDoc(ref, {
//       resumeGenerated:    true,
//       resumeGeneratedAt:  serverTimestamp(),
//       resumeTemplateId:   templateId,   // ← track which template was used
//     }, { merge: true });

//     // ── Track resume generation event with template ──
//     await trackEvent(userId, "resume_generated", {
//       transactionId,
//       templateId,
//     });

//     // ── Increment user resume counter ──
//     await incrementUserStat(userId, "totalResumesGenerated");

//     // ── Update user last resume timestamp + template ──
//     await setDoc(
//       doc(db, "users", userId),
//       {
//         lastResumeGeneratedAt: serverTimestamp(),
//         lastResumeTemplateId:  templateId,
//       },
//       { merge: true }
//     );

//     console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

//   } catch (err) {
//     console.error("❌ markResumeGenerated error:", err);
//   }
// }

// /**
//  * Get pending transaction — paid but NOT yet analysed.
//  */
// export async function getPendingTransaction(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return null;

//     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//     const pending = all
//       .filter(t => t.status === "paid" && t.analysed === false)
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     if (pending.length === 0) return null;

//     console.log("✅ Pending transaction found:", pending[0].id);
//     return pending[0];

//   } catch (err) {
//     console.error("❌ getPendingTransaction error:", err);
//     return null;
//   }
// }

// /**
//  * Get most recent completed transaction — paid AND analysed.
//  */
// export async function getCompletedTransaction(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return null;

//     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//     const completed = all
//       .filter(t => t.status === "paid" && t.analysed === true)
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     if (completed.length === 0) return null;

//     console.log("✅ Completed transaction found:", completed[0].id);
//     return completed[0];

//   } catch (err) {
//     console.error("❌ getCompletedTransaction error:", err);
//     return null;
//   }
// }

// /**
//  * Get all transactions for a user (most recent first, max 50).
//  */
// export async function getAllTransactions(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return [];
//     return snapshot.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
//       .slice(0, 50);
//   } catch (err) {
//     console.error("❌ getAllTransactions error:", err);
//     return [];
//   }
// }

// // ─────────────────────────────────────────────
// // ANALYSES
// // ─────────────────────────────────────────────

// /**
//  * Get most recent analysis for a user.
//  */
// export async function getLastAnalysis(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "analyses")
//     );
//     if (snapshot.empty) return null;

//     const sorted = snapshot.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     console.log("✅ Last analysis found");
//     return sorted[0];

//   } catch (err) {
//     console.error("❌ getLastAnalysis error:", err);
//     return null;
//   }
// }

// /**
//  * Get all analyses for a user (most recent first, max 20).
//  */
// export async function getAllAnalyses(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "analyses")
//     );
//     if (snapshot.empty) return [];

//     return snapshot.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
//       .slice(0, 20);

//   } catch (err) {
//     console.error("❌ getAllAnalyses error:", err);
//     return [];
//   }
// }

// // ─────────────────────────────────────────────
// // GENERATED RESUMES
// // ─────────────────────────────────────────────

// /**
//  * Check if user is eligible for free resume generation.
//  * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
//  */
// export async function getFreeResumeEligibility(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

//     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

//     // All paid transactions sorted newest first
//     const paidTransactions = all
//       .filter(t => t.status === "paid")
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     if (paidTransactions.length === 0) {
//       return { eligible: false, transactionId: null, planId: "ats_basic" };
//     }

//     // Always use the most recent paid plan for template access
//     // normalizePlanId handles old transactions saved with service code as planId
//     const mostRecentPlan = normalizePlanId(paidTransactions[0].planId) || "ats_basic";
//     const mostRecentIncludes = paidTransactions[0].includes || [];

//     // Find any analysed transaction where resume has NOT been generated yet
//     // Resume unlock: user must have done at least 1 analysis
//     const unusedAnalysis = all
//       .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     if (unusedAnalysis.length === 0) {
//       // No eligible transaction — but still return planId so templates show correctly
//       console.log("No unused analysis found");
//       return {
//         eligible:      false,
//         transactionId: null,
//         planId:        mostRecentPlan,
//         includes:      mostRecentIncludes,
//       };
//     }

//     // Use the most recent unused analysis transaction
//     const eligible = unusedAnalysis[0];
//     console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
//     return {
//       eligible:      true,
//       transactionId: eligible.id,
//       planId:        normalizePlanId(eligible.planId) || mostRecentPlan,
//       includes:      eligible.includes || mostRecentIncludes,
//     };

//   } catch (err) {
//     console.error("getFreeResumeEligibility error:", err);
//     return { eligible: false, transactionId: null, planId: "ats_basic" };
//   }
// }

// // ─────────────────────────────────────────────
// // PLAN LIMITS — reads from servicesConfig
// // ─────────────────────────────────────────────

// export function getPlanLimits(planId) {
//   const id   = normalizePlanId(planId);
//   const plan = servicesConfig.plans.find(p => p.id === id);
//   const limits = {
//     analysisCount:    plan?.analysisCount    ?? 2,
//     resumeGenCount:   plan?.resumeGenCount   ?? 1,
//     coverLetterCount: plan?.coverLetterCount ?? 1,
//   };
//   console.log(`📊 getPlanLimits(${planId}):`, limits);
//   return limits;
// }

// /**
//  * Get full usage status for a transaction.
//  * Used by dashboard to show analysis counter + generate button state.
//  */
// export async function getTransactionUsage(userId, transactionId) {
//   if (!userId || !transactionId) return null;
//   try {
//     const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
//     if (!snap.exists()) return null;
//     const data    = snap.data();
//     const used   = data.analysisUsedCount || 0;
//     // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
//     const limits = getPlanLimits(data.planId);
//     const max    = limits.analysisCount;  // authoritative from config
//     const resumeGenerated = data.resumeGenerated || false;
//     // Once resume is generated — NO more analyses allowed for this transaction
//     // User must pay again for new analyses
//     // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
//     const canAnalyzeAgain   = !resumeGenerated && used < max;
//     const canGenerateResume = used > 0 && !resumeGenerated;

//     // ── Cover letter usage ──
//     const coverLetterUsed      = data.coverLetterUsedCount || 0;
//     const coverLetterLimit     = data.coverLetterCount     || limits.coverLetterCount || 1;
//     const coverLetterRemaining = Math.max(0, coverLetterLimit - coverLetterUsed);

//     return {
//       transactionId,
//       planId:                data.planId,
//       analysisUsedCount:     used,
//       analysisCount:         max,
//       analysisRemaining:     resumeGenerated ? 0 : Math.max(0, max - used),
//       canAnalyzeAgain,
//       resumeGenerated,
//       resumeGenCount:        limits.resumeGenCount,
//       canGenerateResume,
//       resumeTemplateId:      data.resumeTemplateId || null,
//       coverLetterRemaining,
//       coverLetterGenerated:  data.coverLetterGenerated || false,
//       // Analyses list for selection modal
//       analyses:              [],  // populated separately
//     };
//   } catch (err) {
//     console.error("❌ getTransactionUsage error:", err);
//     return null;
//   }
// }

// /**
//  * Get all paid transaction usages for a user.
//  */
// export async function getAllTransactionUsages(userId) {
//   if (!userId) return [];
//   try {
//     const snap = await getDocs(collection(db, "users", userId, "transactions"));
//     return snap.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .filter(t => t.status === "paid" || t.status === "completed")
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
//   } catch (err) {
//     console.error("❌ getAllTransactionUsages error:", err);
//     return [];
//   }
// }

// /**
//  * Get the latest generated resume for a user.
//  */
// export async function getLatestGeneratedResume(userId) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "generatedResumes")
//     );
//     if (snapshot.empty) return null;

//     const sorted = snapshot.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     console.log("✅ Latest generated resume found");
//     return sorted[0]?.resumeData || null;

//   } catch (err) {
//     console.error("❌ getLatestGeneratedResume error:", err);
//     return null;
//   }
// }

// // ─────────────────────────────────────────────
// // SERVICE ACCESS
// // ─────────────────────────────────────────────

// /**
//  * Check if user has access to a specific service from any of their transactions.
//  * Works for single services AND bundles.
//  */
// export async function hasServiceAccess(userId, serviceCode) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return false;

//     const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//     return transactions.some(t => {
//       if (t.status !== "paid") return false;
//       // Direct service match
//       if (t.serviceCode === serviceCode) return true;
//       // Bundle match — check includes array
//       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
//       return false;
//     });
//   } catch (err) {
//     console.error("❌ hasServiceAccess error:", err);
//     return false;
//   }
// }

// /**
//  * Get pending transaction for a specific service.
//  * Works for both direct service and bundle.
//  */
// export async function getPendingTransactionForService(userId, serviceCode) {
//   try {
//     const snapshot = await getDocs(
//       collection(db, "users", userId, "transactions")
//     );
//     if (snapshot.empty) return null;

//     const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//     const pending = all.filter(t => {
//       if (t.status !== "paid" || t.analysed !== false) return false;
//       if (t.serviceCode === serviceCode) return true;
//       if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
//       return false;
//     }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     return pending[0] || null;
//   } catch (err) {
//     console.error("❌ getPendingTransactionForService error:", err);
//     return null;
//   }
// }

// // ─────────────────────────────────────────────
// // SUPPORT TICKETS
// // ─────────────────────────────────────────────

// /**
//  * Save a support ticket.
//  */
// export async function saveSupportTicket(userId, ticketData) {
//   try {
//     const ref = await addDoc(collection(db, "supportTickets"), {
//       userId:    userId || null,
//       firstName: ticketData.firstName,
//       lastName:  ticketData.lastName,
//       email:     ticketData.email,
//       topic:     ticketData.topic,
//       message:   ticketData.message,
//       status:    "open",
//       createdAt: serverTimestamp(),
//       updatedAt: serverTimestamp(),
//       date:      new Date().toISOString().split("T")[0],
//     });

//     // ── Track support ticket event ──
//     if (userId) {
//       await trackEvent(userId, "support_ticket_created", {
//         ticketId: ref.id,
//         topic:    ticketData.topic,
//       });
//     }

//     console.log("✅ Support ticket saved:", ref.id);
//     return ref.id;

//   } catch (err) {
//     console.error("❌ saveSupportTicket error:", err);
//     return null;
//   }
// }

// /**
//  * Get all support tickets for a user.
//  * Uses a proper Firestore query instead of fetching all and filtering client-side.
//  */
// export async function getUserSupportTickets(userId) {
//   try {
//     const q = query(
//       collection(db, "supportTickets"),
//       where("userId", "==", userId),
//       orderBy("createdAt", "desc"),
//       limit(50)
//     );
//     const snapshot = await getDocs(q);
//     if (snapshot.empty) return [];
//     return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
//   } catch (err) {
//     console.error("❌ getUserSupportTickets error:", err);
//     return [];
//   }
// }

// // ─────────────────────────────────────────────
// // SESSION / PAGE TRACKING
// // ─────────────────────────────────────────────

// /**
//  * Track a page view or dashboard step visit.
//  * Call this from key screens: dashboard intro, upload, results, etc.
//  */
// export async function trackPageView(userId, page, extra = {}) {
//   await trackEvent(userId, "page_view", { page, ...extra });
// }

// /**
//  * Track a user action (button clicks, downloads, etc.)
//  */
// export async function trackUserAction(userId, action, extra = {}) {
//   await trackEvent(userId, action, extra);
// }

// /**
//  * Track analysis start — called when user clicks "Analyze My Resume".
//  */
// export async function trackAnalysisStart(userId, transactionId) {
//   await trackEvent(userId, "analysis_started", { transactionId });
//   await setDoc(
//     doc(db, "users", userId),
//     { lastActivityAt: serverTimestamp() },
//     { merge: true }
//   );
// }

// /**
//  * Track analysis failure so you can investigate in Firebase console.
//  */
// export async function trackAnalysisError(userId, transactionId, errorMessage) {
//   await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
// }

// /**
//  * Track report download.
//  */
// export async function trackReportDownload(userId, analysisId) {
//   await trackEvent(userId, "report_downloaded", { analysisId });
//   await incrementUserStat(userId, "totalDownloads");
// }

// /**
//  * Track service card click on dashboard intro.
//  */
// export async function trackServiceClick(userId, serviceCode) {
//   await trackEvent(userId, "service_selected", { serviceCode });
// }

// /**
//  * Track payment modal opened.
//  */
// export async function trackPaymentModalOpened(userId, serviceCode) {
//   await trackEvent(userId, "payment_modal_opened", { serviceCode });
// }

// /**
//  * Track payment failure.
//  */
// export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
//   await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
// }

// // ─────────────────────────────────────────────
// // COVER LETTER
// // ─────────────────────────────────────────────

// /**
//  * Mark cover letter as generated for a transaction.
//  * Increments coverLetterUsedCount — respects the per-plan limit.
//  */
// export async function markCoverLetterGenerated(userId, transactionId) {
//   try {
//     const ref = doc(db, "users", userId, "transactions", transactionId);
//     await updateDoc(ref, {
//       coverLetterGenerated:   true,
//       coverLetterUsedCount:   increment(1),
//       coverLetterGeneratedAt: serverTimestamp(),
//     });
//     await incrementUserStat(userId, "totalCoverLetters");
//     await trackEvent(userId, "cover_letter_generated", { transactionId });
//     console.log("✅ Cover letter marked as generated:", transactionId);
//   } catch (err) {
//     console.error("❌ markCoverLetterGenerated error:", err);
//     throw err;
//   }
// }

// /**
//  * Check if user has cover letter generation remaining.
//  * Returns { eligible, transactionId, remaining, limit }
//  */
// export async function getCoverLetterEligibility(userId) {
//   try {
//     const snap = await getDocs(collection(db, "users", userId, "transactions"));
//     const paid = snap.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .filter(t => t.status === "paid")
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

//     for (const tx of paid) {
//       const used  = tx.coverLetterUsedCount || 0;
//       const limit = tx.coverLetterCount     || 1;
//       if (used < limit) {
//         return {
//           eligible:      true,
//           transactionId: tx.id,
//           planId:        normalizePlanId(tx.planId),
//           remaining:     limit - used,
//           limit,
//         };
//       }
//     }
//     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
//   } catch (err) {
//     console.error("getCoverLetterEligibility error:", err);
//     return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
//   }
// }

// // ─────────────────────────────────────────────
// // GENERATED DOCUMENTS — resumes + cover letters
// // Saved to Firestore, available for 30 days
// // ─────────────────────────────────────────────

// const DOCS_TTL_DAYS = 30;

// /**
//  * Save a generated resume to Firestore.
//  * Stores the full resume JSON + template info for re-download.
//  */
// export async function saveGeneratedResume(userId, { resumeData, templateId, transactionId, planId }) {
//   try {
//     if (!userId) throw new Error("No userId provided to saveGeneratedResume");
//     if (!resumeData) throw new Error("No resumeData provided to saveGeneratedResume");

//     const expiresAt = new Date();
//     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

//     const docData = {
//       type:          "resume",
//       templateId:    templateId    || "classic",
//       planId:        planId        || "ats_basic",
//       transactionId: transactionId || null,
//       resumeData:    resumeData,
//       createdAt:     serverTimestamp(),
//       expiresAt:     expiresAt.toISOString(),
//     };

//     console.log("💾 Saving resume to Firestore for user:", userId, "template:", templateId);
//     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), docData);
//     console.log("✅ Resume saved to generatedDocs:", ref.id);
//     return ref.id;
//   } catch (err) {
//     console.error("❌ saveGeneratedResume FAILED:", err.message, err);
//     throw err;
//   }
// }

// /**
//  * Save a generated cover letter to Firestore.
//  * Stores full letter JSON (opening, body1, body2, closing etc).
//  */
// export async function saveGeneratedCoverLetter(userId, { letterData, tone, transactionId, planId }) {
//   try {
//     if (!userId) throw new Error("No userId provided to saveGeneratedCoverLetter");
//     if (!letterData) throw new Error("No letterData provided to saveGeneratedCoverLetter");

//     const expiresAt = new Date();
//     expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

//     const docData = {
//       type:          "cover_letter",
//       tone:          tone          || "professional",
//       planId:        planId        || "ats_basic",
//       transactionId: transactionId || null,
//       letterData:    letterData,
//       createdAt:     serverTimestamp(),
//       expiresAt:     expiresAt.toISOString(),
//     };

//     console.log("💾 Saving cover letter to Firestore for user:", userId, "tone:", tone);
//     const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), docData);
//     console.log("✅ Cover letter saved to generatedDocs:", ref.id);
//     return ref.id;
//   } catch (err) {
//     console.error("❌ saveGeneratedCoverLetter FAILED:", err.message, err);
//     throw err;
//   }
// }

// /**
//  * Get all generated docs for a user (resumes + cover letters).
//  * Filters out expired docs (older than 30 days).
//  */
// export async function getUserGeneratedDocs(userId) {
//   try {
//     const snap = await getDocs(collection(db, "users", userId, "generatedDocs"));
//     const now  = new Date();
//     return snap.docs
//       .map(d => ({ id: d.id, ...d.data() }))
//       .filter(doc => {
//         if (!doc.expiresAt) return true; // keep docs without expiry
//         return new Date(doc.expiresAt) > now;
//       })
//       .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
//   } catch (err) {
//     console.error("getUserGeneratedDocs error:", err);
//     return [];
//   }
// }

// /**
//  * Get only generated resumes.
//  */
// export async function getUserGeneratedResumes(userId) {
//   const docs = await getUserGeneratedDocs(userId);
//   return docs.filter(d => d.type === "resume");
// }

// /**
//  * Get only generated cover letters.
//  */
// export async function getUserGeneratedCoverLetters(userId) {
//   const docs = await getUserGeneratedDocs(userId);
//   return docs.filter(d => d.type === "cover_letter");
// }

import {
  collection,
  addDoc,
  getDocs,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  serverTimestamp,
  query,
  where,
  orderBy,
  limit,
  increment,
} from "firebase/firestore";
import { db } from "./firebase";
import servicesConfig from "./servicesConfig";

// ── Normalize legacy planIds saved as service codes ──
const LEGACY_PLAN_MAP = {
  "ATS_ANALYSIS":        "ats_basic",
  "ATS_RESUME_SAMPLE":   "ats_basic",
  "ATS_RESUME_IMPROVED": "ats_basic",
  "DOCUMENT_SUMMARY":    "doc_pro",
  "DOCUMENT_CHAT":       "doc_pro",
};
function normalizePlanId(planId) {
  if (!planId) return "ats_basic";
  return LEGACY_PLAN_MAP[planId] || planId;
}

// ─────────────────────────────────────────────
// TRACKING HELPERS
// ─────────────────────────────────────────────

/**
 * Write a tracking event to users/{uid}/events subcollection.
 * Never throws — tracking must never break the main flow.
 */
async function trackEvent(userId, eventName, data = {}) {
  if (!userId) return;
  try {
    await addDoc(collection(db, "users", userId, "events"), {
      event:     eventName,
      ...data,
      timestamp: serverTimestamp(),
    });
  } catch (err) {
    console.warn(`⚠️ trackEvent(${eventName}) failed silently:`, err.message);
  }
}

/**
 * Increment a counter on the user's top-level document.
 * e.g. totalPayments, totalAnalyses, totalResumesGenerated
 */
async function incrementUserStat(userId, field, by = 1) {
  if (!userId) return;
  try {
    await setDoc(
      doc(db, "users", userId),
      { [field]: increment(by) },
      { merge: true }
    );
  } catch (err) {
    console.warn(`⚠️ incrementUserStat(${field}) failed silently:`, err.message);
  }
}

// ─────────────────────────────────────────────
// TRANSACTIONS
// ─────────────────────────────────────────────

/**
 * Save a new verified transaction after Stripe payment succeeds.
 * Deduplicates by paymentIntentId — safe to call multiple times.
 */
export async function saveTransaction(userId, paymentIntentId, planId = "ats_basic", includes = null, paymentMeta = {}) {
  try {
    // ── Deduplicate: don't create a second record for the same payment ──
    const existing = await getDocs(
      query(
        collection(db, "users", userId, "transactions"),
        where("paymentIntentId", "==", paymentIntentId)
      )
    );
    if (!existing.empty) {
      console.log("ℹ️ Transaction already exists, skipping duplicate:", existing.docs[0].id);
      return existing.docs[0].id;
    }

    // ── Default includes to planId if not provided ──
    const serviceIncludes = includes || [planId];

    // Get plan limits from config
    const limits = getPlanLimits(planId);

    // ── Snapshot plan name from config at time of purchase ──
    const planConfig = servicesConfig.plans.find(p => p.id === planId);

    const ref = await addDoc(collection(db, "users", userId, "transactions"), {
      paymentIntentId,
      planId,
      planName:                paymentMeta.planName  || planConfig?.name  || planId,
      amountPaid:              paymentMeta.amountPaid    ?? planConfig?.priceInCents ?? 0,
      amountDisplay:           paymentMeta.amountDisplay ?? planConfig?.price         ?? "",
      currency:                paymentMeta.currency  || "usd",
      includes:                serviceIncludes,
      status:                  "paid",
      analysed:                false,
      analysisUsedCount:       0,
      analysisCount:           limits.analysisCount,
      resumeGenerated:         false,
      resumeGenCount:          limits.resumeGenCount,
      // ── NEW: scratch resume tracking ──
      scratchResumeCount:      planConfig?.scratchResumeCount ?? 1,
      scratchResumeUsedCount:  0,
      scratchResumeGenerated:  false,
      // ── Cover letter tracking ──
      coverLetterGenerated:    false,
      coverLetterCount:        limits.coverLetterCount || 1,
      coverLetterUsedCount:    0,
      createdAt:               serverTimestamp(),
    });

    // ── Track payment event ──
    await trackEvent(userId, "payment_completed", {
      paymentIntentId,
      planId,
      includes:      serviceIncludes,
      transactionId: ref.id,
    });

    // ── Increment user payment counter ──
    await incrementUserStat(userId, "totalPayments");

    // ── Update user last paid timestamp ──
    await setDoc(
      doc(db, "users", userId),
      { lastPaymentAt: serverTimestamp(), lastPlanId: planId },
      { merge: true }
    );

    console.log("✅ Transaction saved:", ref.id);
    return ref.id;

  } catch (err) {
    console.error("❌ saveTransaction error:", err);
    throw err;
  }
}

/**
 * Mark a transaction as analysed (analysis complete).
 */
export async function markTransactionComplete(userId, transactionId) {
  if (!userId || !transactionId) {
    console.error("❌ markTransactionComplete: missing params");
    return;
  }
  try {
    const ref = doc(db, "users", userId, "transactions", transactionId);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      console.error("❌ Transaction not found:", transactionId);
      return;
    }

    const data        = snap.data();
    const newCount    = (data.analysisUsedCount || 0) + 1;
    // Always read limit from config — don't trust stale Firebase value
    const planLimits  = getPlanLimits(data.planId);
    const maxCount    = planLimits.analysisCount;
    const analysedAll = newCount >= maxCount;

    await setDoc(ref, {
      status:            "paid",
      analysed:          true,
      completedAt:       serverTimestamp(),
      analysisUsedCount: newCount,
      analysisCount:     maxCount,      // patch it in case it was missing
      resumeGenCount:    data.resumeGenCount || planLimits.resumeGenCount,
      analysedAll,
    }, { merge: true });

    // ── Track analysis completion event ──
    await trackEvent(userId, "analysis_completed", { transactionId, analysisUsedCount: newCount, analysedAll });

    // ── Increment user analysis counter ──
    await incrementUserStat(userId, "totalAnalyses");

    // ── Update user last analysed timestamp ──
    await setDoc(
      doc(db, "users", userId),
      { lastAnalysisAt: serverTimestamp() },
      { merge: true }
    );

    console.log("✅ Transaction marked complete:", transactionId);

  } catch (err) {
    console.error("❌ markTransactionComplete error:", err.message);
    throw err;
  }
}

/**
 * Mark resume as generated for a transaction.
 */
export async function markResumeGenerated(userId, transactionId, templateId = "classic") {
  if (!userId || !transactionId) {
    console.error("❌ markResumeGenerated: missing params");
    return;
  }
  try {
    const ref = doc(db, "users", userId, "transactions", transactionId);
    await setDoc(ref, {
      resumeGenerated:    true,
      resumeGeneratedAt:  serverTimestamp(),
      resumeTemplateId:   templateId,   // ← track which template was used
    }, { merge: true });

    // ── Track resume generation event with template ──
    await trackEvent(userId, "resume_generated", {
      transactionId,
      templateId,
    });

    // ── Increment user resume counter ──
    await incrementUserStat(userId, "totalResumesGenerated");

    // ── Update user last resume timestamp + template ──
    await setDoc(
      doc(db, "users", userId),
      {
        lastResumeGeneratedAt: serverTimestamp(),
        lastResumeTemplateId:  templateId,
      },
      { merge: true }
    );

    console.log(`✅ Resume generated with template [${templateId}]:`, transactionId);

  } catch (err) {
    console.error("❌ markResumeGenerated error:", err);
  }
}

/**
 * Get pending transaction — paid but NOT yet analysed.
 */
export async function getPendingTransaction(userId) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "transactions")
    );
    if (snapshot.empty) return null;

    const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    const pending = all
      .filter(t => t.status === "paid" && t.analysed === false)
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

    if (pending.length === 0) return null;

    console.log("✅ Pending transaction found:", pending[0].id);
    return pending[0];

  } catch (err) {
    console.error("❌ getPendingTransaction error:", err);
    return null;
  }
}

/**
 * Get most recent completed transaction — paid AND analysed.
 */
export async function getCompletedTransaction(userId) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "transactions")
    );
    if (snapshot.empty) return null;

    const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    const completed = all
      .filter(t => t.status === "paid" && t.analysed === true)
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

    if (completed.length === 0) return null;

    console.log("✅ Completed transaction found:", completed[0].id);
    return completed[0];

  } catch (err) {
    console.error("❌ getCompletedTransaction error:", err);
    return null;
  }
}

/**
 * Get all transactions for a user (most recent first, max 50).
 */
export async function getAllTransactions(userId) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "transactions")
    );
    if (snapshot.empty) return [];
    return snapshot.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
      .slice(0, 50);
  } catch (err) {
    console.error("❌ getAllTransactions error:", err);
    return [];
  }
}

// ─────────────────────────────────────────────
// ANALYSES
// ─────────────────────────────────────────────

/**
 * Get most recent analysis for a user.
 */
export async function getLastAnalysis(userId) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "analyses")
    );
    if (snapshot.empty) return null;

    const sorted = snapshot.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

    console.log("✅ Last analysis found");
    return sorted[0];

  } catch (err) {
    console.error("❌ getLastAnalysis error:", err);
    return null;
  }
}

/**
 * Get all analyses for a user (most recent first, max 20).
 */
export async function getAllAnalyses(userId) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "analyses")
    );
    if (snapshot.empty) return [];

    return snapshot.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
      .slice(0, 20);

  } catch (err) {
    console.error("❌ getAllAnalyses error:", err);
    return [];
  }
}

// ─────────────────────────────────────────────
// GENERATED RESUMES
// ─────────────────────────────────────────────

/**
 * Check if user is eligible for free resume generation.
 * Eligible = has a completed analysis on a transaction where resumeGenerated is false.
 */
export async function getFreeResumeEligibility(userId) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "transactions")
    );
    if (snapshot.empty) return { eligible: false, transactionId: null, planId: "ats_basic" };

    const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

    // All paid transactions sorted newest first
    const paidTransactions = all
      .filter(t => t.status === "paid")
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

    if (paidTransactions.length === 0) {
      return { eligible: false, transactionId: null, planId: "ats_basic" };
    }

    // Always use the most recent paid plan for template access
    // normalizePlanId handles old transactions saved with service code as planId
    const mostRecentPlan = normalizePlanId(paidTransactions[0].planId) || "ats_basic";
    const mostRecentIncludes = paidTransactions[0].includes || [];

    // Find any analysed transaction where resume has NOT been generated yet
    // Resume unlock: user must have done at least 1 analysis
    const unusedAnalysis = all
      .filter(t => t.analysed === true && t.resumeGenerated !== true && t.status !== "generated")
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

    if (unusedAnalysis.length === 0) {
      // No eligible transaction — but still return planId so templates show correctly
      console.log("No unused analysis found");
      return {
        eligible:      false,
        transactionId: null,
        planId:        mostRecentPlan,
        includes:      mostRecentIncludes,
      };
    }

    // Use the most recent unused analysis transaction
    const eligible = unusedAnalysis[0];
    console.log("Eligible for resume generation:", eligible.id, "plan:", eligible.planId || mostRecentPlan);
    return {
      eligible:      true,
      transactionId: eligible.id,
      planId:        normalizePlanId(eligible.planId) || mostRecentPlan,
      includes:      eligible.includes || mostRecentIncludes,
    };

  } catch (err) {
    console.error("getFreeResumeEligibility error:", err);
    return { eligible: false, transactionId: null, planId: "ats_basic" };
  }
}

// ─────────────────────────────────────────────
// PLAN LIMITS — reads from servicesConfig
// ─────────────────────────────────────────────

export function getPlanLimits(planId) {
  const id   = normalizePlanId(planId);
  const plan = servicesConfig.plans.find(p => p.id === id);
  const limits = {
    analysisCount:    plan?.analysisCount    ?? 2,
    resumeGenCount:   plan?.resumeGenCount   ?? 1,
    coverLetterCount: plan?.coverLetterCount ?? 1,
  };
  console.log(`📊 getPlanLimits(${planId}):`, limits);
  return limits;
}

/**
 * Get full usage status for a transaction.
 * Used by dashboard to show analysis counter + generate button state.
 */
export async function getTransactionUsage(userId, transactionId) {
  if (!userId || !transactionId) return null;
  try {
    const snap = await getDoc(doc(db, "users", userId, "transactions", transactionId));
    if (!snap.exists()) return null;
    const data    = snap.data();
    const used   = data.analysisUsedCount || 0;
    // ALWAYS read limits from servicesConfig — Firebase value may be stale/missing
    const limits = getPlanLimits(data.planId);
    const max    = limits.analysisCount;  // authoritative from config
    const resumeGenerated = data.resumeGenerated || false;
    // Once resume is generated — NO more analyses allowed for this transaction
    // User must pay again for new analyses
    // canAnalyzeAgain: true if resume not yet generated AND analyses remaining
    const canAnalyzeAgain   = !resumeGenerated && used < max;
    const canGenerateResume = used > 0 && !resumeGenerated;

    // ── Cover letter usage ──
    const coverLetterUsed      = data.coverLetterUsedCount || 0;
    const coverLetterLimit     = data.coverLetterCount     || limits.coverLetterCount || 1;
    const coverLetterRemaining = Math.max(0, coverLetterLimit - coverLetterUsed);

    return {
      transactionId,
      planId:                data.planId,
      analysisUsedCount:     used,
      analysisCount:         max,
      analysisRemaining:     resumeGenerated ? 0 : Math.max(0, max - used),
      canAnalyzeAgain,
      resumeGenerated,
      resumeGenCount:        limits.resumeGenCount,
      canGenerateResume,
      resumeTemplateId:      data.resumeTemplateId || null,
      coverLetterRemaining,
      coverLetterGenerated:  data.coverLetterGenerated || false,
      // Analyses list for selection modal
      analyses:              [],  // populated separately
    };
  } catch (err) {
    console.error("❌ getTransactionUsage error:", err);
    return null;
  }
}

/**
 * Get all paid transaction usages for a user.
 */
export async function getAllTransactionUsages(userId) {
  if (!userId) return [];
  try {
    const snap = await getDocs(collection(db, "users", userId, "transactions"));
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(t => t.status === "paid" || t.status === "completed")
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
  } catch (err) {
    console.error("❌ getAllTransactionUsages error:", err);
    return [];
  }
}

/**
 * Get the latest generated resume for a user.
 */
export async function getLatestGeneratedResume(userId) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "generatedResumes")
    );
    if (snapshot.empty) return null;

    const sorted = snapshot.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

    console.log("✅ Latest generated resume found");
    return sorted[0]?.resumeData || null;

  } catch (err) {
    console.error("❌ getLatestGeneratedResume error:", err);
    return null;
  }
}

// ─────────────────────────────────────────────
// SERVICE ACCESS
// ─────────────────────────────────────────────

/**
 * Check if user has access to a specific service from any of their transactions.
 * Works for single services AND bundles.
 */
export async function hasServiceAccess(userId, serviceCode) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "transactions")
    );
    if (snapshot.empty) return false;

    const transactions = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    return transactions.some(t => {
      if (t.status !== "paid") return false;
      // Direct service match
      if (t.serviceCode === serviceCode) return true;
      // Bundle match — check includes array
      if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
      return false;
    });
  } catch (err) {
    console.error("❌ hasServiceAccess error:", err);
    return false;
  }
}

/**
 * Get pending transaction for a specific service.
 * Works for both direct service and bundle.
 */
export async function getPendingTransactionForService(userId, serviceCode) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "transactions")
    );
    if (snapshot.empty) return null;

    const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    const pending = all.filter(t => {
      if (t.status !== "paid" || t.analysed !== false) return false;
      if (t.serviceCode === serviceCode) return true;
      if (Array.isArray(t.includes) && t.includes.includes(serviceCode)) return true;
      return false;
    }).sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

    return pending[0] || null;
  } catch (err) {
    console.error("❌ getPendingTransactionForService error:", err);
    return null;
  }
}

// ─────────────────────────────────────────────
// SUPPORT TICKETS
// ─────────────────────────────────────────────

/**
 * Save a support ticket.
 */
export async function saveSupportTicket(userId, ticketData) {
  try {
    const ref = await addDoc(collection(db, "supportTickets"), {
      userId:    userId || null,
      firstName: ticketData.firstName,
      lastName:  ticketData.lastName,
      email:     ticketData.email,
      topic:     ticketData.topic,
      message:   ticketData.message,
      status:    "open",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      date:      new Date().toISOString().split("T")[0],
    });

    // ── Track support ticket event ──
    if (userId) {
      await trackEvent(userId, "support_ticket_created", {
        ticketId: ref.id,
        topic:    ticketData.topic,
      });
    }

    console.log("✅ Support ticket saved:", ref.id);
    return ref.id;

  } catch (err) {
    console.error("❌ saveSupportTicket error:", err);
    return null;
  }
}

/**
 * Get all support tickets for a user.
 * Uses a proper Firestore query instead of fetching all and filtering client-side.
 */
export async function getUserSupportTickets(userId) {
  try {
    const q = query(
      collection(db, "supportTickets"),
      where("userId", "==", userId),
      orderBy("createdAt", "desc"),
      limit(50)
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) return [];
    return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (err) {
    console.error("❌ getUserSupportTickets error:", err);
    return [];
  }
}

// ─────────────────────────────────────────────
// SESSION / PAGE TRACKING
// ─────────────────────────────────────────────

/**
 * Track a page view or dashboard step visit.
 * Call this from key screens: dashboard intro, upload, results, etc.
 */
export async function trackPageView(userId, page, extra = {}) {
  await trackEvent(userId, "page_view", { page, ...extra });
}

/**
 * Track a user action (button clicks, downloads, etc.)
 */
export async function trackUserAction(userId, action, extra = {}) {
  await trackEvent(userId, action, extra);
}

/**
 * Track analysis start — called when user clicks "Analyze My Resume".
 */
export async function trackAnalysisStart(userId, transactionId) {
  await trackEvent(userId, "analysis_started", { transactionId });
  await setDoc(
    doc(db, "users", userId),
    { lastActivityAt: serverTimestamp() },
    { merge: true }
  );
}

/**
 * Track analysis failure so you can investigate in Firebase console.
 */
export async function trackAnalysisError(userId, transactionId, errorMessage) {
  await trackEvent(userId, "analysis_failed", { transactionId, errorMessage });
}

/**
 * Track report download.
 */
export async function trackReportDownload(userId, analysisId) {
  await trackEvent(userId, "report_downloaded", { analysisId });
  await incrementUserStat(userId, "totalDownloads");
}

/**
 * Track service card click on dashboard intro.
 */
export async function trackServiceClick(userId, serviceCode) {
  await trackEvent(userId, "service_selected", { serviceCode });
}

/**
 * Track payment modal opened.
 */
export async function trackPaymentModalOpened(userId, serviceCode) {
  await trackEvent(userId, "payment_modal_opened", { serviceCode });
}

/**
 * Track payment failure.
 */
export async function trackPaymentFailed(userId, serviceCode, errorMessage) {
  await trackEvent(userId, "payment_failed", { serviceCode, errorMessage });
}

// ─────────────────────────────────────────────
// COVER LETTER
// ─────────────────────────────────────────────

/**
 * Mark cover letter as generated for a transaction.
 * Increments coverLetterUsedCount — respects the per-plan limit.
 */
export async function markCoverLetterGenerated(userId, transactionId) {
  try {
    const ref = doc(db, "users", userId, "transactions", transactionId);
    await updateDoc(ref, {
      coverLetterGenerated:   true,
      coverLetterUsedCount:   increment(1),
      coverLetterGeneratedAt: serverTimestamp(),
    });
    await incrementUserStat(userId, "totalCoverLetters");
    await trackEvent(userId, "cover_letter_generated", { transactionId });
    console.log("✅ Cover letter marked as generated:", transactionId);
  } catch (err) {
    console.error("❌ markCoverLetterGenerated error:", err);
    throw err;
  }
}

/**
 * Check if user has cover letter generation remaining.
 * Returns { eligible, transactionId, remaining, limit }
 */
export async function getCoverLetterEligibility(userId) {
  try {
    const snap = await getDocs(collection(db, "users", userId, "transactions"));
    const paid = snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(t => t.status === "paid")
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

    for (const tx of paid) {
      const used  = tx.coverLetterUsedCount || 0;
      const limit = tx.coverLetterCount     || 1;
      if (used < limit) {
        return {
          eligible:      true,
          transactionId: tx.id,
          planId:        normalizePlanId(tx.planId),
          remaining:     limit - used,
          limit,
        };
      }
    }
    return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
  } catch (err) {
    console.error("getCoverLetterEligibility error:", err);
    return { eligible: false, transactionId: null, remaining: 0, limit: 1 };
  }
}

// ─────────────────────────────────────────────
// GENERATED DOCUMENTS — resumes + cover letters
// Saved to Firestore, available for 30 days
// ─────────────────────────────────────────────

const DOCS_TTL_DAYS = 30;

/**
 * Save a generated resume to Firestore.
 * Stores the full resume JSON + template info for re-download.
 */
export async function saveGeneratedResume(userId, { resumeData, templateId, transactionId, planId, mode = "improved", domain = null }) {
  try {
    if (!userId)     throw new Error("No userId provided to saveGeneratedResume");
    if (!resumeData) throw new Error("No resumeData provided to saveGeneratedResume");

    const expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

    const docData = {
      type:          "resume",
      mode:          mode          || "improved",   // "improved" | "scratch"
      templateId:    templateId    || "classic",
      planId:        planId        || "ats_basic",
      transactionId: transactionId || null,
      domain:        domain        || null,          // scratch resumes carry domain
      resumeData,
      createdAt:     serverTimestamp(),
      expiresAt:     expiresAt.toISOString(),
    };

    console.log(`💾 Saving resume | mode=${mode} | template=${templateId} | user=${userId}`);
    const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), docData);
    console.log("✅ Resume saved to generatedDocs:", ref.id);

    // Track the event
    await trackEvent(userId, "resume_saved", { mode, templateId, transactionId, domain });

    return ref.id;
  } catch (err) {
    console.error("❌ saveGeneratedResume FAILED:", err.message, err);
    throw err;
  }
}

/**
 * Save a generated cover letter to Firestore.
 * Stores full letter JSON (opening, body1, body2, closing etc).
 */
export async function saveGeneratedCoverLetter(userId, { letterData, tone, transactionId, planId }) {
  try {
    if (!userId) throw new Error("No userId provided to saveGeneratedCoverLetter");
    if (!letterData) throw new Error("No letterData provided to saveGeneratedCoverLetter");

    const expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + DOCS_TTL_DAYS);

    const docData = {
      type:          "cover_letter",
      tone:          tone          || "professional",
      planId:        planId        || "ats_basic",
      transactionId: transactionId || null,
      letterData:    letterData,
      createdAt:     serverTimestamp(),
      expiresAt:     expiresAt.toISOString(),
    };

    console.log("💾 Saving cover letter to Firestore for user:", userId, "tone:", tone);
    const ref = await addDoc(collection(db, "users", userId, "generatedDocs"), docData);
    console.log("✅ Cover letter saved to generatedDocs:", ref.id);
    return ref.id;
  } catch (err) {
    console.error("❌ saveGeneratedCoverLetter FAILED:", err.message, err);
    throw err;
  }
}

/**
 * Get all generated docs for a user (resumes + cover letters).
 * Filters out expired docs (older than 30 days).
 */
export async function getUserGeneratedDocs(userId) {
  try {
    const snap = await getDocs(collection(db, "users", userId, "generatedDocs"));
    const now  = new Date();
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(doc => {
        if (!doc.expiresAt) return true; // keep docs without expiry
        return new Date(doc.expiresAt) > now;
      })
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
  } catch (err) {
    console.error("getUserGeneratedDocs error:", err);
    return [];
  }
}

/**
 * Get only generated resumes.
 */
export async function getUserGeneratedResumes(userId) {
  const docs = await getUserGeneratedDocs(userId);
  return docs.filter(d => d.type === "resume");
}

/**
 * Get only generated cover letters.
 */
export async function getUserGeneratedCoverLetters(userId) {
  const docs = await getUserGeneratedDocs(userId);
  return docs.filter(d => d.type === "cover_letter");
}

// Check if user can generate a scratch resume for this transaction
export async function getScratchResumeEligibility(userId) {
  if (!userId) return { eligible: false, transactionId: null, used: 0, allowed: 1 };
  try {
    const snapshot = await getDocs(collection(db, "users", userId, "transactions"));
    const paid = snapshot.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(t => t.status === "paid")
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

    if (paid.length === 0) {
      return { eligible: false, transactionId: null, used: 0, allowed: 1, reason: "no_paid_plan" };
    }

    // Walk transactions newest-first — find one that still has scratch resume quota
    for (const tx of paid) {
      const planId  = normalizePlanId(tx.planId || "ats_basic");
      const plan    = servicesConfig.plans.find(p => p.id === planId);

      // Allowed count: prefer what was saved on the transaction at purchase time
      // Fall back to live config (handles transactions created before this fix)
      const allowed = tx.scratchResumeCount ?? plan?.scratchResumeCount ?? 1;

      // Used count: prefer the counter saved on the transaction (fast, no extra read)
      // Fall back to counting generatedDocs (for transactions created before this fix)
      let used = tx.scratchResumeUsedCount ?? null;

      if (used === null) {
        // Legacy fallback — count from generatedDocs
        const docsSnap = await getDocs(collection(db, "users", userId, "generatedDocs"));
        used = docsSnap.docs
          .map(d => d.data())
          .filter(d =>
            d.type === "resume" &&
            d.mode === "scratch" &&
            d.transactionId === tx.id
          ).length;
      }

      console.log(`📊 Scratch eligibility | tx=${tx.id} | used=${used}/${allowed} | plan=${planId}`);
      console.log(used, allowed)

      if (used < allowed) {
        return {
          eligible:      true,
          transactionId: tx.id,
          planId,
          used,
          allowed,
          remaining:     allowed - used,
        };
      }
    }

    // All transactions exhausted
    return {
      eligible:      false,
      transactionId: null,
      used:          0,
      allowed:       1,
      reason:        "quota_exhausted",
    };

  } catch (err) {
    console.error("getScratchResumeEligibility error:", err);
    return { eligible: false, transactionId: null, used: 0, allowed: 1, reason: "error" };
  }
}

// Mark a scratch resume as generated
export async function markScratchResumeGenerated(userId, transactionId, templateId) {
  if (!userId || !transactionId) {
    console.error("markScratchResumeGenerated: missing userId or transactionId");
    return;
  }
  try {
    const txRef = doc(db, "users", userId, "transactions", transactionId);

    // Atomically increment the used counter + set flags
    await updateDoc(txRef, {
      scratchResumeUsedCount:  increment(1),
      scratchResumeGenerated:  true,
      scratchResumeGeneratedAt: serverTimestamp(),
      scratchResumeTemplateId: templateId || "classic",
    });

    // Track event + increment global stat
    await trackEvent(userId, "scratch_resume_generated", { transactionId, templateId });
    await incrementUserStat(userId, "totalScratchResumesGenerated");

    console.log(`✅ Scratch resume marked | tx=${transactionId} | template=${templateId}`);
  } catch (err) {
    console.error("markScratchResumeGenerated error:", err);
    // Don't throw — the resume was already saved, tracking failure shouldn't break UX
  }
}